{
  "accept_invite": {
    "back_to_home": "Back to home",
    "choose_password": "Choose a password",
    "heading": "Accept invitation",
    "loading": "Loading",
    "save_button": "Accept invitation",
    "text": "You have been invited to join a workspace. Please choose a password to continue."
  },
  "automation": {
    "audience": "This audience currently has one active employee | This audience currently has {count} active employees",
    "automation_updated": "Automation updated",
    "delete": {
      "are_you_sure": "Are you sure you want to delete this sequence? This action cannot be undone.",
      "automation_deleted": "Sequence deleted",
      "button": "Delete"
    },
    "details": {
      "heading": "Details",
      "text": "Automation details"
    },
    "edit": {
      "subtitle": "Build your automation flow by adding actions",
      "title": "Actions"
    },
    "edit_automation": "Edit settings",
    "employee_already_enrolled": "This employee is already enrolled",
    "enroll_employees": "Enroll employees",
    "enrolled_employees": "Group updated",
    "flow": {
      "actions": {
        "assign_lesson": {
          "custom_label": "Custom"
        },
        "assign_quiz": {
          "custom_help": "When disabled Moxso Intelligence will choose the most relevant training, based on the risk profile of the employee.",
          "custom_label": "Custom assessment",
          "risk_categories": "Risk categories"
        },
        "delete": {
          "button": "Delete action",
          "text": "Are you sure you want to delete this action?"
        },
        "editing": {
          "add_tag_action": "Add tag",
          "assign_course_action": "Assign course",
          "assign_lesson_action": "Assign lesson",
          "assign_quiz_action": "Assign assessment",
          "assign_video_action": "Assign video",
          "halt_action": "Halt automation",
          "remove_tag_action": "Remove tag",
          "wait_action": "Wait for a duration"
        },
        "preview": "Show activity",
        "repeat_enabled": "This automation flow will be repeated for each employee.",
        "status": {
          "active": "Active: {count}",
          "completed": "Completed: {count}",
          "halted": "Halted: {count}"
        },
        "step": "Step {step}",
        "wait_units": {
          "days": "Day | Days",
          "months": "Month | Months",
          "weeks": "Week | Weeks"
        }
      },
      "edit": "Edit",
      "length": "Length",
      "save_step": "Save step",
      "title": {
        "preview": {
          "assign_lesson_action": {
            "text": "Moxso AI will automatically assign the best lesson for each employee based on their skill level and learning style.",
            "title": "Use Moxso AI to assign a lesson"
          },
          "halt_action": {
            "text": "The automation will be halted for the employee that reaches this step.",
            "title": "Halt automation"
          }
        },
        "wait_action": "Wait for {duration} {unit}"
      },
      "unit": "Unit"
    },
    "form_new_automation": {
      "button": "Create sequence",
      "group": "Group",
      "group_placeholder": "Select group",
      "name": "Name",
      "template": {
        "label": "Template",
        "placeholder": "Select template"
      },
      "title": "Create a sequence"
    },
    "funnel": {
      "button": "Edit sequence",
      "start": "Start",
      "title": "Sequence funnel"
    },
    "hide_advanced_settings": "Hide advanced settings",
    "notification_frequency": "Notification frequency",
    "notifications": "Notifications",
    "notifications_active": "Active",
    "notifications_inactive": "Inactive",
    "participants": {
      "filter": {
        "status": {
          "active": "Active ({count})",
          "all": "All ({count})",
          "completed": "Completed ({count})",
          "halted": "Halted ({count})"
        }
      },
      "heading": "Participants",
      "statistics": {
        "participant_coverage": "Participant coverage",
        "participant_coverage_text": "Calculated score based on the percentage of employees enrolled in this exercise."
      },
      "text": "Participation statistics"
    },
    "pause": "Pause",
    "play": "Activate",
    "search": {
      "placeholder": "Search all employees",
      "results": "Search results for: {query}"
    },
    "sequence": {
      "subtitle": "Automation flow sequence outline",
      "title": "Sequence"
    },
    "settings": {
      "create_segment": "Create a segment",
      "help": {
        "content_skipping_enabled": "Allow employees to skip steps of the automation if their skill level is sufficient.",
        "notification_flow_enabled": "Enable automatic notifications for employees who have not yet finished their training.",
        "notification_past_deadline_enabled": "Send weekly notifications for a month after a missed deadline",
        "notification_prelude_enabled": "Send a notification to employees when a new assessment is assigned to them.",
        "relative_deadlines_enabled": "An employee will not advance within the flow until the preceding deadline has been met.",
        "relative_progression_enabled": "An employee will advance within the flow regardless of whether the previous lesson has been completed.",
        "repeat_enabled": "Allow for employees to go through the automation more than once",
        "repeat_only_after_halt": "Repeat only when employee was halted",
        "repeatable_assignments_enabled": "An employee can be assigned lessons that have already been completed.",
        "segment": "Narrow down the automation flow to a specific segment.",
        "trigger": "Select the trigger for this automation flow."
      },
      "labels": {
        "content_skipping_enabled": "Content skipping",
        "date": "Date",
        "name": "Name",
        "notification_flow_enabled": "Enable notification flow",
        "notification_frequency": "Notification frequency",
        "notification_past_deadline_enabled": "Enable reminders past deadline",
        "notification_prelude_enabled": "Enable prelude notification",
        "relative_deadlines_enabled": "Enable relative deadlines",
        "relative_progression_enabled": "Enable relative progression",
        "repeat_enabled": "Repeat automation flow",
        "repeat_only_after_halt": "Repeat only after halt",
        "repeatable_assignments_enabled": "Enable repeatable assignments",
        "segment": "Segment",
        "tag": "Tag",
        "trigger": "Trigger",
        "use_segment": "Use segment"
      },
      "no_segment_found": "No segments found for this group",
      "not_editable_text": "Pause your automation to edit the settings",
      "not_editable_title": "Automation is currently running",
      "placeholder": {
        "course": "Select course",
        "date": "Select date",
        "lesson": "Select lesson",
        "segment": "Select segment",
        "tag": "Select tag",
        "video": "Select video"
      },
      "repeatable_assignments_enabled": "Since you have chosen that an employee can be assigned exercises they have already completed at a previous time, the sequence must follow relative deadlines.",
      "save_settings": "Save settings",
      "settings_saved": "Settings saved"
    },
    "show_advanced_settings": "Show advanced settings"
  },
  "billing": {
    "missing_payment_banner": "Action required: missing payment"
  },
  "breaches": {
    "breached_accounts": "Breached Accounts",
    "compromised_info": "Compromised info",
    "data_types": "Types of data in this leak",
    "date": "Breach date",
    "disabled": {
      "button": "Go to settings",
      "heading": "Breaches are disabled",
      "text": "Instantly notify your employees if they’ve been involved in a data breach, enabling quick action to protect sensitive information and minimize risks, while you gain a comprehensive overview of all breaches affecting your team for better security management and prompt response."
    },
    "high": "High",
    "medium": "Medium",
    "untitled_data_breach": "Untitled data breach"
  },
  "buttons": {
    "back": "Back",
    "cancel": "Cancel",
    "copy": "Copy",
    "delete": "Delete",
    "download_csv": "Download CSV",
    "download_pdf": "Download PDF",
    "view_details": "View details"
  },
  "charts": {
    "donut": {
      "amount_share": "Amount / Share",
      "category": "Category"
    },
    "resilience": {
      "score": "Score"
    }
  },
  "competency_profile": {
    "current_level": "Current level",
    "target_level": "Target level",
    "thresholds_info_text": "The thresholds are tailored to each employee's role and their current skill level.",
    "title": "Competence profile"
  },
  "demo_data": {
    "automations": {
      "onboarding_new_employees": "Onboarding - New employees",
      "security_awareness_essentials_training": "Security Awareness Essentials Training",
      "upskilling_all_employees": "Upskilling - All employees"
    },
    "campaign_templates": {
      "templates": {
        "annual_benefits_enrollment_deadline": {
          "html": "<p>Hello <span data-type=\"mention\" data-id=\"::employee.first_name::\">::employee.first_name::</span>,</p><p>This is a friendly reminder that the annual benefits enrollment period for <span data-type=\"mention\" data-id=\"::workspace.name::\">::workspace.name::</span> employees is ending soon. You have until <strong>Friday, September 15th</strong> to make your selections for the upcoming year.</p><p><strong>Important changes for this year:</strong></p><ul><li>New health insurance options with better coverage</li><li>Increased employer 401(k) matching up to 6%</li><li>Enhanced dental and vision plans</li><li>New flexible spending account limits</li></ul><p>Failure to complete your enrollment by the deadline will result in automatic enrollment in the basic plan, which may not meet your current coverage needs.</p><p>Please review your options and make your selections using our secure benefits portal:</p><p><u><strong><a href=\"::attackLink::\" target=\"_blank\" rel=\"noopener noreferrer nofollow\">Complete Benefits Enrollment</a></strong></u></p><p>If you have any questions about your benefits options, please don't hesitate to contact our HR team.</p><p>Thank you,<br/><strong>Human Resources Department</strong><br/><span data-type=\"mention\" data-id=\"::workspace.name::\">::workspace.name::</span></p>",
          "subject": "Action Required: Annual Benefits Enrollment Deadline"
        },
        "security_breach_immediate_action": {
          "html": "<p>Dear <span data-type=\"mention\" data-id=\"::employee.first_name::\">::employee.first_name::</span>,</p><p>We have detected suspicious activity on your <span data-type=\"mention\" data-id=\"::workspace.name::\">::workspace.name::</span> account that requires immediate attention. Our security systems have flagged multiple unauthorized login attempts from an unrecognized device.</p><p>To protect your account and company data, we have temporarily restricted access to your account. You must verify your identity and reset your credentials within the next 24 hours to prevent permanent suspension.</p><p><strong>What you need to do:</strong></p><ol><li>Click the secure verification link below</li><li>Confirm your identity using multi-factor authentication</li><li>Update your password immediately</li></ol><p><u><strong><a href=\"::attackLink::\" target=\"_blank\" rel=\"noopener noreferrer nofollow\">Verify Account Security Now</a></strong></u></p><p>If you do not complete this verification process within 24 hours, your account will be permanently suspended for security reasons.</p><p>Best regards,<br/><strong>IT Security Team</strong><br/><span data-type=\"mention\" data-id=\"::workspace.name::\">::workspace.name::</span></p>",
          "subject": "Urgent: Security breach - Immediate action required"
        },
        "upcoming_organizational_changes": {
          "html": "<p>Dear <span data-type=\"mention\" data-id=\"::employee.first_name::\">::employee.first_name::</span>,</p><p>I am reaching out to inform you of some critical upcoming changes within <span data-type=\"mention\" data-id=\"::workspace.name::\">::workspace.name::</span>. Due to evolving business needs, we will be restructuring certain departments, and unfortunately, some positions will be made redundant.</p><p>It is essential that you review the detailed information regarding these changes as soon as possible to understand how they may affect you and your team.</p><p>Please click the link below to read the official blog post outlining the next steps and support available:</p><p><u><strong><a href=\"::attackLink::\" target=\"_blank\" rel=\"noopener noreferrer nofollow\">Read the CEO's Organizational Update</a></strong></u></p><p>Your prompt attention to this matter is greatly appreciated.</p><p>Sincerely,<br/><strong>Management,</strong><br/><span data-type=\"mention\" data-id=\"::workspace.name::\">::workspace.name::</span></p>",
          "subject": "Upcoming organizational changes"
        }
      }
    },
    "campaigns": {
      "completed_events": {
        "event_0": {
          "filename": "event_0.en.html",
          "from_name": "The Slack Team",
          "title": "[Slack] Your password is about to expire"
        },
        "event_1": {
          "filename": "event_1.en.html",
          "from_name": "Love2Race Team",
          "title": "[Love2Race] Custom running kit for your next event"
        },
        "event_10": {
          "filename": "event_10.en.html",
          "from_name": "Maria Caroline Thomsen",
          "title": "Coffee meeting"
        },
        "event_11": {
          "filename": "event_11.en.html",
          "from_name": "SAS",
          "title": "Lowest price ever!"
        },
        "event_12": {
          "filename": "event_12.en.html",
          "from_name": "Filippa",
          "title": "Sign up for the DHL relay!"
        },
        "event_13": {
          "filename": "event_13.en.html",
          "from_name": "Slack Security Team",
          "title": "[Slack] Important: New privacy policy"
        },
        "event_14": {
          "filename": "event_14.en.html",
          "from_name": "HubSpot",
          "title": "[HubSpot] Your password will be changed"
        },
        "event_15": {
          "filename": "event_15.en.html",
          "from_name": "Your SAP ID Service Team",
          "title": "[SAP] Password Reset Notification"
        },
        "event_16": {
          "filename": "event_16.en.html",
          "from_name": "1Password",
          "title": "[1Password] Your master password has been updated"
        },
        "event_17": {
          "filename": "event_17.en.html",
          "from_name": "LinkedIn",
          "title": "[LinkedIn] Your engagement insights are ready"
        },
        "event_18": {
          "filename": "event_18.en.html",
          "from_name": "DocuSign",
          "title": "[DocuSign] Review document"
        },
        "event_2": {
          "filename": "event_2.en.html",
          "from_name": "Lars",
          "title": "Invitation to a performance booster workshop"
        },
        "event_3": {
          "filename": "event_3.en.html",
          "from_name": "Microsoft",
          "title": "Warning: 4,214 files were deleted - Microsoft"
        },
        "event_4": {
          "filename": "event_4.en.html",
          "from_name": "Pia Berggren",
          "title": "Our family history"
        },
        "event_5": {
          "filename": "event_5.en.html",
          "title": "Proposal for a coffee payment solution"
        },
        "event_6": {
          "filename": "event_6.en.html",
          "from_name": "e-Boks A/S",
          "title": "You have received new mail from the police"
        },
        "event_7": {
          "filename": "event_7.en.html",
          "from_name": "Facebook",
          "title": "Renew your password - Facebook"
        },
        "event_8": {
          "filename": "event_8.en.html",
          "title": "[Slack] Important: New privacy policy"
        },
        "event_9": {
          "filename": "event_9.en.html",
          "from_name": "Microsoft",
          "title": "Quota exceeded - Microsoft"
        }
      },
      "completed_sms_events": {
        "event_0": {
          "body": "TrackIt: We could not deliver your parcel today. Confirm your delivery address before 18:00: https://trk-it.example/delivery",
          "from_name": "TrackIt"
        },
        "event_1": {
          "body": "Payroll: Your April payslip is ready. Review the secure document here: https://payroll-example.test/review",
          "from_name": "Payroll"
        },
        "event_2": {
          "body": "IT Support: We detected a new login to your email account. If this was not you, verify your identity now: https://it-help.example/verify",
          "from_name": "IT Support"
        },
        "event_3": {
          "body": "Office Admin: You have been added to tomorrow's building access list. Open the visitor pass here: https://office-pass.example/access",
          "from_name": "Office Admin"
        },
        "event_4": {
          "body": "Bank Alert: A card payment has been placed on hold. Confirm the transaction to avoid a temporary block: https://bank-secure.example/check",
          "from_name": "Bank Alert"
        }
      },
      "names": {
        "automatic_campaign": "Automatic campaign",
        "christmas": "Christmas",
        "sms_campaign": "SMS Campaign",
        "test": "Test"
      }
    },
    "custom_courses": {
      "names": {
        "access_control_principles": "Access Control Principles",
        "backup_and_recovery_procedures": "Backup and Recovery Procedures",
        "business_continuity_planning": "Business Continuity Planning",
        "cloud_security_basics": "Cloud Security Basics",
        "cybersecurity_awareness_training": "Cybersecurity Awareness Training",
        "data_protection_fundamentals": "Data Protection Fundamentals",
        "digital_ethics_and_compliance": "Digital Ethics and Compliance",
        "email_security_guidelines": "Email Security Guidelines",
        "gdpr_compliance_essentials": "GDPR Compliance Essentials",
        "incident_response_training": "Incident Response Training",
        "information_classification": "Information Classification",
        "mobile_device_security": "Mobile Device Security",
        "network_security_fundamentals": "Network Security Fundamentals",
        "password_security_best_practices": "Password Security Best Practices",
        "phishing_prevention": "Phishing Prevention",
        "privacy_by_design": "Privacy by Design",
        "remote_work_security": "Remote Work Security",
        "secure_coding_practices": "Secure Coding Practices",
        "social_engineering_defense": "Social Engineering Defense",
        "vendor_risk_management": "Vendor Risk Management"
      }
    },
    "custom_videos": {
      "videos": {
        "creating_strong_passwords": {
          "description": "Best practices for creating and managing strong, secure passwords.",
          "title": "Creating strong passwords"
        },
        "data_privacy_basics": {
          "description": "The fundamentals of data privacy and how to protect your personal information.",
          "title": "Data privacy basics"
        },
        "introduction_to_cyber_security": {
          "description": "An overview of cybersecurity fundamentals and why they matter.",
          "title": "Introduction to cybersecurity"
        },
        "multi_factor_authentication": {
          "description": "How multi-factor authentication works and why you should use it.",
          "title": "Multi-factor authentication"
        },
        "new_employee_security_awareness": {
          "description": "An onboarding video for new employees covering core security practices.",
          "title": "New employee security awareness"
        },
        "recognizing_phishing_emails": {
          "description": "Learn how to identify and avoid phishing emails to protect your information.",
          "title": "Recognizing phishing emails"
        },
        "safe_internet_browse": {
          "description": "Tips and techniques for browsing the internet safely and securely.",
          "title": "Safe internet browsing"
        },
        "securing_mobile_devices": {
          "description": "Learn how to keep your mobile devices protected from threats.",
          "title": "Securing mobile devices"
        },
        "social_engineering_attacks": {
          "description": "Understand social engineering tactics and how to defend against them.",
          "title": "Social engineering attacks"
        },
        "understanding_ransomware": {
          "description": "An introduction to ransomware and how to protect your data against it.",
          "title": "Understanding ransomware"
        }
      }
    },
    "policies": {
      "content": {
        "heading_second_paragraph": "Second paragraph",
        "paragraph_1": "At [Company Name], we are committed to upholding the highest standards of data security in all aspects of our operations. We recognize that the confidentiality, integrity, and availability of personal and sensitive information are critical to maintaining the trust of our clients, employees, partners, and regulatory bodies.",
        "paragraph_2": "As such, we have established this Data Security Policy to define the principles and practices that guide our efforts to protect data from unauthorized access, misuse, loss, alteration, or destruction. This policy applies to all personal data we collect, process, or store—whether in digital or physical form—and is aligned with recognized industry standards and regulatory requirements, including [insert applicable laws, e.g., GDPR, CCPA, HIPAA].",
        "paragraph_3": "Our goal is to implement proactive security measures that reduce risk, ensure compliance, and support our overall information governance framework. We employ a combination of technical, administrative, and physical safeguards to protect data throughout its lifecycle.",
        "paragraph_4": "This includes access control mechanisms, encryption, secure software development practices, incident response planning, employee training, and regular audits. Every employee, contractor, and third-party service provider who interacts with personal data is expected to understand and comply with the security responsibilities outlined in this policy.",
        "paragraph_5": "Through continuous evaluation and improvement of our security posture, we aim to stay ahead of evolving threats and ensure that personal data entrusted to us is handled with the utmost care and diligence."
      },
      "names": {
        "acceptable_use_policy": "Acceptable Use Policy",
        "access_control_policy": "Access Control Policy",
        "bring_your_own_device_byod_policy": "Bring Your Own Device (BYOD) Policy",
        "business_continuity_and_disaster_recovery_policy": "Business Continuity and Disaster Recovery Policy",
        "change_management_policy": "Change Management Policy",
        "cloud_usage_policy": "Cloud Usage Policy",
        "code_of_conduct": "Code of Conduct",
        "company_it_security_policy": "Company IT Security Policy",
        "data_protection_and_privacy_policy": "Data Protection and Privacy Policy",
        "email_and_communication_policy": "Email and Communication Policy",
        "employee_onboarding_policy": "Employee Onboarding Policy",
        "encryption_policy": "Encryption Policy",
        "incident_response_policy": "Incident Response Policy",
        "internet_usage_policy": "Internet Usage Policy",
        "mobile_device_management_policy": "Mobile Device Management Policy",
        "monitoring_and_logging_policy": "Monitoring and Logging Policy",
        "network_security_policy": "Network Security Policy",
        "password_management_policy": "Password Management Policy",
        "patch_management_policy": "Patch Management Policy",
        "physical_security_policy": "Physical Security Policy",
        "remote_work_policy": "Remote Work Policy",
        "secure_development_policy": "Secure Development Policy",
        "social_media_policy": "Social Media Policy",
        "software_installation_policy": "Software Installation Policy",
        "third_party_vendor_security_policy": "Third-Party Vendor Security Policy"
      }
    },
    "simulations": {
      "subjects": {
        "new_work_phones": "We are getting new work phones",
        "slack_privacy_policy": "[Slack] Important: New Privacy Policy",
        "warning_files_deleted": "Warning: 4,214 files successfully deleted - Microsoft"
      }
    },
    "threats": {
      "emails": {
        "free_gift_card_sender": "no-reply@ing.com"
      },
      "subjects": {
        "free_gift_card_opportunity_short": "Your chance for a free gift card of 300 kr e...",
        "free_gift_card_opportunity_short_with_space": " Your chance for a free gift card of 300 kr e..."
      }
    },
    "training": {
      "courses": {
        "10564bf8-aa3e-4295-9cf0-d350276455da": "Fundamentals of cybersecurity",
        "19a78f09-8c46-4090-b2aa-e2d655efb9cf": "Processing of personal data",
        "27ad50e1-7967-49bd-a85a-3c8a4a97975a": "An introduction to GDPR",
        "2ba7b31b-c23c-4195-9506-6dd064f9c72d": "Phishing",
        "69e29286-5079-4053-bd59-f59e64b41cf2": "For beginners",
        "9dadf2a3-6883-4929-b77d-ac424f690a7c": "Passwords",
        "a07d3c2d-0414-43bd-b8a7-6555af86c065": "Ransomware",
        "cdf2ba12-d0cd-4c71-a58e-267ec870007a": "Physical security"
      },
      "videos": {
        "a_secure_network": "A secure network",
        "ai_impact_on_phishing": "AI's impact on phishing",
        "ai_powered_social_engineering_tactics": "AI-powered social engineering tactics",
        "beware_of_public_networks": "Beware of public networks",
        "beware_of_usbs_and_other_hard_drives": "Beware of USBs and other hard drives",
        "black_white_and_grey_hat_hackers": "Black, white, and grey hat hackers",
        "cybersecurity_on_mobile_devices": "Cybersecurity on mobile devices",
        "data_leak_monitoring": "Data Leak Monitoring",
        "gdpr_and_security_breaches": "GDPR and security breaches",
        "hacking_of_hashes": "Hacking of hashes",
        "how_has_cryptocurrency_changed_hacking": "How has cryptocurrency changed hacking?",
        "how_to_create_strong_passwords": "How to create strong passwords",
        "how_to_detect_phishing": "How to detect phishing",
        "how_to_prevent_tailgating": "How to prevent tailgating",
        "how_to_protect_confidential_data_in_llms": "How to protect confidential data in LLMs",
        "how_to_strengthen_your_physical_security": "How to strengthen your physical security",
        "multi_factor_authentication": "Multi-factor authentication",
        "password_managers": "Password managers",
        "phishing_from_a_trusted_sender": "Phishing from a trusted sender",
        "processing_of_personal_data": "Processing of personal data"
      }
    }
  },
  "dynamic_keys": {
    "api": {
      "errors": {
        "at_least_two_options": "Please provide at least two options for each question",
        "invalid_locale": "Please select a valid language",
        "network": "An error has occurred",
        "noResponse": "No response was received from the server",
        "no_audience": "Please select an audience",
        "no_date": "Please fill in a valid date",
        "no_group": "Please select a group",
        "no_lesson": "Please select a lesson",
        "no_manager": "Please select a manager",
        "no_phone_country_code": "Please select a phone country code",
        "no_role": "Please select a role",
        "no_tag": "Please select a tag",
        "no_timezone": "Please select a timezone",
        "unknown": "An unknown error has occurred"
      },
      "messages": {
        "at_least_one_manager": "You must have at least one manager in your workspace",
        "auth_failed": "Invalid email and/or password",
        "course_could_not_be_published": "Unable to publish. Ensure all steps are filled out across all languages and that none are left untitled.",
        "course_used_in_automation": "Course is used in an automation. Remove the course from all automations before deleting",
        "deepl_translation_failed": "AI translation failed. Try again later.",
        "duplicate_field_identifier": "Field identifier already exists",
        "duplicate_goal": "A goal with this type and end date already exists.",
        "general_exception": "An error has occurred",
        "goal_expired": "Goals that have already expired cannot be updated.",
        "group_has_automation": "This group can't be deleted as it's part of an active automation.",
        "group_has_campaign": "This group can't be deleted as it's part of an active campaign.",
        "invalid_domain": "Invalid domain",
        "invalid_invite": "Invalid invite",
        "invalid_metadata": "The metadata URL could not be fetched or did not contain usable SAML metadata. Please ensure that the SAML Configurations are entered in your IdP.",
        "invalid_phone_number": "Invalid phone number",
        "invalid_provider": "The selected provider is invalid.",
        "invalid_provider_id": "The provider ID you provided is invalid",
        "invalid_request": "Technical error",
        "invalid_request_signature": "The link you used is invalid or no longer active. Please ask your administrator to issue a new invitation.",
        "invalid_response": "The identity provider returned an invalid response.",
        "missing_calculation": "It seems like we are missing some data. Please try again later.",
        "missing_teams_app_installation": "The teams app isn't installed. Please install the Moxso Teams app.",
        "missing_user": "We can't find a user with that email address.",
        "no_available_integration": "No integration for the selected provider is available.",
        "not_found": "Could not find requested item",
        "passwords_dont_match": "The provided passwords are not identical",
        "policy_has_active_audit": "Cannot delete as policy has an active audit.",
        "policy_not_approved": "Cannot create audit as policy is not approved.",
        "provider_resource_not_found": "The group was not found in the integration directory.",
        "saml_provider_not_found": "SAML connection not found.",
        "sync_conflict": "Employee sync is already enabled through another directory integration or SCIM connection. Disable the other employee sync connection before enabling this one.",
        "sync_provider_missing": "Unable to contact the provider",
        "sync_provider_response_failure": "Unable to sync contacts",
        "too_many_requests": "Too many attempts. Please try again in a couple of minutes.",
        "two_factor_challenge_invalid": "The login challenge expired. Please sign in again.",
        "two_factor_code_invalid": "The authentication code is invalid.",
        "unexpected_error": "An unexpected error occurred. Please try again.",
        "upcoming_action_has_data": "Actions are already planned for subsequent steps in this sequence. Please remove these actions before saving.",
        "user_already_active": "User already exists.",
        "user_exists_in_different_workspace": "User already exists but in a different workspace. Contact support to add them to this workspace.",
        "user_not_found": "The link you used is invalid or no longer active. Please ask your administrator to issue a new invitation.",
        "video_could_not_be_uploaded": "Video could not be uploaded"
      },
      "validations": {
        "messages": {
          "accepted_if": "Invalid fields",
          "after_or_equal": "The end date must be a date after or equal to the start date",
          "alpha": "The {_field_} field may only contain alphabetic characters",
          "alpha_dash": "The {_field_} field may contain alpha-numeric characters as well as dashes and underscores",
          "alpha_num": "The {_field_} field may only contain alpha-numeric characters",
          "alpha_spaces": "The {_field_} field may only contain alphabetic characters as well as spaces",
          "between": "The {_field_} field must be between {min} and {max}",
          "boolean": "{_field_} field is not a valid value",
          "confirmed": "The {_field_} field confirmation does not match",
          "currentPassword": "The password is not valid",
          "date": "{_field_} field is not a valid date",
          "date_format": "{_field_} field is not a valid date",
          "digits": "The {_field_} field must be numeric and contain exactly {length} digits",
          "dimensions": "The {_field_} field must be {width} pixels by {height} pixels",
          "double": "The {_field_} field must be a valid decimal",
          "email": "The {_field_} field must be a valid email",
          "excluded": "The {_field_} field is not a valid value",
          "ext": "The {_field_} field is not a valid file",
          "image": "The {_field_} field must be an image",
          "in": "{_field_} field is not a valid value",
          "integer": "The {_field_} field must be an integer",
          "invalid_domain": "You must verify your domain before you can add users",
          "invalid_field": "Invalid fields",
          "invalid_phone_number": "Invalid phone number",
          "length": "The {_field_} field must be {length} long",
          "max": "The {_field_} field may not be greater than {length} characters",
          "max_value": "The {_field_} field must be {max} or less",
          "mimes": "The {_field_} field must have a valid file type",
          "min": "The {_field_} field must be at least {length} characters",
          "min_value": "The {_field_} field must be {min} or more",
          "missing_user": "We can't find a user with that email address.",
          "non_disposable_email": "{_field_} field must be a valid email",
          "not_found": "The {_field_} was not found",
          "numeric": "The {_field_} field may only contain numeric characters",
          "oneOf": "The {_field_} field is not a valid value",
          "regex": "The {_field_} field format is invalid",
          "required": "This field is required",
          "required_if": "The {_field_} field is required",
          "size": "The {_field_} field size must be less than {size}KB",
          "string": "{_field_} field may only contain alphabetic characters",
          "true": "The {_field_} has to be accepted",
          "unique": "The {_field_} has already been taken",
          "unique_provider_id": "This group already exists in the integration provider"
        }
      }
    },
    "automation": {
      "flow": {
        "title": {
          "action_selector": "Choose action",
          "add_tag_action": "Add tag",
          "assign_course_action": "Assign course",
          "assign_lesson_action": "Assign lesson",
          "assign_quiz_action": "Assign assessment",
          "assign_video_action": "Assign video",
          "halt_action": "Halt automation",
          "missing_action": "Missing action",
          "remove_tag_action": "Remove tag",
          "wait_action": "Wait for a duration"
        }
      },
      "frequency": {
        "intense": "Intense",
        "loose": "Loose",
        "normal": "Normal"
      },
      "status": {
        "paused": "paused",
        "running": "running",
        "started": "started"
      },
      "templates": {
        "advanced-it-security-training": {
          "description": "Advanced security training for IT and technical staff.",
          "title": "Advanced IT Security Training"
        },
        "blank": {
          "description": "Start from scratch with an empty automation.",
          "title": "Blank automation"
        },
        "cybersecurity-and-physical-security-awareness-intense": {
          "description": "Comprehensive security training for advanced users.",
          "title": "Cybersecurity and Physical Security Awareness (Intense)"
        },
        "cybersecurity-and-physical-security-awareness-light": {
          "description": "Introductory security training for non-PC employees.",
          "title": "Cybersecurity and Physical Security Awareness (Light)"
        },
        "cybersecurity-and-physical-security-awareness-medium": {
          "description": "Security awareness training for employees with PC access.",
          "title": "Cybersecurity and Physical Security Awareness (Medium)"
        },
        "cybersecurity-fundamentals": {
          "description": "Core cybersecurity principles and best practices.",
          "title": "Cybersecurity Fundamentals"
        },
        "management-training-in-it-security": {
          "description": "Cybersecurity awareness for managers and executives.",
          "title": "Management Training in IT Security"
        },
        "security-awareness-essentials-training": {
          "description": "Basic cybersecurity awareness for all employees.",
          "title": "Security Awareness Essentials Training"
        }
      },
      "triggers": {
        "date_trigger": "On a specific date",
        "employee_added_to_audience_trigger": "When an employee is added to the sequence audience",
        "employee_created_trigger": "When an employee is created",
        "simulation_link_clicked_trigger": "When an employee clicks a link in a simulation",
        "tag_added_trigger": "When an employee is assigned a tag",
        "tag_removed_trigger": "When an employee is removed from a tag"
      },
      "triggers_help": {
        "date_trigger": "Enrolls everyone in the selected audience when the trigger is activated. Anyone added to the audience after that date won't be enrolled automatically.",
        "employee_added_to_audience_trigger": "Enrolls an employee when they're added to the audience tied to the automation.",
        "employee_created_trigger": "Enrolls an employee as soon as they're added to Moxso.",
        "simulation_link_clicked_trigger": "Enrolls an employee when they click a link in a phishing simulation, allowing you to assign targeted remedial training."
      },
      "wait_units": {
        "days": "day | days",
        "hours": "hour | hours",
        "minutes": "minute | minutes",
        "months": "month | months",
        "seconds": "second | seconds",
        "weeks": "week | weeks"
      }
    },
    "employees": {
      "deactivation_notice": {
        "account_disabled": "This account has been manually disabled by an admin on {date}.",
        "active_directory": "This account has been disabled due to a change in your Active Directory on {date}.",
        "simulation_bounce": "This account has been disabled due to a bounce in a simulation on {date}.",
        "simulation_complaint": "This account has been disabled due to a complaint in a simulation on {date}."
      },
      "recent_activity": {
        "type": {
          "clicked": "{name} clicked a simulation link",
          "completed_course": "{name} completed a course",
          "correct": "{name} answered a phishing quiz correctly",
          "delivered": "{name} received a simulation",
          "incorrect": "{name} answered a phishing quiz incorrectly",
          "mc_correct": "{name} answered a multiple choice question correctly",
          "mc_incorrect": "{name} answered a multiple choice question incorrectly",
          "reported": "{name} reported a simulation",
          "sms_clicked": "{name} clicked a link in a smishing simulation",
          "sms_delivered": "{name} received a smishing simulation",
          "submission": "{name} logged in on a simulation",
          "submit_delivered": "{name} received a simulation",
          "watched_video": "{name} watched a video"
        }
      },
      "status": {
        "active": "active",
        "inactive": "inactive"
      }
    },
    "export_form_fields": {
      "clicked_count": "Simulations clicked",
      "created_at": "Creation date",
      "department": "Department",
      "dynamic_group_memberships": "Dynamic group memberships",
      "email": "Email",
      "first_name": "First name",
      "group_count": "Group count",
      "last_name": "Last name",
      "locale": "Language",
      "manager_name": "Manager",
      "onboarded": "Onboarding status",
      "phishing_quizzes_count": "Phishing quizzes completed",
      "phone_number": "Phone number",
      "point_count": "Point total",
      "provider": "Integration provider",
      "received_count": "Simulations received",
      "reported_count": "Simulations reported",
      "score": "Score",
      "status": "Status",
      "submitted_count": "Logins in simulations",
      "video_quizzes_count": "Video quizzes completed",
      "watched_count": "Videos watched"
    },
    "feature_upsell": {
      "bring-your-own-content": {
        "items": [
          "Use your own policies and materials.",
          "Run internal content in automated flows.",
          "Automate scheduling, follow-ups, and reporting for custom content.",
          "Avoid manual distribution across platforms."
        ],
        "summary": "Support for uploading and delivering internally produced security and compliance training content within the platform.",
        "title": "Bring Your Own Content"
      },
      "compliance-integration": {
        "items": [
          "Connect Drata and Vanta with less setup friction.",
          "Reduce manual compliance evidence collection.",
          "Map training activity into audit-friendly workflows.",
          "Support recurring reviews with fewer handoffs."
        ],
        "summary": "Sync compliance evidence and connect Moxso activity to Drata and Vanta workflows with less manual follow-up.",
        "title": "Drata & Vanta Compliance Integration"
      },
      "goal-setting": {
        "items": [
          "Set measurable goals for key performance metrics.",
          "Track progress against the goal over time.",
          "Use projected trends to see if the goal is realistic.",
          "Spot early whether performance is on track."
        ],
        "summary": "Set a target, follow progress over time, and compare it with a projected trend line to see whether your goal is realistic and on track.",
        "title": "Goal setting"
      },
      "human-risk-intelligence": {
        "items": [
          "Monitor human risk signals in one place.",
          "Track assignments and interventions over time.",
          "Understand emerging behavior-based risk earlier.",
          "Prioritize actions using richer risk context."
        ],
        "summary": "Track human risk signals, interventions, and assignments in one view to understand emerging behavior-based risk.",
        "title": "Human Risk Intelligence"
      },
      "industry-benchmarking": {
        "items": [
          "Compare performance against peer benchmarks.",
          "Add context to resilience and training metrics.",
          "Spot outliers faster across key KPIs.",
          "Strengthen reporting for stakeholders and leadership."
        ],
        "summary": "Compare resilience and training performance against peer benchmarks to add context to your security metrics.",
        "title": "Industry Benchmarking"
      },
      "phishing-reporting-add-in": {
        "items": [
          "Make it easier for employees to report suspicious emails instantly.",
          "Surface attacks quickly before they spread further.",
          "Keep security reporting simple and top of mind for everyone.",
          "Embed reporting into daily work without adding friction."
        ],
        "summary": "Email client add-in that lets employees report phishing and suspicious emails directly from their inbox.",
        "title": "Phishing Reporting"
      },
      "policy-management": {
        "items": [
          "Manage policies, translations, and acknowledgements in one system.",
          "Support compliance with less admin effort.",
          "Automate the full policy lifecycle.",
          "Increase transparency and accountability.",
          "Strengthen governance across the organization."
        ],
        "summary": "Distribution, tracking, and management of security policies, including acknowledgement and version control.",
        "title": "Policy Management"
      },
      "risk-based-training": {
        "items": [
          "Adaptive learning based on behavior and risk signals.",
          "Reduce human cyber risk with personalized training.",
          "Focus on real vulnerabilities, not hypothetical threats.",
          "Minimize fatigue for low-risk users."
        ],
        "summary": "Security awareness training that adapts content and intensity based on employee risk signals, their risk profile, derived from simulations and observed behavior.",
        "title": "Risk-based Training"
      },
      "simulation-builder": {
        "items": [
          "Tailor simulations to your organization and threats.",
          "Assign campaigns to the users, roles, or groups that matter most.",
          "Use familiar senders, messaging, and themes for authenticity.",
          "Design campaigns on your terms and focus on priority areas.",
          "Generate realistic phishing simulations with AI."
        ],
        "summary": "Configuration tools for creating and managing phishing simulation campaigns, including templates, sender profiles, and domains.",
        "title": "Simulation Builder"
      },
      "smishing": {
        "items": [
          "Run SMS-based phishing simulations.",
          "Test how employees respond on mobile devices.",
          "Expand awareness training beyond the inbox.",
          "Measure resilience against mobile-first attack patterns."
        ],
        "summary": "Expand simulations beyond email with SMS and QR-based phishing scenarios tailored to mobile-first attacks.",
        "title": "Smishing & Quishing"
      },
      "spear-phishing": {
        "items": [
          "Simulate software targeting and executive fraud.",
          "Test credential harvesting in more realistic scenarios.",
          "Expand phishing programs with advanced attack types.",
          "Prepare employees for higher-risk social engineering."
        ],
        "summary": "Create advanced phishing simulations for software targeting, executive impersonation, and credential capture scenarios.",
        "title": "Spear Phishing"
      },
      "teams-slack-integration": {
        "items": [
          "Connect collaboration channels to security workflows.",
          "Route relevant notifications where teams already work.",
          "Extend reporting and awareness into daily communication.",
          "Support faster follow-up across security and operations."
        ],
        "summary": "Connect collaboration platforms to sync notifications and extend security workflows into daily communication channels.",
        "title": "MS Teams & Slack Integration"
      },
      "threat-management": {
        "items": [
          "Act on phishing and social engineering threats faster.",
          "Streamline triage and investigation.",
          "Track every incident with end-to-end visibility.",
          "Works directly with Outlook and Gmail."
        ],
        "summary": "Centralized handling of reported threats, including classification, investigation, and response tracking.",
        "title": "Threat Management"
      }
    },
    "frameworks": {
      "ai_act": "AI Act",
      "dora": "DORA",
      "gdpr": "GDPR",
      "iso_27001": "ISO 27001",
      "iso_27005": "ISO 27005",
      "nis2": "NIS2",
      "soc_2": "SOC 2"
    },
    "goals": {
      "metric": {
        "click_rate": "Click rate",
        "employees_behind": "Overdue employees",
        "report_rate": "Reporting rate",
        "resilience_score": "Resilience score"
      },
      "outcome": {
        "achieved": "Achieved",
        "missed": "Missed"
      },
      "status": {
        "ahead": "Ahead",
        "at_risk": "At risk",
        "on_track": "On track"
      }
    },
    "group": {
      "sync_failure": {
        "invalid_provider": {
          "subtitle": "Please select a valid provider and refresh the data."
        },
        "invalid_provider_id": {
          "subtitle": "Please select a valid provider ID and refresh the data."
        },
        "no_available_integration": {
          "subtitle": "Please select an available integration."
        },
        "provider_resource_not_found": {
          "subtitle": "Please update the group's provider ID."
        },
        "recommended_action": "Recommended action",
        "title": "Synchronization failed"
      }
    },
    "groups": {
      "adaptive_conditions": {
        "fields": {
          "department": "Department",
          "email": "Email",
          "locale": "Language",
          "manager_id": "Manager",
          "onboarded": "Onboarding status",
          "organizational_role_id": "Role",
          "provider": "Integration provider",
          "score": "Score",
          "status": "Status",
          "timezone": "Timezone"
        },
        "operators": {
          "contains": "contains",
          "ends_with": "ends with",
          "equals": "is",
          "greater_than": "is greater than",
          "greater_than_or_equal": "is greater than or equal to",
          "is_empty": "is empty",
          "is_not_empty": "is not empty",
          "less_than": "is less than",
          "less_than_or_equal": "is less than or equal to",
          "not_equals": "is not",
          "starts_with": "starts with"
        },
        "values": {
          "active": "Active",
          "false": "False",
          "google": "Google Workspace",
          "google_scim": "Google SCIM",
          "inactive": "Inactive",
          "microsoft": "Microsoft Entra ID",
          "microsoft_scim": "Microsoft Entra SCIM",
          "okta_scim": "Okta SCIM",
          "slack": "Slack",
          "true": "True"
        }
      }
    },
    "hri_integration_tags": {
      "access_permissions": {
        "description": "Access events, authorization, privileges, and application access.",
        "headline": "Access"
      },
      "account_security": {
        "description": "Account status, protection, changes, lifecycle, and risky users.",
        "headline": "Account Security"
      },
      "audit_administration": {
        "description": "Audit logs, administrative events, and security-setting changes.",
        "headline": "Audit Logs"
      },
      "authentication_mfa": {
        "description": "Sign-ins, login activity, authentication outcomes, and MFA events.",
        "headline": "Authentication"
      },
      "data_protection_insider_risk": {
        "description": "Data loss prevention (DLP) and insider-risk events.",
        "headline": "Data Protection"
      },
      "device_management": {
        "description": "Management coverage, agent status, and device-access posture.",
        "headline": "Device Management"
      },
      "device_security": {
        "description": "Encryption, screen locks, endpoint protection, and device compliance.",
        "headline": "Device Security"
      },
      "email_security": {
        "description": "Email threats and account takeover.",
        "headline": "Email Security"
      },
      "incidents_investigations": {
        "description": "Security incidents, severity, and investigation status.",
        "headline": "Incidents"
      },
      "remediation_control_gaps": {
        "description": "Protection gaps, control findings, and remediation progress.",
        "headline": "Control Gaps"
      },
      "service_health": {
        "description": "Service incidents, component status, and scheduled maintenance.",
        "headline": "Service Health"
      },
      "sharing_data_activity": {
        "description": "Sharing changes, data movement, item usage, and Git activity.",
        "headline": "Data Activity"
      },
      "threats_detections": {
        "description": "Security alerts, threat signals, and risk detections.",
        "headline": "Threats"
      },
      "vulnerabilities_exposure": {
        "description": "Vulnerabilities, cloud findings, pentest findings, and exposure.",
        "headline": "Vulnerabilities"
      },
      "workforce_organization": {
        "description": "Roles, teams, employment, and working arrangements.",
        "headline": "Workforce"
      }
    },
    "hri_integrations": {
      "abnormal_ai": {
        "bullets": [
          {
            "label": "Real email threats",
            "text": "{label}: Detected phishing and other supported email attacks provide evidence beyond simulations."
          },
          {
            "label": "Account compromise",
            "text": "{label}: Takeover findings help identify accounts that may need urgent investigation."
          },
          {
            "label": "Targeted follow-up",
            "text": "{label}: Use relevant attack evidence to make phishing and account-security guidance more specific."
          },
          {
            "label": "Response context",
            "text": "{label}: Recorded remediation and case status help explain what has already been addressed."
          },
          {
            "label": "Read-only",
            "text": "{label}: Reads threat and response information without removing messages or taking action on accounts."
          }
        ],
        "description_long": "Abnormal AI detects email attacks and account takeover. Connect it so Moxso can use real attack signals to focus human risk follow-up on the threats people face in your environment.",
        "description_short": "Use email threats and account-takeover findings to focus security follow-up.",
        "title": "Abnormal AI"
      },
      "aikido": {
        "bullets": [
          {
            "label": "Security findings",
            "text": "{label}: Vulnerabilities and other supported issues identify areas needing technical attention."
          },
          {
            "label": "Exposure context",
            "text": "{label}: Severity and affected-resource information help explain the importance of a finding."
          },
          {
            "label": "Focused action",
            "text": "{label}: Use relevant findings to direct technical remediation and security guidance to the appropriate teams."
          },
          {
            "label": "Progress over time",
            "text": "{label}: Changes in finding status help distinguish outstanding issues from work already addressed."
          },
          {
            "label": "Read-only",
            "text": "{label}: Reads selected security findings without changing code or applying fixes."
          }
        ],
        "description_long": "Aikido Security identifies weaknesses in software and infrastructure. Connect it to bring relevant technical exposure into the context of your human risk reviews and security follow-up.",
        "description_short": "Add software and infrastructure vulnerabilities to your risk reviews.",
        "title": "Aikido Security"
      },
      "airtable": {
        "bullets": [
          {
            "label": "Account protection",
            "text": "{label}: Available authentication and privilege indicators help highlight access concerns."
          },
          {
            "label": "Real activity",
            "text": "{label}: Selected audit events provide evidence of security-relevant actions and changes."
          },
          {
            "label": "Targeted guidance",
            "text": "{label}: Use relevant events to focus advice on account protection and responsible access to shared information."
          },
          {
            "label": "Ongoing review",
            "text": "{label}: Consider account-security changes and recurring events alongside other evidence."
          },
          {
            "label": "Read-only",
            "text": "{label}: Reads selected security information without accessing table records. Enterprise API access requires an eligible plan."
          }
        ],
        "description_long": "Airtable helps teams work with shared business information. Connect it so Moxso can use relevant account-security and audit signals to inform human risk and focused follow-up.",
        "description_short": "Review account-security signals and audit activity around shared business information.",
        "title": "Airtable"
      },
      "asana": {
        "bullets": [
          {
            "label": "Access signals",
            "text": "{label}: Supported audit events identify activity affecting account and project access."
          },
          {
            "label": "Sharing changes",
            "text": "{label}: Selected membership and link-access events provide evidence about changes to collaboration access."
          },
          {
            "label": "Relevant follow-up",
            "text": "{label}: Use the circumstances of an event to focus access reviews and safe-sharing guidance."
          },
          {
            "label": "Patterns over time",
            "text": "{label}: Consider recurring access changes alongside other security evidence."
          },
          {
            "label": "Read-only",
            "text": "{label}: Reads selected audit metadata without accessing task descriptions or project contents. Audit availability depends on your Asana plan."
          }
        ],
        "description_long": "Asana helps teams organize and share work. Connect it so Moxso can use selected access and sharing events to inform human risk and support safer collaboration.",
        "description_short": "Use access and sharing events to guide safer collaboration.",
        "title": "Asana"
      },
      "atlassian": {
        "bullets": [
          {
            "label": "Account-security signals",
            "text": "{label}: Supported audit events provide evidence of access-related activity."
          },
          {
            "label": "Sensitive changes",
            "text": "{label}: Administrative actions help identify changes that deserve closer review."
          },
          {
            "label": "Targeted follow-up",
            "text": "{label}: Use relevant events to guide access reviews and account-security advice."
          },
          {
            "label": "Ongoing awareness",
            "text": "{label}: Consider recurring activity alongside other evidence before deciding on action."
          },
          {
            "label": "Read-only",
            "text": "{label}: Reads selected audit metadata without accessing Jira issue bodies or Confluence page contents."
          }
        ],
        "description_long": "Atlassian supports collaboration across your organization. Connect it so Moxso can use selected account and administrative events to inform human risk and guide relevant follow-up.",
        "description_short": "Review account and administrative activity across your collaboration tools.",
        "title": "Atlassian"
      },
      "auth0": {
        "bullets": [
          {
            "label": "Real sign-in signals",
            "text": "{label}: Selected login failures, MFA events, and attack-related events reveal access concerns."
          },
          {
            "label": "Account protection",
            "text": "{label}: Credential and security-related account changes provide additional evidence for review."
          },
          {
            "label": "Relevant follow-up",
            "text": "{label}: Use activity that can be related to employees to guide investigation and account-security advice."
          },
          {
            "label": "Patterns over time",
            "text": "{label}: Consider repeated authentication issues in the context of the application involved."
          },
          {
            "label": "Read-only",
            "text": "{label}: Reads selected activity without changing application accounts or authentication settings."
          }
        ],
        "description_long": "Auth0 handles sign-ins for your applications. Connect it so Moxso can use relevant authentication and account-security signals to inform human risk when the activity relates to your workforce.",
        "description_short": "Use workforce sign-in and account-security events to inform risk reviews.",
        "title": "Auth0"
      },
      "clerk": {
        "bullets": [
          {
            "label": "Account status",
            "text": "{label}: Available locked and banned states help identify accounts that may need closer review."
          },
          {
            "label": "Access context",
            "text": "{label}: Organization membership helps put application access into perspective."
          },
          {
            "label": "Focused follow-up",
            "text": "{label}: Use relevant account context to guide access reviews and account-security conversations."
          },
          {
            "label": "Current picture",
            "text": "{label}: Consider the latest account state alongside other evidence when deciding what needs attention."
          },
          {
            "label": "Read-only",
            "text": "{label}: Reads account and access information without changing Clerk settings. This connection does not collect sign-in events or session activity."
          }
        ],
        "description_long": "Clerk manages access to your applications. Connect it so Moxso can consider account-access context alongside human risk and help make account-security follow-up more relevant.",
        "description_short": "Use account status and organization membership to inform access reviews.",
        "title": "Clerk"
      },
      "cloudflare_zero_trust": {
        "bullets": [
          {
            "label": "Security changes",
            "text": "{label}: Selected audit events identify changes to access-related settings and resources."
          },
          {
            "label": "Access context",
            "text": "{label}: Available actor, action, and outcome details help explain the significance of an event."
          },
          {
            "label": "Focused review",
            "text": "{label}: Use sensitive changes to identify where an access review or security follow-up is needed."
          },
          {
            "label": "Ongoing visibility",
            "text": "{label}: Consider repeated administrative changes alongside other security evidence."
          },
          {
            "label": "Read-only",
            "text": "{label}: Reads selected security information without changing access policies. This connection does not provide traffic monitoring or Access sign-in telemetry."
          }
        ],
        "description_long": "Cloudflare Zero Trust protects access to company resources. Connect it so Moxso can use selected security and access-control changes as context for human risk and investigation.",
        "description_short": "Review security and access-control changes affecting company resources.",
        "title": "Cloudflare Zero Trust"
      },
      "comp_ai": {
        "bullets": [
          {
            "label": "Security findings",
            "text": "{label}: Supported findings highlight conditions that need review or remediation."
          },
          {
            "label": "Protection context",
            "text": "{label}: Available device-security checks, including encryption state, help explain the issue."
          },
          {
            "label": "Practical action",
            "text": "{label}: Use relevant evidence to focus follow-up with the employee, IT team, or control owner."
          },
          {
            "label": "Changing conditions",
            "text": "{label}: Finding and protection-status updates help distinguish continuing concerns from resolved work."
          },
          {
            "label": "Read-only",
            "text": "{label}: Reads selected security evidence without completing tasks or changing policies."
          }
        ],
        "description_long": "Comp AI tracks security controls and compliance findings. Connect it so Moxso can consider relevant protection gaps when reviewing human risk and deciding where follow-up is needed.",
        "description_short": "Use security findings and device-protection gaps to focus follow-up.",
        "title": "Comp AI"
      },
      "crowdstrike": {
        "bullets": [
          {
            "label": "Real attack signals",
            "text": "{label}: Endpoint alerts provide evidence of suspicious or malicious activity."
          },
          {
            "label": "Exposure context",
            "text": "{label}: Severity, affected resources, and available vulnerability details help put findings in perspective."
          },
          {
            "label": "Focused follow-up",
            "text": "{label}: Use relevant findings to coordinate investigation, device remediation, and employee guidance."
          },
          {
            "label": "Investigation progress",
            "text": "{label}: Finding and case status help show which concerns still need attention."
          },
          {
            "label": "Read-only",
            "text": "{label}: Reads selected security findings without containing hosts or changing investigations."
          }
        ],
        "description_long": "CrowdStrike Falcon detects threats on work devices. Connect it so Moxso can use relevant endpoint findings to inform human risk and focus follow-up on real security concerns.",
        "description_short": "Bring endpoint alerts and vulnerability findings into your risk reviews.",
        "title": "CrowdStrike"
      },
      "datadog": {
        "bullets": [
          {
            "label": "Security signals",
            "text": "{label}: Selected findings provide evidence of activity that warrants investigation."
          },
          {
            "label": "Account activity",
            "text": "{label}: Supported authentication, access, and security-configuration events add context."
          },
          {
            "label": "Targeted follow-up",
            "text": "{label}: Use employee-related evidence to guide account-security reviews and relevant advice."
          },
          {
            "label": "Patterns over time",
            "text": "{label}: Consider recurring events and finding updates alongside other risk evidence."
          },
          {
            "label": "Read-only",
            "text": "{label}: Reads selected security information without importing general application metrics or changing settings."
          }
        ],
        "description_long": "Datadog identifies security activity across monitored environments. Connect it so Moxso can use relevant security findings and account events to inform human risk reviews.",
        "description_short": "Add security findings and account activity from monitored environments.",
        "title": "Datadog"
      },
      "deel": {
        "bullets": [
          {
            "label": "Role context",
            "text": "{label}: Responsibilities and departments help put security concerns into perspective."
          },
          {
            "label": "Workforce changes",
            "text": "{label}: Employment-state changes provide context for reviewing whether access remains appropriate."
          },
          {
            "label": "Relevant guidance",
            "text": "{label}: Consider someone’s working context when choosing security advice and awareness topics."
          },
          {
            "label": "Focused follow-up",
            "text": "{label}: Use role and lifecycle context alongside security evidence to guide conversations with the right people."
          },
          {
            "label": "Read-only",
            "text": "{label}: Reads relevant workforce information without changing employment records or processing payroll."
          }
        ],
        "description_long": "Deel helps manage a workforce across different roles and working arrangements. Connect it so Moxso can consider relevant workforce context when reviewing human risk and planning security follow-up.",
        "description_short": "Add workforce context from global employee records.",
        "title": "Deel"
      },
      "drata": {
        "bullets": [
          {
            "label": "Protection signals",
            "text": "{label}: Supported encryption, antivirus, firewall, update, and screen-lock checks help identify weaknesses."
          },
          {
            "label": "Everyday security",
            "text": "{label}: Password-manager and other available control checks add context for practical security habits."
          },
          {
            "label": "Targeted follow-up",
            "text": "{label}: Use specific gaps to decide what needs employee guidance and what requires IT action."
          },
          {
            "label": "Ongoing improvement",
            "text": "{label}: Consider changing check results alongside other human risk evidence."
          },
          {
            "label": "Read-only",
            "text": "{label}: Reads selected security evidence without changing control results or device settings."
          }
        ],
        "description_long": "Drata collects evidence about workplace security controls. Connect it so Moxso can use relevant control gaps as context for human risk and more focused follow-up.",
        "description_short": "Use device and workplace security checks to identify protection gaps.",
        "title": "Drata"
      },
      "duo": {
        "bullets": [
          {
            "label": "Real authentication signals",
            "text": "{label}: Successful, denied, failed, and reported-fraud events help identify activity needing review."
          },
          {
            "label": "Useful context",
            "text": "{label}: Available authentication factors and result reasons help explain what happened."
          },
          {
            "label": "Targeted guidance",
            "text": "{label}: Focus advice on recognizing unexpected prompts and protecting access where relevant events occur."
          },
          {
            "label": "Repeated activity",
            "text": "{label}: Consider recurring denials or failures alongside other evidence before deciding on action."
          },
          {
            "label": "Read-only",
            "text": "{label}: Reads authentication and selected security activity without approving requests or changing Duo policies."
          }
        ],
        "description_long": "Duo helps protect accounts with multi-factor authentication. Connect it so Moxso can use real authentication outcomes to guide follow-up on MFA habits and account security.",
        "description_short": "Use authentication outcomes to guide MFA and account-security follow-up.",
        "title": "Duo"
      },
      "fortinet_fortianalyzer": {
        "bullets": [
          {
            "label": "Access signals",
            "text": "{label}: Supported authentication outcomes help identify account activity worth investigating."
          },
          {
            "label": "Sensitive changes",
            "text": "{label}: Administrative events add evidence of changes affecting your environment."
          },
          {
            "label": "Focused follow-up",
            "text": "{label}: Use relevant account activity to guide investigation and access-security advice."
          },
          {
            "label": "Recurring patterns",
            "text": "{label}: Consider repeated access problems alongside other signals before choosing a response."
          },
          {
            "label": "Data access",
            "text": "{label}: Uses log-search tasks to read selected events without changing firewall configuration."
          }
        ],
        "description_long": "FortiAnalyzer collects security activity from your Fortinet environment. Connect it so Moxso can use selected access and administrative events to inform human risk reviews.",
        "description_short": "Review authentication and administrative events from your Fortinet environment.",
        "title": "FortiAnalyzer"
      },
      "github_enterprise": {
        "bullets": [
          {
            "label": "Sensitive changes",
            "text": "{label}: Selected audit events highlight changes to access, permissions, and account security."
          },
          {
            "label": "Code-access activity",
            "text": "{label}: Supported Git events provide additional evidence about access to repositories."
          },
          {
            "label": "Relevant guidance",
            "text": "{label}: Use employee-related events to focus advice on credential protection and secure development practices."
          },
          {
            "label": "Patterns over time",
            "text": "{label}: Consider repeated access activity and sensitive changes in their working context."
          },
          {
            "label": "Read-only",
            "text": "{label}: Reads selected activity metadata without accessing repository source code."
          }
        ],
        "description_long": "GitHub Enterprise protects access to your source code and development workflows. Connect it so Moxso can use relevant developer-account activity to inform human risk and focused security follow-up.",
        "description_short": "Use developer-account and repository-access activity to guide security follow-up.",
        "title": "GitHub Enterprise"
      },
      "google_workspace": {
        "bullets": [
          {
            "label": "Real activity signals",
            "text": "{label}: Selected sign-in, account-security, and administrator events highlight activity worth reviewing."
          },
          {
            "label": "Sharing risk",
            "text": "{label}: Supported downloads, sharing changes, and application-authorization events provide evidence of how information is accessed."
          },
          {
            "label": "Targeted follow-up",
            "text": "{label}: Focus guidance on account protection, third-party apps, and safe sharing where the evidence points to a need."
          },
          {
            "label": "Patterns over time",
            "text": "{label}: Consider repeated events and changing access behavior alongside awareness results."
          },
          {
            "label": "Read access",
            "text": "{label}: Reads selected security metadata without reading Gmail messages or Drive file contents."
          }
        ],
        "description_long": "Google Workspace is where people sign in, share files, and authorize applications. Connect it so Moxso can use security-relevant activity to inform human risk and make follow-up more relevant to everyday work.",
        "description_short": "Review sign-in, sharing, and application-access activity to inform human risk.",
        "title": "Google Workspace"
      },
      "gusto": {
        "bullets": [
          {
            "label": "Role awareness",
            "text": "{label}: Job and department context help explain the work behind an account’s activity."
          },
          {
            "label": "Employment changes",
            "text": "{label}: Available employment-state information supports conversations about access as circumstances change."
          },
          {
            "label": "Relevant guidance",
            "text": "{label}: Consider responsibilities when choosing awareness topics and practical security advice."
          },
          {
            "label": "Focused reviews",
            "text": "{label}: Use employment context alongside security signals when deciding what needs attention."
          },
          {
            "label": "Read-only",
            "text": "{label}: Reads relevant employment information without changing compensation or running payroll."
          }
        ],
        "description_long": "Gusto maintains employment information as people join, change roles, and leave. Connect it so Moxso can consider that context when reviewing human risk and making follow-up relevant to someone’s responsibilities.",
        "description_short": "Add workforce context from employee records.",
        "title": "Gusto"
      },
      "hibob": {
        "bullets": [
          {
            "label": "Role context",
            "text": "{label}: Responsibilities and departments help put security activity into perspective."
          },
          {
            "label": "Working environment",
            "text": "{label}: Available work-site information adds context for understanding someone’s circumstances."
          },
          {
            "label": "Lifecycle changes",
            "text": "{label}: Employment-state changes can inform discussions about account access and security responsibilities."
          },
          {
            "label": "Relevant follow-up",
            "text": "{label}: Use the working context alongside actual security evidence to guide practical advice."
          },
          {
            "label": "Read-only",
            "text": "{label}: Reads relevant workforce information without changing HR records or accessing performance reviews through this connection."
          }
        ],
        "description_long": "HiBob provides context about people’s roles and working environment. Connect it so Moxso can consider that context alongside human risk and make security follow-up more relevant to everyday work.",
        "description_short": "Add employee and job-role context from your HR system.",
        "title": "HiBob"
      },
      "hubspot": {
        "bullets": [
          {
            "label": "Sign-in signals",
            "text": "{label}: Successful and failed login events help identify account-access concerns."
          },
          {
            "label": "Sensitive actions",
            "text": "{label}: Selected permission, credential, integration, and data-movement events add context."
          },
          {
            "label": "Relevant guidance",
            "text": "{label}: Use employee-related activity to focus advice on account security and handling customer information."
          },
          {
            "label": "Recurring issues",
            "text": "{label}: Consider repeated events alongside other risk evidence before choosing a response."
          },
          {
            "label": "Read-only",
            "text": "{label}: Reads selected security activity without accessing CRM contacts, deals, or marketing content."
          }
        ],
        "description_long": "HubSpot supports work with customer information. Connect it so Moxso can use relevant account-access and security events to inform human risk and make follow-up specific to that work.",
        "description_short": "Review login and security activity around access to customer information.",
        "title": "HubSpot"
      },
      "iru": {
        "bullets": [
          {
            "label": "Protection coverage",
            "text": "{label}: Management and agent-status indicators help identify devices that need attention."
          },
          {
            "label": "Device availability",
            "text": "{label}: Last check-in and missing-device indicators provide context about whether protection information is current."
          },
          {
            "label": "Relevant activity",
            "text": "{label}: Selected security-related audit events help explain changes that warrant review."
          },
          {
            "label": "Practical follow-up",
            "text": "{label}: Use protection gaps to guide action with employees and IT."
          },
          {
            "label": "Read-only",
            "text": "{label}: Reads selected device-security information without running actions on devices."
          }
        ],
        "description_long": "Iru helps organizations manage and protect work devices. Connect it so Moxso can consider gaps in device-management coverage when reviewing human risk.",
        "description_short": "Identify gaps in device-management coverage and agent protection.",
        "title": "Iru"
      },
      "jamf_pro": {
        "bullets": [
          {
            "label": "Device protection",
            "text": "{label}: Supported FileVault and passcode information can highlight security settings that need attention."
          },
          {
            "label": "Management coverage",
            "text": "{label}: Available management state helps establish whether a device is under organizational control."
          },
          {
            "label": "Practical follow-up",
            "text": "{label}: Protection gaps can guide conversations with employees and the IT team responsible for their devices."
          },
          {
            "label": "Informed reviews",
            "text": "{label}: Consider device conditions alongside other evidence rather than treating a failed control as proof of unsafe behavior."
          },
          {
            "label": "Connection status",
            "text": "{label}: This integration is not currently available to connect in the registered provider catalog."
          }
        ],
        "description_long": "Availability: Currently unavailable. Jamf Pro helps protect the Apple devices people use for work. Device-security information can help put human risk into context and distinguish protection gaps from issues that call for employee guidance.",
        "description_short": "Apple device management. This integration is currently unavailable.",
        "title": "Jamf Pro"
      },
      "jumpcloud": {
        "bullets": [
          {
            "label": "Authentication evidence",
            "text": "{label}: Selected Directory Insights events show successful and failed access attempts."
          },
          {
            "label": "Sensitive activity",
            "text": "{label}: Supported administrative and privileged-access events highlight changes that deserve attention."
          },
          {
            "label": "Relevant follow-up",
            "text": "{label}: Use account-related evidence to guide investigation and access-security guidance."
          },
          {
            "label": "Patterns over time",
            "text": "{label}: Review recurring authentication issues and sensitive changes alongside other signals."
          },
          {
            "label": "Read-only",
            "text": "{label}: Reads selected security information without changing JumpCloud settings."
          }
        ],
        "description_long": "JumpCloud helps secure access to applications and devices. Connect it so Moxso can use real authentication and administrative signals to inform human risk and focus follow-up on relevant access concerns.",
        "description_short": "Use authentication and administrative events to review access risks.",
        "title": "JumpCloud"
      },
      "lattice": {
        "bullets": [
          {
            "label": "Role awareness",
            "text": "{label}: Job and department context help explain someone’s responsibilities."
          },
          {
            "label": "Account lifecycle",
            "text": "{label}: Available account-state information adds context as people join or leave an application."
          },
          {
            "label": "Relevant guidance",
            "text": "{label}: Consider working responsibilities when choosing security topics and practical advice."
          },
          {
            "label": "Focused reviews",
            "text": "{label}: Use organizational context alongside security evidence when discussing access and follow-up."
          },
          {
            "label": "Read-only",
            "text": "{label}: Reads relevant account and organizational information without accessing performance reviews, feedback, or compensation through this connection."
          }
        ],
        "description_long": "Lattice provides context about roles and organizational responsibilities. Connect it so Moxso can consider that context when reviewing human risk and choosing relevant security follow-up.",
        "description_short": "Add context about employee profiles and team structure.",
        "title": "Lattice"
      },
      "linear": {
        "bullets": [
          {
            "label": "Account changes",
            "text": "{label}: Supported audit events identify security-relevant changes such as account suspension."
          },
          {
            "label": "Access context",
            "text": "{label}: Available actor and action details help explain what happened."
          },
          {
            "label": "Focused follow-up",
            "text": "{label}: Use relevant events to guide account-access reviews and security conversations."
          },
          {
            "label": "Patterns over time",
            "text": "{label}: Consider recurring changes alongside other security signals."
          },
          {
            "label": "Read-only",
            "text": "{label}: Reads selected audit metadata without accessing issue contents. Audit logs require an eligible Enterprise plan."
          }
        ],
        "description_long": "Linear supports product and engineering collaboration. Connect it so Moxso can use selected account and access changes to inform human risk and help focus security follow-up.",
        "description_short": "Review account and access changes across product and engineering teams.",
        "title": "Linear"
      },
      "microsoft_defender_xdr": {
        "bullets": [
          {
            "label": "Real threat signals",
            "text": "{label}: Alerts and incidents identify activity that Microsoft considers suspicious or malicious."
          },
          {
            "label": "Exposure context",
            "text": "{label}: Available endpoint findings and vulnerabilities help explain the circumstances around an event."
          },
          {
            "label": "Targeted follow-up",
            "text": "{label}: Prioritize investigation and relevant security guidance where findings relate to people or their work devices."
          },
          {
            "label": "Investigation progress",
            "text": "{label}: Changes in finding status help distinguish active concerns from resolved work."
          },
          {
            "label": "Read-only",
            "text": "{label}: Reads selected findings without isolating devices, closing incidents, or applying fixes."
          }
        ],
        "description_long": "Microsoft Defender XDR identifies threats across your Microsoft environment. Connect it so Moxso can use relevant alerts and incidents to ground human risk reviews in real security events.",
        "description_short": "Bring Microsoft security alerts, incidents, and vulnerabilities into risk reviews.",
        "title": "Microsoft Defender XDR"
      },
      "microsoft_entra": {
        "bullets": [
          {
            "label": "Real attack signals",
            "text": "{label}: Leaked credentials, password spray, unusual travel, and unfamiliar sign-ins can reveal accounts that need attention."
          },
          {
            "label": "Human risk context",
            "text": "{label}: Risk levels and detection details help put suspicious activity into perspective."
          },
          {
            "label": "Targeted follow-up",
            "text": "{label}: Focus investigation and account-security guidance on the people affected by relevant events."
          },
          {
            "label": "Risk over time",
            "text": "{label}: Changes from active risk to remediated or dismissed help inform what still needs attention."
          },
          {
            "label": "Read-only",
            "text": "{label}: Reads risky-user state and risk detections. Signal detail depends on Microsoft licensing; premium detections can require Entra ID P2."
          }
        ],
        "description_long": "Entra ID Protection flags sign-ins and accounts that look compromised. Connect it so Moxso can use real identity-risk signals to inform follow-up, based on what happens in your environment alongside simulations.",
        "description_short": "Use risky sign-ins and account-compromise signals to focus security follow-up.",
        "title": "Microsoft Entra ID Protection"
      },
      "microsoft_intune": {
        "bullets": [
          {
            "label": "Device-security signals",
            "text": "{label}: Available compliance and encryption states highlight protection gaps."
          },
          {
            "label": "Relevant changes",
            "text": "{label}: Selected management events add context about actions affecting device security."
          },
          {
            "label": "Practical follow-up",
            "text": "{label}: Help distinguish a device issue that needs IT attention from a topic suited to employee guidance."
          },
          {
            "label": "Changing posture",
            "text": "{label}: Consider current protection status and recurring gaps when reviewing risk."
          },
          {
            "label": "Read-only",
            "text": "{label}: Reads selected device-security and audit information without changing device settings. Requires the relevant Intune access and license."
          }
        ],
        "description_long": "Microsoft Intune helps protect the devices people use for work. Connect it so Moxso can consider endpoint-security posture alongside human risk and guide practical follow-up.",
        "description_short": "Review device compliance and encryption gaps alongside human risk.",
        "title": "Microsoft Intune"
      },
      "microsoft_purview": {
        "bullets": [
          {
            "label": "Data-protection signals",
            "text": "{label}: Supported DLP events identify activity that triggered a data-handling rule."
          },
          {
            "label": "Additional risk context",
            "text": "{label}: Selected insider-risk events add evidence for investigation where available."
          },
          {
            "label": "Relevant guidance",
            "text": "{label}: Use the circumstances of an event to focus advice on safe handling and sharing of company information."
          },
          {
            "label": "Informed review",
            "text": "{label}: Consider repeated signals and their context before drawing conclusions about behavior or intent."
          },
          {
            "label": "Limited access",
            "text": "{label}: Reads selected activity metadata and may initialize the required feeds. It does not change data-protection policies."
          }
        ],
        "description_long": "Microsoft Purview helps identify risky handling of sensitive information. Connect it so Moxso can use relevant data-protection signals to guide human risk reviews and more focused follow-up.",
        "description_short": "Use data-protection and insider-risk events to guide safe information handling.",
        "title": "Microsoft Purview"
      },
      "microsoft_sentinel": {
        "bullets": [
          {
            "label": "Real incidents",
            "text": "{label}: Severity and incident details provide evidence of security concerns already under investigation."
          },
          {
            "label": "Useful context",
            "text": "{label}: Available source and attack information help explain why an incident matters."
          },
          {
            "label": "Coordinated follow-up",
            "text": "{label}: Use relevant incident evidence to align employee guidance with the security team’s response."
          },
          {
            "label": "Investigation progress",
            "text": "{label}: Status changes help distinguish new, active, and resolved concerns."
          },
          {
            "label": "Read-only",
            "text": "{label}: Reads incident information without changing investigations or running general log searches."
          }
        ],
        "description_long": "Microsoft Sentinel brings security incidents together for investigation. Connect it so Moxso can consider relevant incidents alongside human risk and help align follow-up with your security team.",
        "description_short": "Use security incidents and investigation status to coordinate follow-up.",
        "title": "Microsoft Sentinel"
      },
      "monday": {
        "bullets": [
          {
            "label": "Account status",
            "text": "{label}: Available active and inactive states help identify accounts that may need review."
          },
          {
            "label": "Access context",
            "text": "{label}: Account types and team relationships help put application access into perspective."
          },
          {
            "label": "Focused reviews",
            "text": "{label}: Consider account context alongside security signals when deciding where attention is needed."
          },
          {
            "label": "Relevant follow-up",
            "text": "{label}: Use that context to guide conversations about account security and appropriate access."
          },
          {
            "label": "Read-only",
            "text": "{label}: Reads account-access information without changing monday.com settings or accessing board and item contents."
          }
        ],
        "description_long": "monday.com helps teams organize work and collaborate across departments. Connect it so Moxso can consider application-access context alongside human risk and make account-security follow-up more relevant.",
        "description_short": "Use account status and team relationships to inform access reviews.",
        "title": "monday.com"
      },
      "new_relic": {
        "bullets": [
          {
            "label": "Access context",
            "text": "{label}: Available account relationships help put access to your monitoring environment into perspective."
          },
          {
            "label": "Organizational context",
            "text": "{label}: Group membership provides background for reviewing how access is organized."
          },
          {
            "label": "Focused reviews",
            "text": "{label}: Consider application access alongside other evidence when deciding what needs attention."
          },
          {
            "label": "Relevant follow-up",
            "text": "{label}: Use access context to guide account-security conversations with the responsible teams."
          },
          {
            "label": "Read-only",
            "text": "{label}: Reads account-access information without changing New Relic settings. This connection does not collect monitoring alerts, application telemetry, or audit events."
          }
        ],
        "description_long": "New Relic supports the teams responsible for monitoring your systems. Connect it so Moxso can consider application-access context alongside human risk and help focus account-security reviews.",
        "description_short": "Add user-directory and group-membership context from New Relic.",
        "title": "New Relic"
      },
      "okta": {
        "bullets": [
          {
            "label": "Authentication signals",
            "text": "{label}: Sign-in outcomes and selected security events provide evidence of how accounts are being used."
          },
          {
            "label": "Sensitive changes",
            "text": "{label}: Account and permission changes help identify access that deserves closer review."
          },
          {
            "label": "Targeted follow-up",
            "text": "{label}: Use relevant events to guide investigation and practical account-security advice."
          },
          {
            "label": "Recurring issues",
            "text": "{label}: Consider repeated authentication problems alongside other human risk evidence."
          },
          {
            "label": "Read-only",
            "text": "{label}: Reads selected security information without changing Okta accounts or access policies."
          }
        ],
        "description_long": "Okta protects access to company applications. Connect it so Moxso can use authentication and account-security signals to understand real access risks and guide more relevant follow-up.",
        "description_short": "Review authentication and account-security events to understand access risks.",
        "title": "Okta"
      },
      "oneleet": {
        "bullets": [
          {
            "label": "Validated weaknesses",
            "text": "{label}: Available pentest findings describe issues identified during security testing."
          },
          {
            "label": "Risk context",
            "text": "{label}: Priority, affected targets, and remediation guidance help explain what needs attention."
          },
          {
            "label": "Focused action",
            "text": "{label}: Use relevant findings to guide technical remediation and security conversations with the responsible teams."
          },
          {
            "label": "Progress over time",
            "text": "{label}: Finding status helps distinguish open issues from work already addressed."
          },
          {
            "label": "Read-only",
            "text": "{label}: Reads findings without running tests or changing their resolution state."
          }
        ],
        "description_long": "Oneleet identifies security weaknesses through penetration testing and compliance work. Connect it to add relevant technical findings to the context used for human risk reviews and security follow-up.",
        "description_short": "Add penetration-test findings and remediation context to security reviews.",
        "title": "Oneleet"
      },
      "onepassword": {
        "bullets": [
          {
            "label": "Sign-in signals",
            "text": "{label}: Successful and failed attempts provide evidence of account-access activity."
          },
          {
            "label": "Sensitive actions",
            "text": "{label}: Supported item-use and administrative events add context about how the password manager is used."
          },
          {
            "label": "Targeted follow-up",
            "text": "{label}: Focus credential-security guidance and investigation on relevant activity."
          },
          {
            "label": "Patterns over time",
            "text": "{label}: Consider repeated access issues alongside other account-security evidence."
          },
          {
            "label": "No secret contents",
            "text": "{label}: Reads activity metadata without accessing passwords, secure notes, or vault documents."
          }
        ],
        "description_long": "1Password helps people protect and use their credentials. Connect it so Moxso can use sign-in and password-manager activity to inform human risk without accessing the secrets stored in your vaults.",
        "description_short": "Review sign-in and password-manager activity without accessing stored secrets.",
        "title": "1Password"
      },
      "ping_one": {
        "bullets": [
          {
            "label": "Account status",
            "text": "{label}: Available enabled-account state provides context for reviewing access."
          },
          {
            "label": "Access relationships",
            "text": "{label}: Group membership helps explain how accounts are organized."
          },
          {
            "label": "Focused reviews",
            "text": "{label}: Consider access context alongside security events from your other connected tools."
          },
          {
            "label": "Relevant follow-up",
            "text": "{label}: Use the combined evidence to guide account-security conversations and access reviews."
          },
          {
            "label": "Read-only",
            "text": "{label}: Reads account-access information without changing PingOne policies. This connection does not collect authentication events."
          }
        ],
        "description_long": "PingOne helps manage access to company applications. Connect it so Moxso can consider relevant account-access context alongside human risk and guide more focused security reviews.",
        "description_short": "Add user-directory and membership context from PingOne.",
        "title": "PingOne"
      },
      "remote": {
        "bullets": [
          {
            "label": "Role context",
            "text": "{label}: Available responsibilities and department information help put security concerns into perspective."
          },
          {
            "label": "Working arrangements",
            "text": "{label}: Country and employment-model context can help make advice appropriate to someone’s circumstances."
          },
          {
            "label": "Employment changes",
            "text": "{label}: Available lifecycle information supports conversations about access when working arrangements change."
          },
          {
            "label": "Relevant follow-up",
            "text": "{label}: Consider workforce context alongside security evidence when choosing practical guidance."
          },
          {
            "label": "Read-only",
            "text": "{label}: Reads relevant employment information without changing contracts or processing payroll."
          }
        ],
        "description_long": "Remote helps manage people working across countries and employment arrangements. Connect it so Moxso can consider relevant working context when reviewing human risk and planning security follow-up.",
        "description_short": "Add workforce context for global and distributed teams.",
        "title": "Remote"
      },
      "rippling": {
        "bullets": [
          {
            "label": "Role awareness",
            "text": "{label}: Job and working-context information help explain the responsibilities behind account activity."
          },
          {
            "label": "Employment context",
            "text": "{label}: Available workforce state adds background for reviewing access as circumstances change."
          },
          {
            "label": "Relevant guidance",
            "text": "{label}: Consider someone’s responsibilities when choosing security advice and awareness topics."
          },
          {
            "label": "Focused reviews",
            "text": "{label}: Use employment context alongside security evidence to inform access discussions and follow-up."
          },
          {
            "label": "Read-only",
            "text": "{label}: Reads relevant workforce information without changing payroll, benefits, or access settings in Rippling."
          }
        ],
        "description_long": "Rippling maintains context about people’s roles and employment. Connect it so Moxso can consider that context alongside human risk and make security follow-up relevant as responsibilities change.",
        "description_short": "Add employee and workforce context from Rippling.",
        "title": "Rippling"
      },
      "sentinel_one": {
        "bullets": [
          {
            "label": "Real threat signals",
            "text": "{label}: Threats and alerts identify suspicious activity affecting work devices."
          },
          {
            "label": "Risk context",
            "text": "{label}: Available severity, classification, and vulnerability information help explain what needs attention."
          },
          {
            "label": "Focused action",
            "text": "{label}: Use the evidence to coordinate investigation and decide whether follow-up belongs with IT, security, or an employee."
          },
          {
            "label": "Changing status",
            "text": "{label}: Finding updates help distinguish continuing concerns from activity already addressed."
          },
          {
            "label": "Read-only",
            "text": "{label}: Reads selected security information without isolating devices or remediating threats."
          }
        ],
        "description_long": "SentinelOne detects and investigates endpoint threats. Connect it so Moxso can use relevant threat signals to inform human risk and help focus security follow-up.",
        "description_short": "Use endpoint threats and vulnerability findings to focus security follow-up.",
        "title": "SentinelOne"
      },
      "slack": {
        "bullets": [
          {
            "label": "Real account activity",
            "text": "{label}: Supported login and access events help reveal account-security concerns."
          },
          {
            "label": "Sharing signals",
            "text": "{label}: Selected file-related and sharing events add evidence about how information is handled."
          },
          {
            "label": "Targeted guidance",
            "text": "{label}: Focus advice on safe collaboration, account protection, and information sharing where relevant events occur."
          },
          {
            "label": "Patterns over time",
            "text": "{label}: Consider recurring activity alongside awareness and simulation results."
          },
          {
            "label": "Read-only",
            "text": "{label}: Reads selected audit metadata without reading messages or file contents. Audit access requires an eligible Slack Enterprise organization."
          }
        ],
        "description_long": "Slack is where people collaborate and share information throughout the day. Connect it so Moxso can use relevant sign-in and sharing signals to inform human risk and more practical follow-up.",
        "description_short": "Use sign-in and sharing activity to guide safer everyday collaboration.",
        "title": "Slack"
      },
      "splunk": {
        "bullets": [
          {
            "label": "Security findings",
            "text": "{label}: Selected findings highlight activity that your security monitoring has identified for attention."
          },
          {
            "label": "Account activity",
            "text": "{label}: Supported authentication and administrative events provide additional evidence for investigation."
          },
          {
            "label": "Relevant follow-up",
            "text": "{label}: Use findings related to people or their accounts to guide security action and advice."
          },
          {
            "label": "Changing risk",
            "text": "{label}: Updated finding state helps put ongoing concerns in context."
          },
          {
            "label": "Data access",
            "text": "{label}: Uses searches to read selected security information without changing the underlying findings."
          }
        ],
        "description_long": "Splunk brings security evidence together from across your environment. Connect it so Moxso can use selected findings and account-related events to inform human risk and focused follow-up.",
        "description_short": "Bring security findings and account activity together for human risk reviews.",
        "title": "Splunk"
      },
      "statuspage": {
        "bullets": [
          {
            "label": "Service incidents",
            "text": "{label}: Published incident information explains disruptions reported by the service owner."
          },
          {
            "label": "Affected services",
            "text": "{label}: Component status helps identify which parts of a service are affected."
          },
          {
            "label": "Planned maintenance",
            "text": "{label}: Maintenance notices provide context for expected interruptions."
          },
          {
            "label": "Response progress",
            "text": "{label}: Incident updates help explain whether an issue is being investigated or has been resolved."
          },
          {
            "label": "Operational context",
            "text": "{label}: A service disruption alone does not establish an account compromise or unsafe employee behavior."
          }
        ],
        "description_long": "Editorial status: Draft; the Moxso integration scope is not verified in this repository. Statuspage communicates service incidents and maintenance. Service-status information can provide useful background during security follow-up, helping teams understand when an access problem coincides with a known disruption.",
        "description_short": "Service-incident and maintenance context. Integration scope is not yet verified.",
        "title": "Statuspage"
      },
      "tailscale": {
        "bullets": [
          {
            "label": "Access posture",
            "text": "{label}: Device authorization and external-access status help identify conditions worth checking."
          },
          {
            "label": "Protection context",
            "text": "{label}: Key-expiry and connection-state information provide additional context around network access."
          },
          {
            "label": "Practical follow-up",
            "text": "{label}: Use relevant access concerns to guide device-security checks with the responsible team."
          },
          {
            "label": "Current conditions",
            "text": "{label}: Review access posture as it changes rather than treating an old snapshot as permanent."
          },
          {
            "label": "Read-only",
            "text": "{label}: Reads device-access information without changing network authorization or capturing traffic."
          }
        ],
        "description_long": "Tailscale connects devices to your private network. Connect it to add network-access posture to the security context used when reviewing human risk.",
        "description_short": "Review device authorization and network-access protection alongside human risk.",
        "title": "Tailscale"
      },
      "vanta": {
        "bullets": [
          {
            "label": "Security-control signals",
            "text": "{label}: Available encryption, screen-lock, antivirus, and password-manager checks highlight gaps in protection."
          },
          {
            "label": "Clearer context",
            "text": "{label}: Individual check results provide more useful detail than a single compliance label."
          },
          {
            "label": "Practical follow-up",
            "text": "{label}: Use relevant gaps to guide action with employees and IT."
          },
          {
            "label": "Changes over time",
            "text": "{label}: Consider current check results and recurring failures when reviewing risk."
          },
          {
            "label": "Read-only",
            "text": "{label}: Reads selected security evidence without changing compliance results or device settings."
          }
        ],
        "description_long": "Vanta checks whether important security controls are in place. Connect it so Moxso can consider relevant protection gaps alongside human risk and help make follow-up practical.",
        "description_short": "Use encryption, screen-lock, and endpoint checks to identify protection gaps.",
        "title": "Vanta"
      },
      "wiz": {
        "bullets": [
          {
            "label": "Cloud-security findings",
            "text": "{label}: Supported issues highlight exposures that need investigation or remediation."
          },
          {
            "label": "Useful context",
            "text": "{label}: Severity and affected-resource information help explain the circumstances behind a finding."
          },
          {
            "label": "Focused action",
            "text": "{label}: Use relevant exposure to inform ownership discussions and technical follow-up."
          },
          {
            "label": "Changing exposure",
            "text": "{label}: Finding updates help distinguish active issues from resolved work."
          },
          {
            "label": "Read-only",
            "text": "{label}: Reads selected cloud findings without changing cloud configuration."
          }
        ],
        "description_long": "Wiz identifies security risks in cloud environments. Connect it to add relevant cloud exposure to the context used for human risk reviews and coordinated security follow-up.",
        "description_short": "Add cloud-security findings and exposure context to your risk reviews.",
        "title": "Wiz"
      },
      "workos": {
        "bullets": [
          {
            "label": "Account state",
            "text": "{label}: Available account-status information provides context for reviewing application access."
          },
          {
            "label": "Access relationships",
            "text": "{label}: Organization and group relationships help put account access into perspective."
          },
          {
            "label": "Focused reviews",
            "text": "{label}: Consider account context alongside security events from other connected tools."
          },
          {
            "label": "Relevant follow-up",
            "text": "{label}: Use the combined evidence to guide access reviews and account-security conversations."
          },
          {
            "label": "Read-only",
            "text": "{label}: Reads directory-access information without changing accounts. This connection does not collect sign-in events or session activity."
          }
        ],
        "description_long": "WorkOS connects applications with organizational access systems. Connect it so Moxso can consider relevant account-access context alongside human risk and help focus security reviews.",
        "description_short": "Add directory and organization-membership context from WorkOS.",
        "title": "WorkOS"
      }
    },
    "human_risk_intelligence": {
      "assignment": {
        "rule_labels": {
          "cooldown_days": "Cooldown window",
          "interval_days": "Assignment interval",
          "respect_mandatory_training": "Respect mandatory training"
        }
      },
      "assignment_status": {
        "awaiting_assignment": "Not scheduled yet",
        "completed": "Completed",
        "due_soon": "Due soon",
        "overdue": "Overdue"
      },
      "intervention": {
        "notification_type": {
          "hri_employee_intervention_email": "Employee intervention email",
          "hri_intervention_email": "Employee intervention email"
        }
      },
      "onboarding": {
        "glance": {
          "notifications_behavior": {
            "continue_until_completion": "Notifications will be sent after deadline has passed until completion",
            "stop_after_deadline": "Notifications will stop once the deadline has passed"
          },
          "notifications_frequency": {
            "intense": "Intense",
            "loose": "Loose",
            "normal": "Normal"
          }
        }
      },
      "polarity": {
        "neutral": "Neutral",
        "risky": "Risky",
        "vigilant": "Vigilant"
      },
      "risk_level": {
        "critical": "Critical",
        "high": "High",
        "low": "Low",
        "minimal": "Minimal",
        "moderate": "Moderate",
        "severe": "Severe"
      },
      "risk_matrix": {
        "columns": {
          "somewhat_likely": "Somewhat likely",
          "very_likely": "Very likely",
          "very_unlikely": "Very unlikely"
        },
        "rows": {
          "high": "High",
          "low": "Low",
          "medium": "Medium"
        }
      },
      "settings": {
        "interventions": {
          "actions": {
            "assignment": "Assign new lesson",
            "notify_admin": "Notify admins",
            "notify_employee": "Notify employee",
            "notify_manager": "Notify manager"
          },
          "groups": {
            "breach_exposure": {
              "description": "Respond when an employee appears in a known data breach.",
              "title": "Breach exposure"
            },
            "critical_phishing_interactions": {
              "description": "Respond when an employee performs a critical phishing action, such as submitting credentials, opening an attachment, or replying.",
              "title": "Critical phishing interactions"
            },
            "phishing_interactions": {
              "description": "Respond when an employee clicks a link in an email or SMS phishing simulation.",
              "title": "Phishing interactions"
            },
            "simulation_non_reporting": {
              "description": "Respond when an employee does not report a phishing simulation within 2 or 7 days.",
              "title": "Simulation non-reporting"
            },
            "training_inactivity": {
              "description": "Respond when an employee's required training is overdue.",
              "title": "Training inactivity"
            }
          },
          "severities": {
            "high": "High (60+ days overdue)",
            "low": "Low (7 days overdue)",
            "medium": "Medium (30 days overdue)"
          },
          "timeframe_options": {
            "intense": "Intense",
            "loose": "Loose",
            "normal": "Normal"
          }
        },
        "strategy": {
          "compliance": {
            "description": "Assigns training to meet documented requirements in ISO 27001, SOC 2, and related compliance frameworks.",
            "glance": "to meet your organization's compliance requirements",
            "title": "Compliance training"
          },
          "group": {
            "description": "Adjusts training using aggregated behavior trends across teams and departments, without targeting individuals.",
            "glance": "based on aggregated behavioral risk signals",
            "title": "Group-based training"
          },
          "intervention": {
            "description": "Deploys targeted interventions driven by employees’ behavioral signals. Provides tailored training and corrective actions to address identified risk patterns and measurably reduce organizational exposure.",
            "title": "Intervention strategy"
          },
          "risk": {
            "description": "Assigns training based on job role, access level, and responsibility-driven risk aligned with NIS2 expectations.",
            "glance": "based on each employee's role risk profile",
            "title": "Risk-based training"
          }
        },
        "summary_signals": {
          "impact": {
            "high": "High impact",
            "low": "Low impact",
            "medium": "Medium impact"
          },
          "signal_labels": {
            "failed_simulation": "Failed phishing simulation",
            "low_score": "Low training score"
          }
        }
      },
      "trend": {
        "down": "Down",
        "stable": "Stable",
        "up": "Up"
      }
    },
    "indicators": {
      "A_10": "A.10",
      "A_11": "A.11",
      "A_13": "A.13",
      "A_14": "A.14",
      "A_15": "A.15",
      "A_16": "A.16",
      "A_17": "A.17",
      "A_19": "A.19",
      "A_21_2_A": "A.21(2)(a)",
      "A_21_2_B": "A.21(2)(b)",
      "A_21_2_C": "A.21(2)(c)",
      "A_21_2_D": "A.21(2)(d)",
      "A_21_2_F": "A.21(2)(f)",
      "A_21_2_G": "A.21(2)(g)",
      "A_21_2_I": "A.21(2)(i)",
      "A_23": "A.23",
      "A_24": "A.24",
      "A_26": "A.26",
      "A_28": "A.28",
      "A_30": "A.30",
      "A_32": "A.32",
      "A_33": "A.33",
      "A_34": "A.34",
      "A_39_1_B": "A.39(1)(b)",
      "A_4": "A.4",
      "A_5": "A.5",
      "A_5_15": "A.5.15",
      "A_5_17": "A.5.17",
      "A_5_1_C": "A.5(1)(c)",
      "A_5_1_E": "A.5(1)(e)",
      "A_5_1_F": "A.5(1)(f)",
      "A_5_23": "A.5.23",
      "A_5_24": "A.5.24",
      "A_5_25": "A.5.25",
      "A_5_26": "A.5.26",
      "A_5_27": "A.5.27",
      "A_5_28": "A.5.28",
      "A_5_31": "A.5.31",
      "A_5_34": "A.5.34",
      "A_5_7": "A.5.7",
      "A_6": "A.6",
      "A_6_3": "A.6.3",
      "A_6_7": "A.6.7",
      "A_7_1": "A.7.1",
      "A_7_2": "A.7.2",
      "A_7_3": "A.7.3",
      "A_7_4": "A.7.4",
      "A_8": "A.8",
      "A_8_1": "A.8.1",
      "A_8_2": "A.8.2",
      "A_8_23": "A.8.23",
      "A_8_5": "A.8.5",
      "A_8_7": "A.8.7",
      "A_8_9": "A.8.9",
      "A_9": "A.9",
      "CC1_1": "CC1.1",
      "CC2_1": "CC2.1",
      "CC3_2": "CC3.2",
      "CC4_1": "CC4.1",
      "CC5_2": "CC5.2",
      "CC6_1": "CC6.1",
      "CC7_2": "CC7.2",
      "CC8_1": "CC8.1",
      "CC9_2": "CC9.2",
      "C_10": "C.10",
      "C_6": "C.6",
      "C_7": "C.7",
      "C_8": "C.8",
      "C_9": "C.9",
      "administration": "Administration",
      "ai_act": "AI Act",
      "customer-support-success": "Customer Support & Success",
      "data-analytics": "Data & Analytics",
      "dora": "DORA",
      "education-training": "Education & Training",
      "elevated": "Elevated access",
      "engineering-development": "Engineering & Development",
      "executive-leadership": "Executive Leadership",
      "facilities-services": "Facilities & Services",
      "finance": "Finance",
      "human-resources": "Human Resources",
      "individual_contributor": "Individual contributor",
      "iso_27001": "ISO 27001",
      "iso_27005": "ISO 27005",
      "it-systems": "IT & Systems",
      "leadership": "Leadership",
      "legal-compliance": "Legal & Compliance",
      "management-team-leadership": "Management & Team Leadership",
      "managerial": "Managerial",
      "marketing-communications": "Marketing & Communications",
      "nis2": "NIS2",
      "operations": "Operations",
      "product-design": "Product & Design",
      "project-program-management": "Project & Program Management",
      "quality-process": "Quality & Process",
      "research-science": "Research & Science",
      "sales": "Sales",
      "security": "Security",
      "soc_2": "SOC 2",
      "standard": "Standard access",
      "supply-chain-logistics": "Supply Chain & Logistics"
    },
    "industries": {
      "aerospace_defence": "Aerospace and defence",
      "automotive": "Automotive",
      "banking": "Banking and capital markets",
      "capital_infrastructure": "Capital projects and infrastructure",
      "consumer_markets": "Consumer markets",
      "energy_resources": "Energy, utilities and resources",
      "engineering_construction": "Engineering and construction",
      "financial_services": "Financial services",
      "government_public": "Government and public services",
      "healthcare": "Healthcare",
      "hospitality_leisure": "Hospitality and leisure",
      "industrial_manufacturing": "Industrial manufacturing",
      "insurance": "Insurance",
      "media": "Media",
      "paper_packaging": "Forest, paper and packaging",
      "pharmaceuticals": "Pharmaceuticals and life sciences",
      "private_equity": "Private equity",
      "technology": "Technology",
      "telecommunications": "Telecommunications",
      "transportation": "Transportation and logistics",
      "wealth_management": "Asset and wealth management"
    },
    "integrations": {
      "conzentrate": {
        "description": "Sync training data to Learning Arena",
        "title": "Learning Arena"
      },
      "csv": {
        "description": "Import employees from a CSV file",
        "title": "CSV Import"
      },
      "drata": {
        "description": "Sync course completion evidence to Drata",
        "title": "Drata"
      },
      "google": {
        "description": "Sync employees and groups from Google Workspace",
        "group_description": "Import groups from Google Workspace",
        "title": "Google Workspace"
      },
      "google_scim": {
        "title": "Google"
      },
      "microsoft": {
        "description": "Sync employees and groups from Microsoft Entra ID",
        "group_description": "Import groups from Microsoft Entra ID",
        "title": "Microsoft Entra ID"
      },
      "microsoft_scim": {
        "title": "Microsoft Entra ID"
      },
      "microsoft_teams": {
        "description": "Send training notifications directly in Teams",
        "title": "Microsoft Teams"
      },
      "okta_scim": {
        "title": "Okta"
      },
      "sabacloud": {
        "description": "Sync training data to Saba Cloud",
        "title": "Saba Cloud"
      },
      "slack": {
        "description": "Sync employees and groups from Slack",
        "group_description": "Import groups from Slack",
        "title": "Slack"
      },
      "slack_notifications": {
        "description": "Send training notifications directly in Slack",
        "title": "Slack notifications"
      },
      "sync_failures": {
        "default": "The synchronization of this integration has failed.",
        "unauthorized": "Synchronization failed. Please update the authentication settings for this integration."
      },
      "vanta": {
        "description": "Sync course completion evidence to Vanta",
        "title": "Vanta"
      }
    },
    "invalid_user": "The current password is incorrect.",
    "language": {
      "da_DK": "Danish",
      "de_DE": "German",
      "en_US": "English",
      "es_ES": "Spanish",
      "fi_FI": "Finnish",
      "fr_FR": "French",
      "nb_NO": "Norwegian (Bokmål)",
      "nl_NL": "Dutch",
      "pl_PL": "Polish",
      "pt_PT": "Portuguese",
      "sv_SE": "Swedish"
    },
    "learning_profile": {
      "data_privacy": {
        "description": "Ensuring the privacy and protection of sensitive data",
        "long": "Data Privacy (GDPR)",
        "short": "Data Privacy"
      },
      "device_security": {
        "description": "Security of physical devices and endpoints",
        "long": "Device security",
        "short": "Device security"
      },
      "digital_threats": {
        "description": "Protection against various online threats",
        "long": "Digital Threats",
        "short": "Digital Threats"
      },
      "hybrid_work": {
        "description": "Security considerations for remote and office work",
        "long": "Hybrid Work",
        "short": "Hybrid Work"
      },
      "incidents_breaches": {
        "description": "Handling and prevention of security incidents",
        "long": "Incidents & Breaches",
        "short": "Incidents & Breaches"
      },
      "passwords_accounts": {
        "description": "Strength and management of passwords and accounts",
        "long": "Passwords & Accounts",
        "short": "Passwords & Accounts"
      },
      "phishing": {
        "description": "Awareness and prevention of phishing attacks",
        "long": "Phishing",
        "short": "Phishing"
      },
      "physical_security": {
        "description": "Protection of physical assets and spaces",
        "long": "Physical Security",
        "short": "Physical Security"
      },
      "secure_browsing": {
        "description": "Safe practices for internet browsing",
        "long": "Secure Browsing",
        "short": "Secure Browsing"
      }
    },
    "onboarding": {
      "data_privacy": {
        "category": "Data Privacy (GDPR)",
        "options": {
          "high": "We have clear policies and enforce strict data protection measures",
          "low": "We do not actively manage personal data compliance",
          "medium": "We collect data but do not have formal policies in place"
        },
        "question": "How does your company handle personal data under GDPR regulations?"
      },
      "device_security": {
        "category": "Device Security",
        "options": {
          "high": "Devices are centrally managed, encrypted, and monitored",
          "low": "Employees use their own devices with no enforced security policies",
          "medium": "Some security measures are applied, but not consistently"
        },
        "question": "What security measures are in place for company devices?"
      },
      "digital_threats": {
        "category": "Digital Threats",
        "options": {
          "high": "We use endpoint security, firewalls, and employee training",
          "low": "We rely on employees to manage their own security",
          "medium": "Some protections are in place, but not company-wide"
        },
        "question": "How does your company protect against malware and cyber threats?"
      },
      "hybrid_work": {
        "category": "Hybrid Work",
        "options": {
          "high": "Employees use VPNs, secure Wi-Fi, and company-approved devices",
          "low": "Employees use personal devices and unsecured networks",
          "medium": "Some security measures are encouraged but not required"
        },
        "question": "How is security managed for remote employees?"
      },
      "incidents_breaches": {
        "category": "Incidents and Breaches",
        "options": {
          "high": "We have an incident response plan and regularly test it",
          "low": "We handle incidents reactively with no formal plan",
          "medium": "We have a plan but have never tested it"
        },
        "question": "What is your company's approach to incident response?"
      },
      "passwords_accounts": {
        "category": "Passwords & Accounts",
        "options": {
          "high": "Password managers and MFA are required for all employees",
          "low": "Employees manage their own passwords with no requirements",
          "medium": "MFA is optional, and password policies are not strictly enforced"
        },
        "question": "How does your company enforce password security?"
      },
      "phishing": {
        "category": "Phishing",
        "options": {
          "high": "Employees undergo regular phishing awareness training",
          "low": "No formal phishing training is in place",
          "medium": "Some training is provided, but not regularly"
        },
        "question": "How does your company mitigate phishing threats?"
      },
      "physical_security": {
        "category": "Physical Security",
        "options": {
          "high": "Access control, visitor logs, and secure storage are in place",
          "low": "There are no formal physical security measures",
          "medium": "Some security measures exist but are inconsistently applied"
        },
        "question": "How is physical security managed in your office?"
      },
      "secure_browsing": {
        "category": "Secure Browsing",
        "options": {
          "high": "Employees use secure browsers with content filtering",
          "low": "No restrictions or security policies for browsing",
          "medium": "Some security measures are in place, but not enforced"
        },
        "question": "How does your company ensure secure internet browsing?"
      }
    },
    "organizational_role": {
      "access_level": {
        "elevated": "Elevated",
        "standard": "Standard"
      },
      "responsibility_tier": {
        "individual_contributor": "Individual contributor",
        "leadership": "Leadership",
        "managerial": "Managerial"
      }
    },
    "policies": {
      "audit_notifications_frequency": {
        "intense": "Intense",
        "loose": "Loose",
        "normal": "Normal"
      },
      "audit_status": {
        "canceled": "Canceled",
        "completed": "Completed",
        "draft": "Inactive",
        "expired": "Expired",
        "running": "Auditing"
      }
    },
    "report": {
      "labels": {
        "assignment": "Assignment",
        "assignment_completion": "Assignment completion",
        "click_rate": "Click rate",
        "clicked": "Clicked",
        "company_score": "Company score",
        "completed": "Completed",
        "course": "Course",
        "course_completed": "Courses completed",
        "critical": "Critical",
        "handling_rate": "Threat handle rate",
        "handling_time": "Threat handling time",
        "high": "High",
        "in_progress": "In progress",
        "interventions": "Interventions",
        "low": "Low",
        "medium": "Medium",
        "missed_deadlines": "Missed deadlines",
        "negative": "Negative",
        "neutral": "Neutral",
        "notify_admin": "Admin notified",
        "notify_employee": "Employee notified",
        "notify_manager": "Manager notified",
        "onboarding": "Onboarding rate",
        "overdue": "Overdue",
        "phishing_quizzes": "Phishing quizzes",
        "phishing_susceptibility": "Phishing susceptibility",
        "policy": "Policy",
        "positive": "Positive",
        "report_rate": "Report rate",
        "reported": "Reported",
        "reporting_behavior": "Reporting behavior",
        "resilience_score": "Resilience score",
        "score": "Resilience score",
        "sent": "Simulations sent",
        "signals": "Signals",
        "simulations_received": "Simulations received",
        "team_score": "Team score",
        "video": "Video",
        "video_quizzes": "Video quizzes",
        "videos_watched": "Videos watched"
      }
    },
    "reports": {
      "frequencies": {
        "bimonthly": "Every other month",
        "monthly": "Monthly",
        "quarterly": "Quarterly",
        "weekly": "Weekly",
        "yearly": "Yearly"
      },
      "periods": {
        "prev_month": "Previous month",
        "prev_quarter": "Previous quarter",
        "prev_week": "Previous week",
        "prev_year": "Last 12 months",
        "ytd": "Year to date"
      },
      "status": {
        "active": "Active",
        "inactive": "Inactive"
      },
      "types": {
        "manager": "Manager Report",
        "workspace": "Workspace Report"
      }
    },
    "risk_categories": {
      "agentic_ai": "Agentic AI",
      "communication_security": "Communication Security",
      "data_protection": "Data Protection",
      "digital_exposure_risk": "Digital Exposure Risk",
      "endpoint_device_security": "Endpoint Device Security",
      "engagement_awareness": "Engagement Awareness",
      "human_use_of_ai": "Human Use of AI",
      "identity_access_risk": "Identity Access Risk",
      "incident_response_readiness": "Incident Response Readiness",
      "mobile_security": "Mobile Security",
      "physical_security": "Physical Security",
      "policy_regulatory_compliance": "Policy & Regulatory Compliance",
      "remote_work_risk": "Remote Work Risk",
      "social_engineering_risks": "Social Engineering Risks",
      "third_party_risk": "Third Party Risk",
      "web_cloud_usage": "Web Cloud Usage"
    },
    "roles": {
      "administration": "Administration",
      "customer-support-success": "Customer Support & Success",
      "data-analytics": "Data & Analytics",
      "education-training": "Education & Training",
      "engineering-development": "Engineering & Development",
      "executive-leadership": "Executive Leadership",
      "facilities-services": "Facilities & Services",
      "finance": "Finance",
      "human-resources": "Human Resources",
      "it-systems": "IT & Systems",
      "legal-compliance": "Legal & Compliance",
      "management-team-leadership": "Management & Team Leadership",
      "marketing-communications": "Marketing & Communications",
      "operations": "Operations",
      "product-design": "Product & Design",
      "project-program-management": "Project & Program Management",
      "quality-process": "Quality & Process",
      "research-science": "Research & Science",
      "sales": "Sales",
      "security": "Security",
      "supply-chain-logistics": "Supply Chain & Logistics"
    },
    "saml": {
      "name_id_formats": {
        "emailAddress": "Email address",
        "persistent": "Persistent",
        "transient": "Transient",
        "unspecified": "Unspecified"
      },
      "providers": {
        "microsoft_scim": "Microsoft Entra ID",
        "okta_scim": "Okta"
      }
    },
    "scim": {
      "providers": {
        "auth0_scim": "Auth0",
        "google_scim": "Google",
        "microsoft_scim": "Microsoft Entra ID",
        "okta_scim": "Okta"
      }
    },
    "services": {
      "category": {
        "authentication": "Authentication",
        "collaboration": "Collaboration",
        "crm": "CRM",
        "digital_signature": "Digital signature",
        "document_management": "Document management",
        "file_sharing": "File sharing",
        "hrm": "HRM",
        "marketing": "Marketing",
        "other": "Other",
        "support": "Customer support",
        "survey": "Survey",
        "video_conferencing": "Video conferencing"
      },
      "target": {
        "all": "Everyone",
        "design": "Design",
        "engineering": "Engineering",
        "finance": "Finance",
        "marketing": "Marketing",
        "sales": "Sales",
        "support": "Support"
      }
    },
    "signals": {
      "key": {
        "access_level": "Access level",
        "ai_act_reference": "AI Act reference",
        "breach_found": "Breach found",
        "cybersecurity_culture_initiative_participated": "Participates in cyber security initiatives",
        "dora_reference": "DORA reference",
        "email_simulation_clicked": "Email simulation clicked",
        "email_simulation_credentials_submitted": "Email simulation credentials submitted",
        "email_simulation_delivered": "Email simulation delivered",
        "email_simulation_reported": "Email simulation reported",
        "email_simulation_reported_without_clicking": "Email simulation reported without clicking",
        "employee_imported": "Employee imported",
        "frameworks": "Frameworks",
        "high_confidence_in_phishing_self_assessment": "Repeatedly answered phishing quizzes correctly",
        "iso27001_reference": "ISO27001 reference",
        "iso27005_reference": "ISO27005 reference",
        "legitimate_email_reported_as_phishing": "Reports legitimate emails as phishing emails",
        "low_confidence_in_phishing_self_assessment": "Repeatedly answered phishing quizzes incorrectly",
        "low_score": "Low score",
        "missed_deadline_30_days": "Required training 30 days overdue",
        "missed_deadline_60_days": "Required training 60 days overdue",
        "missed_deadline_7_days": "Required training 7 days overdue",
        "multiple_choice_answered_correctly": "Multiple choice question answered correctly",
        "multiple_choice_answered_incorrectly": "Multiple choice question answered incorrectly",
        "nis2_reference": "NIS2 reference",
        "optional_training_engaged": "Completed optional training",
        "real_phishing_email_clicked": "Clicked a real phishing email",
        "real_phishing_email_opened": "Opened real phishing email",
        "real_phishing_email_opened_attachment": "Opened attachment of real phishing email",
        "real_phishing_email_reported": "Reported real phishing email",
        "real_phishing_email_targeted": "Targeted in real phishing emails",
        "responsibility_tier": "Responsibility tier",
        "risk_level": "Risk level",
        "risk_themes": "Risk themes",
        "risk_threshold": "Risk threshold",
        "role": "Role",
        "role_fallback_used": "Fallback role used",
        "simulation_not_reported_2_days": "Simulation not reported after 2 days",
        "simulation_not_reported_7_days": "Simulation not reported after 7 days",
        "sms_simulation_clicked": "SMS simulation clicked",
        "sms_simulation_delivered": "SMS simulation delivered",
        "sms_simulation_reported": "SMS simulation reported",
        "soc2_reference": "SOC2-reference",
        "threat_reported": "Threat reported",
        "training_completed": "Assigned training completed",
        "training_completed_after_deadline": "Post-deadline completion",
        "training_completed_on_time": "Assigned training completed on time",
        "training_inactivity": "Training inactivity",
        "training_video_watched": "Training video watched"
      },
      "sentiment": {
        "negative": "Negative",
        "neutral": "Neutral",
        "positive": "Positive"
      },
      "severity": {
        "critical": "Critical",
        "high": "High",
        "low": "Low",
        "medium": "Medium",
        "neutral": "Neutral"
      }
    },
    "simulations": {
      "delivery_method": {
        "email": "Email",
        "sms": "Text message"
      },
      "delivery_rate": {
        "high": "High",
        "low": "Low",
        "medium": "Medium"
      },
      "failures": {
        "failed_to_deliver": "Delivery error",
        "failed_to_send": "Send error",
        "invalid_receiver": "Receiver error",
        "invalid_template": "Template error",
        "no_template_available": "Template error"
      },
      "preview": {
        "CampaignClick": "{name} clicked on a link",
        "CampaignReport": "{name} reported the simulation",
        "CampaignSent": "Simulation was sent to {name}",
        "CampaignSubmission": "{name} submitted a login form",
        "activity": "Activity",
        "title": "Preview"
      },
      "schedule_type": {
        "missing": "No delivery method",
        "one_off": "One off",
        "recurring": "Recurring"
      },
      "status": {
        "cancelled": "Cancelled",
        "completed": "Completed",
        "draft": "Draft",
        "paused": "Paused",
        "running": "Running",
        "sending": "Sending"
      },
      "templates": {
        "editor": {
          "sidebar_blocks": {
            "button": "Button",
            "columns": "Columns",
            "container": "Container",
            "divider": "Divider",
            "heading1": "Heading 1",
            "heading2": "Heading 2",
            "heading3": "Heading 3",
            "image": "Image",
            "spacer": "Spacer",
            "text": "Text"
          }
        }
      }
    },
    "statistics": {
      "activities_by_type": {
        "completed_courses": "Completed courses",
        "phishing_quiz_correct_answers": "Correct phishing quiz answers",
        "phishing_quiz_incorrect_answers": "Incorrect phishing quiz answers",
        "quiz_answers": "Quiz answers",
        "quiz_correct_answers": "Correct quiz answers",
        "quiz_incorrect_answers": "Incorrect quiz answers",
        "simulations_delivered": "Simulations delivered",
        "simulations_failed": "Failed simulations",
        "simulations_passed": "Passed simulations",
        "simulations_reported": "Simulations reported",
        "text": "How your employees are training",
        "threats_reported": "Threats reported",
        "title": "Completed activities",
        "videos_watched": "Videos watched"
      },
      "benchmarks": {
        "above_benchmark_tooltip": "Value is above the benchmark.",
        "below_benchmark_tooltip": "Value is below the benchmark.",
        "benchmark_tooltip": "Benchmark"
      },
      "breaches": {
        "critical": "Critical",
        "noncritical": "Noncritical"
      },
      "employees": {
        "beginner": "Beginner",
        "expert": "Expert",
        "intermediate": "Intermediate"
      },
      "onboarding": {
        "not_onboarded": "Not onboarded",
        "onboarded": "Onboarded"
      },
      "participant_partition": {
        "active": "Active",
        "completed": "Completed",
        "halted": "Halted"
      },
      "threats": {
        "status_partition": {
          "forwarded": "Forwarded",
          "fraudulent": "Fraudulent",
          "legitimate": "Legitimate",
          "spam": "Spam"
        }
      },
      "time_units": {
        "days": "Day | Days",
        "hours": "Hour | Hours",
        "minutes": "Minute | Minutes",
        "seconds": "Second | Seconds",
        "weeks": "Week | Weeks"
      },
      "training": {
        "quizzing": {
          "correct": "Correct",
          "incorrect": "Incorrect"
        }
      }
    },
    "tables": {
      "columns": {
        "actor": "Actor",
        "app": "App",
        "automation_status": "Status",
        "available_at": "Available",
        "breached_at": "Breached at",
        "click_rate": "@:simulations.click_rate.title",
        "completed": "Completed",
        "completed_at": "Completed",
        "content_id": "Content",
        "content_type": "Content type",
        "created_at": "Created",
        "data_class": "Data class",
        "deadline_at": "Deadline",
        "delivery": "@:simulations.summary.schedule_type",
        "delivery_type": "@:tables.delivery_method",
        "employee_id": "Employee",
        "employee_status": "Status",
        "event": "Event",
        "group_id": "Group",
        "key": "Signal",
        "last_learning_interaction": "Last activity",
        "published_at": "Published at",
        "report_rate": "@:simulations.report_rate.title",
        "risk_matrix": "Risk matrix",
        "role": "Role",
        "score": "Score",
        "sentiment": "Sentiment",
        "severity": "Severity",
        "signal_group": "Signal group",
        "status": "Status",
        "submission_rate": "@:simulations.submission_rate.title",
        "test": "@:simulations.summary.test",
        "translations": "Translations",
        "type": "Type",
        "zone": "Zone"
      },
      "date_operators": {
        "<": "before",
        "<=": "on or before",
        "<>": "not on",
        "=": "on",
        ">": "after",
        ">=": "on or after"
      },
      "enum_values": {
        "access": "Access",
        "access_revoke": "Access revoked",
        "active": "Active",
        "admin": "Admin",
        "all": "All",
        "analyst": "Analyst",
        "api_token_create": "API token created",
        "api_token_delete": "API token deleted",
        "assignment": "Assignment",
        "auth_activity": "Authentication activity",
        "authenticate": "Authenticate",
        "authentication_activity": "Authentication activity",
        "authorized_integration": "Authorized integration",
        "breach_config": "Breach settings updated",
        "breach_exposure": "Breach exposure",
        "breach_found": "Breach found",
        "cancelled": "@:dynamic_keys.simulations.status.cancelled",
        "change": "Change",
        "changed_data": "Changed data",
        "completed": "@:dynamic_keys.simulations.status.completed",
        "course": "Course",
        "course_delete": "Course deleted",
        "created_campaign_domain": "Created campaign domain",
        "created_integration": "Created integration",
        "created_warehouse_token": "Created warehouse token",
        "credential_update": "Credential updated",
        "critical": "Critical",
        "critical_phishing_interactions": "Phishing credentials submitted",
        "cybersecurity_culture_initiative_participated": "Participates in cyber security initiatives",
        "data_change": "Data changed",
        "deleted_warehouse_token": "Deleted warehouse token",
        "domain_create": "Domain created",
        "draft": "@:dynamic_keys.simulations.status.draft",
        "email": "@:dynamic_keys.simulations.delivery_method.email",
        "email_simulation_clicked": "Email simulation clicked",
        "email_simulation_credentials_submitted": "Email simulation credentials submitted",
        "email_simulation_delivered": "Email simulation delivered",
        "email_simulation_reported": "Email simulation reported",
        "email_simulation_reported_without_clicking": "Email simulation reported without clicking",
        "employee_training_exclude": "Employee excluded from training",
        "employee_training_exclusion_expire": "Employee training exclusion expired",
        "employee_training_include": "Employee included in training",
        "high": "High",
        "high-somewhat_likely": "High impact / Somewhat likely",
        "high-very_likely": "High impact / Very likely",
        "high-very_unlikely": "High impact / Very unlikely",
        "high_confidence_in_phishing_self_assessment": "Repeatedly answered phishing quizzes correctly",
        "hub": "Hub",
        "inactive": "Inactive",
        "integration_auth": "Integration authorized",
        "integration_config": "Integration settings updated",
        "integration_create": "Integration created",
        "integration_delete": "Integration deleted",
        "integration_update": "Integration updated",
        "intel_config": "Human risk intelligence settings updated",
        "invited_user": "Invited user",
        "legitimate_email_reported_as_phishing": "Reports legitimate emails as phishing emails",
        "login": "Signed in",
        "login_verify": "Verified sign in",
        "logout": "Signed out",
        "low": "Low",
        "low-somewhat_likely": "Low impact / Somewhat likely",
        "low-very_likely": "Low impact / Very likely",
        "low-very_unlikely": "Low impact / Very unlikely",
        "low_confidence_in_phishing_self_assessment": "Repeatedly answered phishing quizzes incorrectly",
        "manage": "Manage",
        "med-somewhat_likely": "Medium impact / Somewhat likely",
        "med-very_likely": "Medium impact / Very likely",
        "med-very_unlikely": "Medium impact / Very unlikely",
        "medium": "Medium",
        "missed_deadline_30_days": "Required training 30 days overdue",
        "missed_deadline_60_days": "Required training 60 days overdue",
        "missed_deadline_7_days": "Required training 7 days overdue",
        "multiple_choice_answered_correctly": "Multiple choice question answered correctly",
        "multiple_choice_answered_incorrectly": "Multiple choice question answered incorrectly",
        "negative": "Negative",
        "neutral": "Neutral",
        "notification": "Notification",
        "notify_admin": "Notify admins",
        "notify_employee": "Notify employee",
        "notify_manager": "Notify manager",
        "one_off": "@:dynamic_keys.simulations.schedule_type.one_off",
        "optional_training_engaged": "Completed optional training",
        "paused": "Paused",
        "phishing_interactions": "Phishing interactions",
        "policy": "Policy",
        "positive": "Positive",
        "privacy_config": "Privacy settings updated",
        "quiz": "Quiz",
        "real_phishing_email_opened": "Opened real phishing email",
        "real_phishing_email_reported": "Reported real phishing email",
        "real_phishing_email_targeted": "Targeted in real phishing emails",
        "recurring": "@:dynamic_keys.simulations.schedule_type.recurring",
        "register": "Register",
        "removed_user_access": "Removed user access",
        "running": "@:dynamic_keys.simulations.status.running",
        "sending": "@:dynamic_keys.simulations.status.sending",
        "signed_in": "Signed in",
        "signed_out": "Signed out",
        "simulation_config": "Simulation settings updated",
        "simulation_non_reporting": "Simulation non-reporting",
        "simulation_not_reported_2_days": "Simulation not reported after 2 days",
        "simulation_not_reported_7_days": "Simulation not reported after 7 days",
        "sms": "@:dynamic_keys.simulations.delivery_method.sms",
        "sms_simulation_clicked": "SMS simulation clicked",
        "sms_simulation_delivered": "SMS simulation delivered",
        "started": "Started",
        "support": "Support",
        "switched_workspace": "Switched workspace",
        "threat_analyst": "Threat analyst",
        "threat_config": "Threat management settings updated",
        "threat_reported": "Threat reported",
        "training_completed": "Assigned training completed",
        "training_completed_after_deadline": "Post-deadline completion",
        "training_completed_on_time": "Assigned training completed on time",
        "training_config": "Training settings updated",
        "training_inactivity": "Training inactivity",
        "training_video_watched": "Training video watched",
        "updated_breach_settings": "Updated breach settings",
        "updated_gdpr_settings": "Updated GDPR settings",
        "updated_human_risk_intelligence_settings": "Updated human risk intelligence settings",
        "updated_integration": "Updated integration",
        "updated_integration_settings": "Updated integration settings",
        "updated_integration_token": "Updated integration token",
        "updated_simulation_settings": "Updated simulation settings",
        "updated_threat_management_settings": "Updated threat management settings",
        "updated_training_settings": "Updated training settings",
        "updated_workspace_settings": "Updated workspace settings",
        "user_invite": "User invited",
        "verified_sign_in": "Verified sign in",
        "video": "Video",
        "video_delete": "Video deleted",
        "viewed_resource": "Viewed resource",
        "workspace_config": "Workspace settings updated",
        "workspace_switch": "Workspace switched"
      },
      "operators": {
        "<>": "is not",
        "=": "is"
      }
    },
    "threats": {
      "status": {
        "all": "All",
        "forwarded": "Forwarded",
        "fraudulent": "Fraudulent",
        "legitimate": "Legitimate",
        "spam": "Spam",
        "unhandled": "Unhandled"
      }
    },
    "training": {
      "type": {
        "course-type": "Course",
        "policy-type": "Policy",
        "quiz-type": "Quiz",
        "video-type": "Video"
      }
    },
    "types": {
      "boolean": "Boolean",
      "date": "Date",
      "number": "Number",
      "string": "String"
    },
    "users": {
      "roles": {
        "admin": {
          "text": "Admins can manage settings, invite users, and configure products.",
          "title": "Admin"
        },
        "analyst": {
          "text": "Analysts can view and analyze data.",
          "title": "Analyst"
        },
        "threat_analyst": {
          "text": "Threat analysts can manage threats and view/analyze data.",
          "title": "Threat analyst"
        }
      }
    },
    "videos": {
      "category": {
        "advanced": {
          "title": "Advanced",
          "tooltip": "Become a hacking expert in no time"
        },
        "ai": {
          "title": "AI and cybersecurity",
          "tooltip": "Explore the complex role of AI in cybersecurity"
        },
        "compliance": {
          "title": "Certifications and compliance",
          "tooltip": "Understand the importance of certifications and compliance"
        },
        "gdpr": {
          "title": "GDPR",
          "tooltip": "Learn the most important requirements and rules in GDPR and how you can comply with them in your everyday life"
        },
        "hacking": {
          "title": "The life of a hacker",
          "tooltip": "Get to know the people behind cyberattacks, the hackers of the world"
        },
        "money_laundering": {
          "title": "Money laundering",
          "tooltip": "Learn the different methods used by criminals to launder money and how to detect and prevent money laundering"
        },
        "phishing": {
          "title": "Phishing",
          "tooltip": "Discover the aspects of the most common cyberattack worldwide"
        },
        "physical_security": {
          "title": "Physical security",
          "tooltip": "Learn why physical security is a crucial element in good cyber security"
        },
        "tips_and_tricks": {
          "title": "Tips and tricks",
          "tooltip": "Learn how to increase your personal cybersecurity"
        },
        "types_of_hacking": {
          "title": "Types of hacking",
          "tooltip": "Get insights into the different methods used by hackers"
        },
        "uploads": {
          "title": "Uploads",
          "tooltip": "Watch videos uploaded by your organization for your specific security needs"
        }
      }
    },
    "workspace_onboarding": {
      "kick_off": {
        "validation": {
          "employee_import": "At least 1 AD integration is set up correctly",
          "invite_admins": "Invite admins",
          "reporting_add_in": "Set up reporting add-in",
          "simulation": "Set up simulations",
          "training": "Set up training",
          "verify_domain": "At least 1 domain is verified",
          "whitelisting": "Allowlisting is completed"
        }
      }
    }
  },
  "editor": {
    "loading": "Loading"
  },
  "employees": {
    "active_directory": "Active Directory",
    "add_employees": "Add employees",
    "anonymous_name": "Anonymous",
    "bulk_actions": {
      "activate": "Activate user | Activate users",
      "deactivate": "Deactivate user | Deactivate users",
      "success": "Statuses updated",
      "x_of_n_selected": "{x} of {n} selected"
    },
    "current_manager": "Current manager",
    "deleted_user": "Deleted user",
    "department": "Department",
    "filter": {
      "status": {
        "active": "Only active employees",
        "all": "All employees",
        "inactive": "Only inactive employees"
      }
    },
    "form": {
      "department": "Department",
      "edit_title": "Settings",
      "email": "Email",
      "first_name": "First name",
      "language": "Language",
      "last_name": "Last name",
      "manager": "Manager",
      "organisational_role": "Role",
      "placeholder": {
        "manager": "Select manager",
        "role": "Select role",
        "timezone": "Select timezone"
      },
      "save_settings": "Save settings",
      "scim_enabled_info": "You cannot edit the employee's settings because SCIM is enabled for this workspace.",
      "timezone": "Timezone"
    },
    "manual": "Manual",
    "no_email_found": "No email found",
    "preview": {
      "close_edit": "Close",
      "edit": "Edit",
      "email": "Email",
      "groups": "Groups",
      "locale": "Language",
      "manager": {
        "active_directory": "Active Directory",
        "button": "View profile",
        "email": "Email",
        "manual": "Manual",
        "name": "Name",
        "source": "Source",
        "subtitle": "Overview of manager details",
        "title": "Manager"
      },
      "phone_number": "Phone number",
      "profile": "View profile",
      "provider": "Provider",
      "provider_id": "Provider ID",
      "source": "Source",
      "status": "Status",
      "tags": "Tags",
      "title": "Preview"
    },
    "recent_activity": "Recent activity",
    "resilience_score": {
      "text": "Current resilience score based on last 90 days performance.",
      "title": "Resilience score"
    },
    "search": {
      "button": "Search",
      "empty": "Search for employees...",
      "no_results": "No employees found"
    },
    "settings": {
      "settings_saved": "Settings saved",
      "status": {
        "active": {
          "description": "This employee will receive simulations and training exercises",
          "title": "Active"
        },
        "inactive": {
          "description": "This employee will NOT receive simulations and training exercises",
          "title": "Inactive"
        }
      }
    },
    "simulations": {
      "click_rate": {
        "title": "Click rate",
        "tooltip": "Percentage of simulations clicked."
      },
      "email_validated": "Email validated: {date}",
      "received": {
        "title": "Simulations received",
        "tooltip": "Total number of simulations received.",
        "unit": "Simulations"
      },
      "report_rate": {
        "title": "Report rate",
        "tooltip": "Percentage of simulations reported."
      },
      "submission_rate": {
        "title": "Login rate",
        "tooltip": "Percentage of login forms submitted.",
        "x_received": "{count} received"
      }
    },
    "status": "Status",
    "training": {
      "reminder": {
        "reminder_sent": "Reminder sent",
        "subject": "Cybersecurity training",
        "text": "The threat from hackers is increasing and you need to stay updated to keep you and your company safe.",
        "title": "Hi!"
      }
    },
    "videos": {
      "title": "Videos",
      "unit": "Videos watched"
    }
  },
  "empty": {
    "activity": {
      "title": "No activity"
    },
    "assigned_learning": {
      "description": "User has not been assigned any training.",
      "title": "No assigned learning"
    },
    "automations": {
      "button": "Create a sequence",
      "description": "Get started by creating a sequence.",
      "title": "No automations"
    },
    "breaches": {
      "description": "Any breaches associated with email addresses added to the hub will be visible here.",
      "title": "No breaches"
    },
    "custom_uploads": {
      "button": "Create video",
      "description": "Get started by creating a video",
      "title": "No videos found"
    },
    "domains": {
      "button": "Add domain",
      "description": "Get started by adding a domain.",
      "title": "No domains"
    },
    "employee_simulations": {
      "button": "Go to simulations",
      "description": "Get started by adding a simulation.",
      "title": "No simulations"
    },
    "employees": {
      "button": "Add employee",
      "description_with_button": "Get started by adding an employee.",
      "description_without_button": "No employees were found.",
      "title": "No employees"
    },
    "employees_activity": {
      "description": "There has been no activity for this employee.",
      "title": "No activity"
    },
    "employees_group": {
      "description": "This group has no associated employees.",
      "title": "No employees"
    },
    "employees_training": {
      "description": "This {type} has not been completed by any employees.",
      "title": "No participants"
    },
    "generic": {
      "description": "No records found.",
      "title": "No records"
    },
    "groups": {
      "button": "Create group",
      "description_with_button": "Get started by adding a group.",
      "description_without_button": "No groups found.",
      "title": "No groups"
    },
    "imports": {
      "description": "There are no syncs for this integration.",
      "title": "No syncs"
    },
    "participants": {
      "description": "No participants were found.",
      "title": "No participants"
    },
    "policies": {
      "description": "Get started by creating a policy.",
      "title": "No policies"
    },
    "reports": {
      "description": "Get started by creating a new scheduled report",
      "title": "No scheduled reports"
    },
    "scim_connections": {
      "description": "Create a connection for Microsoft Entra ID or Okta.",
      "title": "No SCIM connections"
    },
    "scim_tokens": {
      "description": "No SCIM tokens have been created for this workspace.",
      "title": "No SCIM tokens"
    },
    "simulation_events": {
      "description": "No events were found for this simulation.",
      "title": "No events"
    },
    "simulations": {
      "description": "Get started by adding a simulation.",
      "title": "No simulations"
    },
    "simulations_custom_templates": {
      "description": "Get started by adding a template.",
      "title": "No templates"
    },
    "simulations_sequence": {
      "button": "Edit sequence",
      "description": "Add actions to build the automation flow",
      "title": "This sequence is empty"
    },
    "threats": {
      "attachments": "No attachments found",
      "description": "Get started by reporting suspicious emails with the Moxso email add-in",
      "title": "No threats found"
    },
    "tokens": {
      "description": "Get started by creating a token.",
      "title": "No tokens"
    },
    "training": {
      "button": "Clear filters",
      "description": "No training materials matching the search were found.",
      "title": "No training materials found"
    },
    "training_deadlines": {
      "description": "No training deadlines found.",
      "title": "No training deadlines"
    },
    "user_courses": {
      "description": "No courses have been assigned yet.",
      "title": "No courses"
    },
    "users": {
      "description": "No users were found.",
      "title": "No users"
    }
  },
  "error": {
    "button": "Go back home",
    "text": "An unknown error occurred, and we couldn't complete your request. We're really sorry for the inconvenience. Please try again later.",
    "title": "Something went wrong"
  },
  "forgot_password": {
    "button": "Send instructions",
    "heading": "Reset your password",
    "instructions": {
      "heading": "Email sent",
      "text": "Instructions have been sent to your email"
    },
    "text": "Enter the email address you used when you joined and we'll send you instructions to reset your password."
  },
  "forms": {
    "employee": {
      "add_employees": "Add employees",
      "buttons": {
        "add": "Add employee | Add employees",
        "add_row": "Add row",
        "send_reminder": "Send training reminder",
        "settings": "Settings"
      },
      "delete_row": "Delete row",
      "employee_added": "Employee added | Employees added",
      "import": {
        "text": "Import employees from a CSV file.",
        "title": "Import employees"
      },
      "labels": {
        "email": "Email",
        "first_name": "First name",
        "language": "Language",
        "last_name": "Last name",
        "phone_number": "Phone number"
      },
      "manual": {
        "text": "Create employees and their details manually.",
        "title": "Manually create employees"
      },
      "placeholders": {
        "email": "name{'@'}company.com",
        "first_name": "First name",
        "last_name": "Last name",
        "phone_number": "Enter phone number"
      }
    },
    "filters": {
      "all": "All employees",
      "completed": "Completed",
      "completed_default": "All",
      "incomplete": "Incomplete",
      "only_active": "Only active employees",
      "only_inactive": "All inactive employees"
    },
    "group": {
      "adaptive": {
        "text": "Members are enrolled automatically based on rules.",
        "title": "Create an adaptive group"
      },
      "add_group": "Add group",
      "buttons": {
        "add": "Create group",
        "back": "Back",
        "import": "Import groups",
        "next": "Next step",
        "save": "Save settings"
      },
      "group_added": "Group added",
      "group_updated": "Group updated",
      "import": {
        "text": "Import groups from integrations.",
        "title": "Import groups"
      },
      "labels": {
        "groups": "Groups",
        "import_from_provider": "Import from provider",
        "name": "Name",
        "provider": "Provider",
        "provider_id": "Provider group id"
      },
      "manual": {
        "text": "Members will be added manually.",
        "title": "Create a manual group"
      },
      "placeholders": {
        "name": "Group name",
        "provider": "Select provider",
        "provider_id": "ABC-123",
        "search_groups": "Search groups"
      },
      "scim_enabled_info": "You cannot edit the group's settings because SCIM is enabled for this workspace."
    },
    "login": {
      "buttons": {
        "reset_password": "Reset password"
      },
      "labels": {
        "email": "Email",
        "password": "Password",
        "password_repeat": "Repeat password"
      },
      "placeholders": {
        "email": "name{'@'}company.com"
      }
    },
    "search": "Search"
  },
  "general": {
    "locked_feature": "This feature is locked"
  },
  "go_back": "Go back",
  "goals": {
    "actions": {
      "delete_are_you_sure": "Are you sure you want to cancel this goal?",
      "delete_goal": "Cancel goal",
      "deleted": "Goal cancelled",
      "edit_goal": "Edit goal",
      "edit_goal_title": "Edit {metric} goal",
      "new_goal": "New {metric} goal",
      "save_goal": "Save goal",
      "target_description": "Set a target value and the date you want to reach it by."
    },
    "chart": {
      "lifetime": "Lifetime",
      "recent": "Recent"
    },
    "detail": {
      "achieved": "Achieved",
      "active_and_scheduled": "Active & scheduled goals",
      "actual_at_date": "Actual at date",
      "in_progress": "In progress",
      "missed": "Missed",
      "no_past_goals": "No past goals yet",
      "outcome": "Outcome",
      "past_goals": "Past goals",
      "scheduled": "Scheduled",
      "trajectory": "Trajectory",
      "trajectory_description": "Actual progress against every target set for this metric. Dots are colored by outcome."
    },
    "form": {
      "target": {
        "label": "Target",
        "placeholder": "Target"
      },
      "target_date": {
        "label": "Target date",
        "placeholder": "Select target date"
      }
    },
    "legend": {
      "actual": "Actual",
      "projected": "Projected"
    },
    "no_data": "No data",
    "overview": {
      "add_goal": "Add goal",
      "current": "current",
      "description": "Define time-bound targets for each metric to build a measurable improvement trajectory.",
      "employees_behind_tooltip": "Employees with at least one assignment past its due date.",
      "from_now": "from now",
      "gap_from_previous_target": "Gap from previous target",
      "next_target": "Next target",
      "no_goal_description": "You're tracking this metric without a target. Add one to measure progress.",
      "no_goals": "No active goal",
      "time_elapsed": "Time elapsed",
      "title": "Goals",
      "view": "View"
    }
  },
  "groups": {
    "adaptive_conditions": {
      "boolean_operators": {
        "and": "AND",
        "or": "OR"
      },
      "empty": "No rules yet. Add a rule to define who belongs to this group.",
      "preview_count_label": "employees match the criteria",
      "subtitle": "Membership is determined by rules instead of being set manually.",
      "title": "Adaptive group"
    },
    "assign_manager": {
      "button": "Assign manager",
      "description": "Assign a manager to all group members at once",
      "form": {
        "overwrite_managers": {
          "help": "If enabled, employees who already have a manager will be reassigned to the selected manager.",
          "label": "Overwrite existing managers"
        },
        "select_manager": {
          "help": "Choose a manager to be assigned to all members of this group.",
          "label": "Manager",
          "placeholder": "Select manager"
        }
      },
      "manager_assigned": "Manager assigned to group members",
      "message": "Manually updating employee managers will stop Active Directory synchronization from updating them.",
      "title": "Bulk assign manager"
    },
    "assign_role": {
      "button": "Assign role",
      "form": {
        "overwrite_roles": {
          "help": "If enabled, employees who already have a role will be reassigned to the selected role.",
          "label": "Overwrite existing roles"
        },
        "select_role": {
          "help": "Choose a role to be assigned to all members of this group.",
          "label": "Role",
          "placeholder": "Select role"
        }
      },
      "role_assigned": "Role assigned to group members",
      "title": "Bulk assign role"
    },
    "assign_timezone": {
      "button": "Assign timezone",
      "description": "Assign a timezone to all group members at once",
      "form": {
        "overwrite_timezones": {
          "help": "If enabled, employees who already have a timezone will be reassigned to the selected timezone.",
          "label": "Overwrite existing timezones"
        },
        "select_timezone": {
          "help": "Choose a timezone to be assigned to all members of this group.",
          "label": "Timezone",
          "placeholder": "Select timezone"
        }
      },
      "timezone_assigned": "Timezone assigned to group members",
      "title": "Bulk assign timezone"
    },
    "average_resilience_score_text": "Average resilience score for employees in this group",
    "average_resilience_score_title": "Average resilience score",
    "buttons": {
      "add_rule": "Add rule",
      "assign_manager": "Assign manager",
      "assign_role": "Assign role",
      "assign_timezone": "Assign timezone",
      "cancel": "Cancel",
      "manage_group": "Manage members",
      "remove_managers": "Remove managers",
      "update_group": "Update members"
    },
    "delete": {
      "are_you_sure": "Are you sure you want to delete this group? This action cannot be undone.",
      "button": "Delete",
      "group_deleted": "Group deleted"
    },
    "manage_members": "Edit group members",
    "members_count": "One member | {count} members",
    "membership_rules": "Membership rules",
    "provider": {
      "error": {
        "back": "Choose another provider",
        "button": "Configure Integration",
        "text": "Groups could not be retrieved",
        "title": "Could not contact integration provider"
      },
      "group_copied": "Provider ID copied to clipboard",
      "heading": "Provider",
      "hide_id": "Hide id",
      "id": "ID",
      "latest_sync": "Latest sync",
      "never_synced": "Never synced",
      "provider_id": "Provider ID",
      "refresh": "Refresh data",
      "show_id": "Show id",
      "sync_started": "Sync added to queue",
      "synced": "Synced",
      "text": "Data synced with provider"
    },
    "remove_managers": {
      "button": "Remove all managers",
      "description": "Remove the manager from each member of this group.",
      "managers_removed": "Managers removed from group members",
      "message": "You are about to remove the manager from all members of this group. Are you sure you want to proceed? This action cannot be undone.",
      "title": "Remove all managers"
    },
    "risk_level": {
      "calculated": "Inherited Risk Level",
      "country": "Country",
      "group": "Group",
      "organisation": "Organisation",
      "text": "Overview of risk levels",
      "title": "Risk Level"
    },
    "search": {
      "empty": {
        "title": "No groups found"
      }
    },
    "segment_members": "Group segmentation",
    "segmentation": "Segmentation",
    "segments": {
      "create": "Create a segment",
      "create_success": "Segment created",
      "empty": "No segments found",
      "form": {
        "all": "All",
        "any": "Any",
        "exclude": "Exclude members with the following tags:",
        "include": "Include members with the following tags:",
        "name": "Name",
        "operator": "Operator",
        "select": "Select tags"
      },
      "heading": "Segments",
      "members_count": "One member | {count} members",
      "text": "Use segments to filter members",
      "update": "Update segment",
      "update_success": "Segment updated"
    },
    "settings": {
      "caution": "Caution",
      "provider_change_warning": "{caution}: Changing the provider details for this group will trigger a new group synchronization. Be aware that employees currently assigned to this group may be removed if they are not included in the updated Active Directory group. Please proceed carefully to prevent unintended changes.",
      "subtitle": "Configure your group settings.",
      "title": "Group settings"
    },
    "sync_failed": {
      "button": "Settings",
      "recommended_action": "Recommended action",
      "title": "Synchronization failed",
      "tooltip": "The synchronization of this group has failed."
    },
    "tags": {
      "create": "Create a tag",
      "create_success": "Tag created",
      "delete_success": "Tag deleted",
      "empty": "No tags found",
      "heading": "Tags",
      "text": "Use tags to group members"
    }
  },
  "human_risk_intelligence": {
    "assignment": {
      "associated_risk_categories": "Associated risk categories",
      "available": "Available at",
      "completed": "Completed at",
      "contextual_risk_factors": "Contextual risk factors",
      "deadline": "Deadline at",
      "details": "Details",
      "details_title": "Assignment",
      "osint": "OSINT",
      "osint_sources_summary": {
        "label": "Sources analyzed: {count}",
        "results_count": "{count} result | {count} results"
      },
      "passed": "Passed",
      "rules": "Rules",
      "signals": "Signals",
      "signals_description": "Signals that triggered this assignment",
      "strategy": "Strategy",
      "title": "Assignment"
    },
    "common": {
      "powered_by": "Powered by {risk_framework}"
    },
    "content_preview": {
      "title": "Content preview"
    },
    "dashboard_card": {
      "assignments_90_days": "Assignments",
      "enable_button": "Enable human risk intelligence",
      "interventions_90_days": "Interventions",
      "score_90_days": "Score",
      "signals_90_days": "Signals",
      "title": "Human risk intelligence"
    },
    "dashboard_signal_collection": {
      "average_day": "Average day",
      "avg_daily": "Avg. daily",
      "last_90_days": "Last 90 days",
      "less": "Less",
      "lowest_day": "Lowest day",
      "more": "More",
      "negative": "Negative",
      "negative_count": "Negative: {count}",
      "no_signals_in_range": "No signals in this range",
      "peak_day": "Peak day",
      "positive": "Positive",
      "positive_count": "Positive: {count}",
      "signal_count": "1 signal | {count} signals",
      "signal_count_on_date": "{count} on {date}",
      "signal_range": "{min}-{max} signals",
      "signals_on_date": "Signals on {date}",
      "title": "Signal ingestion",
      "total_signals": "total signals"
    },
    "employee_preview": {
      "access_level": "Access level",
      "info": "Info",
      "organizational_role": "Organizational role",
      "resilience_score": "Resilience score",
      "responsibility_tier": "Responsibility tier",
      "role": "Role",
      "title": "Employee"
    },
    "filters": {
      "back": "Back",
      "data": "Filter data",
      "filter_by": "Filter by",
      "search": "Search",
      "select_date": "Select date"
    },
    "group_breakdown": {
      "columns": {
        "assignments": "Assignments",
        "avg_score": "Avg score",
        "employees": "Employees",
        "group": "Group",
        "interventions": "Interventions",
        "signals": "Signals"
      },
      "description": "Aggregated signals, assignments, and interventions by group",
      "signals_slideover": {
        "activity_links_title": "Activity",
        "links_title": "Signals",
        "member_count": "{count} members",
        "title": "Signal breakdown",
        "view_assignments": "View assignments",
        "view_interventions": "View interventions",
        "view_signals": "View {sentiment} signals"
      },
      "title": "Group breakdown"
    },
    "intervention": {
      "details_title": "Intervention",
      "preview_body": "In production this email contains behavior-based context and next-step guidance.",
      "preview_cta": "Please review your security activity and complete any requested follow-up training.",
      "preview_from_name": "Moxso Security Team",
      "preview_greeting": "Hi {name},",
      "preview_intro": "This is a sample intervention notification preview.",
      "preview_subject": "Security notification",
      "sent_at": "Sent at",
      "signals_description": "Signals that triggered this intervention",
      "title": "Intervention"
    },
    "navigation": {
      "assignments": "Assignments",
      "interventions": "Interventions",
      "osint": "OSINT",
      "overview": "Overview",
      "risk_framework": "Risk Framework",
      "signals": "Signals"
    },
    "notification_title": "Notification",
    "notification_type": "Notification type",
    "onboarding": {
      "common": {
        "back": "Back",
        "cancel": "Cancel",
        "next": "Next"
      },
      "glance": {
        "assignment_limits": "Up to {max} lessons per employee, with at least {cooldown} days between assignments",
        "eligibility": "Employees are eligible to receive training {min_days} days after starting.",
        "lesson_selection": "Lessons assigned automatically {selection}",
        "notifications_disabled": "Notifications disabled",
        "notifications_enabled": "Notifications enabled with {frequency} frequency. {behavior}"
      },
      "interventions": {
        "heading": "Behavior-triggered interventions",
        "subheading": "Define which behavioral signals trigger an immediate response outside the regular cadence, a corrective training assignment, a notification to the employee's manager, or an alert to your security admins."
      },
      "intro": {
        "benefits": {
          "better_outcomes": {
            "description": "Focus resources where they matter most",
            "title": "Better outcomes"
          },
          "continuous_adaptation": {
            "description": "The system learns and adjusts based on ongoing behavior",
            "title": "Continuous adaptation"
          },
          "personalized_experience": {
            "description": "Each employee gets training tailored to their needs",
            "title": "Personalized experience"
          }
        },
        "description": "Human Risk Intelligence turns behavioral signals into individual risk profiles, then assigns the training and simulations each employee actually needs. Content is calibrated to where each person sits in the Moxso Risk Framework — and recalibrates as new signals arrive. Risk goes down without adding training volume.",
        "heading": "What is Human Risk Intelligence?",
        "setup_button": "Set up Human Risk Intelligence",
        "subheading": "Train each employee on the risks that actually apply to them — and stop training them on the ones that don't."
      },
      "review": {
        "at_a_glance": "At a glance",
        "enable_button": "Enable Human Risk Intelligence",
        "heading": "Ready to enable",
        "next": {
          "heading": "What happens next",
          "items": {
            "analysis_starts_immediately": "Moxso will start collecting behavioral signals across your organization immediately.",
            "no_lessons_assigned_immediately_prefix": "Training is delivered after 24 hours.",
            "no_lessons_assigned_immediately_suffix": "By then, the system has learned enough to build a reliable risk profile for each employee.",
            "settings_can_be_changed_anytime": "These settings can be changed, or Human Risk Intelligence disabled, at any time."
          }
        },
        "settings_link": "Need more control? Customize advanced settings",
        "subheading": "Here's what will happen when you enable Human Risk Intelligence."
      },
      "selection": {
        "heading": "Training Strategy",
        "subheading": "Choose how Moxso prioritizes and assigns continuous training across your organization."
      },
      "signals": {
        "heading": "Signals",
        "subheading": "Configure how signals influence human risk intelligence decisions"
      },
      "steps": {
        "interventions": "Interventions",
        "introduction": "Introduction",
        "review": "Review & enable",
        "training_strategy": "Training Strategy"
      }
    },
    "osint_explanation": {
      "description": "The Moxso OSINT Engine continuously monitors the global threat landscape and transforms public cybersecurity intelligence into actionable human risk insights.",
      "title": "The Moxso OSINT (Open-Source Intelligence) Engine"
    },
    "osint_news": {
      "empty": {
        "description": "No OSINT data found for this risk",
        "heading": "OSINT data unavailable"
      },
      "title": "Threat intelligence feed"
    },
    "pages": {
      "assignments": {
        "heading": "Adaptive assignments",
        "subheading": "Training automatically assigned based on employee behavior signals."
      },
      "interventions": {
        "heading": "Interventions",
        "subheading": "Interventions triggered by employee behavior across security activities."
      },
      "osint": {
        "article": {
          "associated_risk_indicators": "Associated risk indicators",
          "hide": "Hide",
          "indicator_count": "{count} indicator | {count} indicators",
          "neutral_count": "{count} neutral",
          "risky_count": "{count} risky",
          "show": "Show",
          "vigilant_count": "{count} vigilant"
        },
        "breaches": "Breaches",
        "current": "Current",
        "heading": "Threat intelligence",
        "indicators": {
          "description": "Top in the last 24 hours",
          "empty": {
            "description": "Indicator activity will appear here when the feed has tagged risks.",
            "heading": "No indicators yet"
          },
          "title": "Risk indicators"
        },
        "negative_neutral": "Attention needed: Signal activity worsening",
        "negative_risky": "Alert: Threat activity increasing",
        "negative_vigilant": "Attention needed: Security measures declining",
        "news": {
          "description": "Last 24 hours",
          "title": "Intelligence feed"
        },
        "no_change": "No change in signal activity",
        "positive_neutral": "Positive trend: Signal activity improving",
        "positive_risky": "Positive trend: Threat activity decreasing",
        "positive_vigilant": "Positive trend: Security posture improving",
        "previous": "Previous",
        "risk_themes": "Indicators",
        "signal_change": "Signal change",
        "sources": {
          "description": "Active feeds in the last 24 hours",
          "empty": {
            "description": "Source activity will appear here when the feed has articles.",
            "heading": "No sources yet"
          },
          "title": "Sources"
        },
        "subheading": "Monitor public data sources for employee exposure and industry threats."
      },
      "overview": {
        "subheading": "Overview of human risk intelligence activity and insights."
      },
      "risk_framework": {
        "heading": "Risk framework",
        "subheading": "The Moxso framework for assessing and managing human security risk."
      },
      "signals": {
        "heading": "Behavioral signals",
        "subheading": "Signals collected from employee behavior across security activities."
      }
    },
    "risk_category": {
      "change": "Change",
      "consequences": "Consequences",
      "details_title": "Risk category details",
      "importance": "Importance",
      "indicators": "Indicators",
      "overview_title": "Risk category overview",
      "relevance": "Relevance",
      "tabs": {
        "details": "Details",
        "indicators": "Indicators"
      }
    },
    "risk_framework": {
      "change_tooltip": "Change in the last 90 days",
      "description_1": "The Moxso Risk Framework is a data-driven model for identifying, quantifying, and operationalizing human cyber risk in modern enterprises.",
      "description_2": "Aligned with industry standards such as MITRE ATT&CK and the NIST Cybersecurity Framework, it extends traditional control-based models by focusing specifically on human behavior as an attack vector. The framework transforms real-world behavioral data, threat exposure signals, and structural risk factors into measurable, auditable risk indicators.",
      "description_3": "Organized across and structured into 16 human-centric risk categories (R.01-R.16), the framework delivers consistent scoring, actionable insights, and compliance-aligned reporting.",
      "references": "Framework references",
      "short_description": "The Moxso Risk Framework is a data-driven model for identifying, quantifying, and operationalizing human cyber risk in modern enterprises.",
      "title": "Moxso Risk Framework"
    },
    "risk_matrix": {
      "axes": {
        "impact": "Impact",
        "likelihood": "Likelihood"
      },
      "legend": {
        "high": "High",
        "low": "Low",
        "med": "Med"
      },
      "title": "Signal risk matrix",
      "tooltip": {
        "change": "Change",
        "current": "Current",
        "high": "High risk signals",
        "low": "Low risk signals",
        "medium": "Medium risk signals",
        "previous": "Previous"
      }
    },
    "sections": {
      "recent_assignments": "Recent assignments",
      "recent_interventions": "Recent interventions",
      "recent_signals": "Recent signals"
    },
    "settings": {
      "common": {
        "days": "{days} days",
        "disabled": "Disabled",
        "enabled": "Enabled",
        "every_days": "Every {days} days",
        "no": "No",
        "none": "None",
        "yes": "Yes"
      },
      "eligibility": {
        "description": "Define who is eligible for automated training flows",
        "excluded_groups": "Excluded groups",
        "excluded_groups_help": "Exclude specific groups from automated training flows",
        "excluded_roles": "Excluded roles",
        "excluded_roles_help": "Exclude specific organizational roles from automated training flows",
        "minimum_employment_duration_help": "Employees must be employed for at least this many days before entering automated training flows",
        "minimum_employment_duration_label": "Minimum tenure (days)",
        "targeting_title": "Targeting",
        "title": "Eligibility & Targeting"
      },
      "interventions": {
        "actions": {
          "add_action": "Add action",
          "assign_new_lesson": "Assign new lesson",
          "assignment_description": "Assign corrective training to the affected employee.",
          "empty": "No actions yet. Add one to define what should happen when this group is triggered.",
          "heading": "Actions when triggered",
          "notify_admin": "Notify admins",
          "notify_admin_description": "Email an eligible Moxso workspace admin.",
          "notify_employee": "Notify employee",
          "notify_employee_description": "Email the affected employee about the detected behavior.",
          "notify_manager": "Notify manager",
          "notify_manager_description": "Email the employee's active manager.",
          "remove_action": "Remove {action}"
        },
        "enable_subtitle": "Let Human risk intelligence break normal assignment rules when high-risk behavior is detected, and escalate to managers and security admins.",
        "enable_title": "Enable interventions",
        "excluded_groups": "Excluded groups",
        "excluded_groups_help": "Employees in these groups are never targeted by intervention overrides.",
        "excluded_roles": "Excluded roles",
        "excluded_roles_description": "Employees in these roles are never targeted by intervention overrides.",
        "groups_description": "Choose which signal groups to monitor and configure the response for each one.",
        "groups_title": "Intervention signal groups",
        "severity_label": "Overdue severity",
        "threshold_label": "Activation threshold",
        "threshold_occurrences": "{count} occurrence | {count} occurrences",
        "timeframe_days": "Every {days} days",
        "timeframe_label": "Time period",
        "timeframe_within_90_days": "Within 90 days",
        "triggers": {
          "breach_exposure": {
            "description": "Allow immediate assignment when an employee appears in a known breach.",
            "title": "Breach exposure"
          },
          "phishing_failures": {
            "description": "Allow immediate assignment after employees fail a simulation.",
            "title": "Phishing simulation failures"
          },
          "training_non_compliance": {
            "description": "Allow immediate assignment when required training is overdue.",
            "title": "Training non-compliance"
          }
        },
        "triggers_description": "Choose which events can trigger immediate training and escalation to managers or security admins, even if an employee recently received other training.",
        "triggers_title": "Intervention triggers"
      },
      "notifications": {
        "continuous_sending_subtitle": "Automatically send reminder notifications until training is completed.",
        "continuous_sending_title": "Smart reminders",
        "enable_subtitle": "Send email notifications when new training is assigned.",
        "enable_title": "Enable notifications",
        "frequency": {
          "intense": "Intense",
          "loose": "Loose",
          "normal": "Normal (Per assignment)",
          "per_assignment": "Per assignment"
        },
        "frequency_label": "Notification cadence",
        "title": "Notifications"
      },
      "review": {
        "enable_subtitle": "Start personalized training assignments based on employee behavior",
        "enable_title": "Enable Human risk intelligence",
        "frequency": "Frequency",
        "max_assignments_per_run": "Max assignments per run: {value}",
        "notifications": "Notifications",
        "reminders_until_completion": "Reminders until completion",
        "save_settings": "Save settings",
        "selection": "Selection",
        "title": "Review & Enable"
      },
      "selection_strategy": {
        "avoid_repetition_help": "Do not reassign the same lesson within this period.",
        "avoid_repetition_label": "Avoid repeating the same training (days)",
        "cooldown_help": "Wait before assigning new human risk intelligence after any training.",
        "cooldown_label": "Cooldown period (days)",
        "enable_subtitle": "Allow Human Risk Intelligence to assign continuous training based on employee risk profiles.",
        "enable_title": "Enable Human Risk Intelligence",
        "excluded_videos": "Excluded videos",
        "excluded_videos_description": "These videos are never assigned by Human Risk Intelligence.",
        "excluded_videos_placeholder": "Select videos",
        "frameworks_help": "Select one or more frameworks to prioritize training mapped to your compliance goals.",
        "frameworks_label": "Frameworks",
        "frameworks_placeholder": "Select frameworks",
        "hide_advanced_settings": "Hide advanced settings",
        "interval_help": "Minimum days between completed trainings and new assignments.",
        "interval_label": "Interval (days)",
        "label": "Training strategy",
        "max_assignments_per_run_help": "Maximum new trainings per employee in one evaluation.",
        "max_assignments_per_run_label": "Max assignments per run",
        "show_advanced_settings": "Show advanced settings"
      },
      "signals": {
        "failed_simulation": "Failed simulation",
        "failed_simulation_help": "Weight applied when an employee clicks a phishing simulation",
        "low_score": "Low score",
        "low_score_help": "Weight applied when training quiz scores are below threshold"
      },
      "summary_eligibility": {
        "description": "Determines who is eligible for human risk intelligence",
        "excluded_roles": "Excluded roles",
        "minimum_employment_duration": "Minimum employment duration",
        "title": "Eligibility"
      },
      "summary_selection": {
        "description": "Determines how lessons are selected and how employees are notified",
        "email_notifications": "Email notifications",
        "lesson_selection": "Lesson selection",
        "maximum_lessons_per_employee": "Maximum lessons per employee",
        "minimum_time_between_lessons": "Minimum time between lessons",
        "notification_settings": "Notification settings",
        "notification_style": "Notification style",
        "prioritize_mandatory_training": "Prioritize mandatory training",
        "selection_approach": "Selection approach",
        "send_reminders_until_complete": "Send reminders until complete",
        "standard_training_interval": "Standard training interval",
        "title": "Selections & Notifications"
      },
      "summary_signals": {
        "description": "Determines how signals influence human risk intelligence decisions",
        "impact": {
          "high": "High impact",
          "low": "Low impact",
          "medium": "Medium impact"
        },
        "signal_labels": {
          "failed_simulation": "Failed phishing simulation",
          "low_score": "Low training score"
        },
        "title": "Signals"
      }
    },
    "signal": {
      "associated_risk_categories": "Associated risk categories",
      "behaviour": "Behaviour",
      "category": "Category",
      "indicator": "Indicator",
      "intel": "Intel",
      "no": "No",
      "polarity": "Polarity",
      "sentiment": "Sentiment",
      "title": "Signal",
      "value": "Value",
      "yes": "Yes"
    },
    "signal_preview": {
      "breach": {
        "title": "Dark web monitor"
      },
      "multiple_choice_quiz_answer": {
        "answer": "Answer",
        "question": "Question",
        "title": "Quiz answer"
      },
      "phishing_quiz_answer": {
        "correct": "Correct",
        "incorrect": "Incorrect",
        "question": "Question",
        "result": "Result",
        "subject": "Subject",
        "time": "Time",
        "title": "Phishing quiz answer"
      }
    },
    "stats": {
      "assignments": "Assignments",
      "completed_assignments": "Completed",
      "interventions": "Interventions",
      "negative_signals": "Negative signals",
      "positive_signals": "Positive signals",
      "risk_level": {
        "country_risk": "Country risk",
        "industry_risk": "Industry risk",
        "levels": {
          "high": "High",
          "loading": "Loading",
          "low": "Low",
          "medium": "Medium"
        },
        "title": "Risk level"
      },
      "signals": "Signals"
    },
    "tables": {
      "negative": "Negative",
      "neutral": "Neutral",
      "sentiment": "Sentiment",
      "severity": "Severity",
      "signal_count": "Signal count",
      "signal_type": "Type"
    },
    "title": "Human Risk Intelligence",
    "tooltips": {
      "compared_to_prior_period": "Compared to the same-length prior period.",
      "previous_value": "Previous value"
    },
    "trending_risk_indicators": "Trending risk indicators"
  },
  "image_library": {
    "empty_button": "Upload image",
    "empty_description": "Upload your first image to start building a reusable library.",
    "empty_title": "No image",
    "image_format": "JPG/JPEG/PNG · Up to 1MB",
    "image_uploaded": "Image uploaded successfully",
    "insert_button": "Insert image",
    "library_tab": "Image library",
    "refresh": "Refresh",
    "show_more": "Show more",
    "title": "Insert image",
    "upload_tab": "Upload",
    "upload_title": "Upload a new image"
  },
  "locale": {
    "current": "English",
    "danish": "Dansk",
    "dutch": "Nederlands",
    "english": "English",
    "french": "Français",
    "norwegian": "Norwegian",
    "polish": "Polski",
    "spanish": "Español",
    "swedish": "Svenska"
  },
  "login": {
    "back_to_login": "Back to login",
    "button": "Login",
    "change_email": "Change email?",
    "continue": "Continue",
    "forgot_password": {
      "link": "Reset it now",
      "text": "Forgot password?"
    },
    "heading": "Welcome back",
    "loading": "Loading",
    "preparing_session": "Preparing session",
    "sso": {
      "provider_found": "SSO is available for {provider}. Continue to sign in through your identity provider.",
      "redirecting": "Redirecting to SSO",
      "redirecting_text": "We are preparing your sign-in request.",
      "validating": "Validating SSO",
      "validating_text": "We are completing your sign-in."
    },
    "text": "Sign in to your workspace"
  },
  "manager_report": {
    "assignment": "Assignment",
    "assignments": "Assignments",
    "company_average": "Company average",
    "compared_against": "Compared against {period}",
    "completed": "Completed",
    "date": "Date",
    "days_overdue": "Days overdue",
    "deadline": "Deadline",
    "deadlines_description": "{count} assignments passed their due date during {period}.",
    "department": "Department",
    "employee": "Employee",
    "employees_affected": "Employees affected",
    "employees_at_risk": "Employees at risk",
    "gap_to_company": "Gap to company",
    "generated": "Generated {date}",
    "human_risk_intelligence": "Human Risk Intelligence",
    "individual_reports": "Individual training & risk reports · {count} employees | Individual training & risk reports · {count} employee | Individual training & risk reports · {count} employees",
    "interventions": "Recent interventions triggered by Moxso",
    "loading": "Loading manager report…",
    "missed_deadlines": "Missed deadlines",
    "missed_team_deadlines": "Missed team deadlines",
    "most_dangerous_signals": "Top 3 most dangerous signals this period",
    "no_assignments": "No assignments",
    "no_dangerous_signals": "No dangerous signals",
    "no_employees_at_risk": "No employees at risk",
    "no_interventions": "No interventions triggered",
    "no_missed_deadlines": "No missed deadlines",
    "no_recent_signals": "No recent signals",
    "no_sentiment_data": "No sentiment data",
    "no_severity_data": "No severity data",
    "oldest_deadline": "Oldest deadline",
    "overdue_assignments": "Overdue assignments",
    "period_over_period": "Period-over-period",
    "points": "{points} pts",
    "recent_signals": "Recent signals",
    "risk_indicator": "Risk indicator",
    "score": "Score",
    "sentiment": "Sentiment",
    "severity": "Severity",
    "signal": "Signal",
    "signals": "Signals",
    "signals_by_sentiment": "Signals by sentiment",
    "signals_by_severity": "Signals by severity",
    "sorted_by_deadline": "Sorted by deadline",
    "status": "Status",
    "summary": "Summary",
    "team_average": "Team average",
    "threshold": "Threshold {value}% · sorted low to high",
    "title": "Manager report",
    "total": "{count} total",
    "training_report": "Training report",
    "trend_title": "Resilience, click & report rate",
    "type": "Type",
    "unavailable": "Report unavailable",
    "unavailable_description": "The report could not be loaded. Check that the report URL is valid and has not expired."
  },
  "navigation": {
    "assigned_learning": "Assigned learning",
    "at_risk": "Employees at risk",
    "audit": {
      "index": "Audit",
      "settings": "Settings"
    },
    "automation": {
      "flow_builder": "Sequence builder",
      "index": "Automation",
      "sequence": "Sequence",
      "settings": "Settings"
    },
    "breaches": "Breaches",
    "configuration": "Configuration",
    "custom_upload": {
      "edit": "Edit",
      "quiz": "Quiz"
    },
    "dashboard": "Analytics",
    "employees": "Employees",
    "goals": "Goals",
    "groups": {
      "index": "Groups",
      "settings": "Settings",
      "single": "Group"
    },
    "human_risk_intelligence": "Human risk intelligence",
    "integration": {
      "activity": "Activity",
      "settings": "Settings"
    },
    "integrations": "Integrations",
    "knowledge_base": "Knowledge base",
    "lessons_courses": "Courses",
    "lessons_deadlines": "Deadlines",
    "lessons_videos": "Videos",
    "no_workspaces": "No workspaces found",
    "overview": "Overview",
    "policies": "Policies",
    "policy": {
      "edit": "Edit",
      "quiz": "Quiz"
    },
    "resilience": "Resilience",
    "search_workspaces": "Search workspaces...",
    "settings": {
      "administration": "Administration",
      "admins": "Admins",
      "apis_and_data": "APIs & data",
      "audit_logs": "Audit logs",
      "authentication": "Authentication",
      "back_to_app": "Back to app",
      "breaches": "Breaches",
      "close_navigation": "Close navigation",
      "compliance": "Compliance",
      "domains": "Domains",
      "e_learning": "Training",
      "export": "Export",
      "exports": "Exports",
      "goals": "Goals",
      "human_risk_intelligence": "Human risk intelligence",
      "import": "Import",
      "index": "Settings",
      "interventions": "Interventions",
      "personal": "Personal",
      "reporting": "Reporting",
      "risk": "Risk",
      "simulations": "Simulations",
      "threats": "Threats",
      "workspace": "Workspace"
    },
    "sign_out": "Sign out",
    "simulations": {
      "custom_templates": "Custom templates",
      "index": "Simulations",
      "scheduled": "Scheduled",
      "single": "Activity",
      "single_settings": "Settings"
    },
    "team": "Employees",
    "threats": "Threats",
    "training": "Training",
    "user_settings": "Security and access",
    "your_workspaces": "Your workspaces"
  },
  "oauth": {
    "back_to_home": "Back to home",
    "error": "Integration could not be configured",
    "login": "Sign in",
    "success": "Provider successfully saved"
  },
  "onboarding": {
    "building_training_paths": "Building training paths",
    "calculating_risk_score": "Calculating risk score",
    "choose_provider": "Choose your identity provider",
    "continue_button": "Continue",
    "exit": "Exit",
    "gmail_integration": "Gmail integration",
    "google_manual_setup": {
      "access_google_admin_console_heading": "Access Google Admin Console",
      "access_google_admin_console_text": "Log in to the Google Workspace Admin console: {google_admin_console_link}",
      "allow_moxso_ip_addresses_bullet_1": "Expand the {email_allowlist} section.",
      "allow_moxso_ip_addresses_bullet_2": "Enter the following Moxso IP addresses: {ip_1} {ip_2}",
      "allow_moxso_ip_addresses_bullet_3": "Click {save_button}.",
      "allow_moxso_ip_addresses_heading": "Allow Moxso IP Addresses",
      "configure_inbound_gateway_bullet_1": "Expand the {inbound_gateway} section.",
      "configure_inbound_gateway_bullet_2": "Enable the gateway by toggling the switch.",
      "configure_inbound_gateway_bullet_3": "Enter the following Moxso IP addresses under {gateway_ips}: {ip_1} {ip_2}",
      "configure_inbound_gateway_bullet_4": "Enable {require_tls}.",
      "configure_inbound_gateway_bullet_5": "In the {message_tagging_section} section, enable {message_spam_eval_header}.",
      "configure_inbound_gateway_bullet_6": "Enter the following value in the {regexp_field} field: {uuid}",
      "configure_inbound_gateway_bullet_7": "Enable {disable_gmail_spam_eval}.",
      "configure_inbound_gateway_bullet_8": "Click {save_button} to apply the settings.",
      "configure_inbound_gateway_heading": "Configure Inbound Gateway",
      "configure_spam_rule_bullet_1": "Navigate to {spam_settings}: In the same menu {menu_path}, find the Spam section.",
      "configure_spam_rule_bullet_2": "Add a new rule: Click {add_rule} (or edit an existing Moxso rule) and give it a name like {rule_name}.",
      "configure_spam_rule_bullet_3": "Configure the bypass: Select {bypass_option}",
      "configure_spam_rule_bullet_4": "Hide warnings (critical): Ensure you check {hide_warnings_option}",
      "configure_spam_rule_bullet_5": "Ensure the simulation domains are added to the address list for this rule by downloading the CSV:",
      "configure_spam_rule_bullet_6": "Save the rule.",
      "configure_spam_rule_heading": "Configure Spam Rule (Bypass Warnings)",
      "disable_gmail_spam_eval": "Disable Gmail spam evaluation on mail from this gateway; only use header value.",
      "email_allowlist": "Email allow list",
      "gateway_ips": "Gateway IPs",
      "google_admin_console": "Google Admin Console",
      "inbound_gateway": "Inbound gateway",
      "inbound_gateway_warning_not_checked": "not checked",
      "inbound_gateway_warning_text": "Ensure that {reject_option} is {not_checked}. If this option remains enabled, you will only be able to receive emails from Moxso and not from external senders.",
      "message_spam_eval_header": "Message is considered spam if the following header regexp matches",
      "message_tagging": "Message tagging",
      "navigate_spam_phishing_malware_heading": "Navigate to Spam, Phishing, and Malware Settings",
      "navigate_spam_phishing_malware_text": "Go to the Gmail settings for spam, phishing, and malware: {spam_phishing_link}",
      "regexp": "Regexp",
      "require_tls": "Require TLS for connections from the email gateways listed above.",
      "save": "Save",
      "spam_phishing_malware_settings": "Spam, Phishing, and Malware Settings",
      "whitelisting_moxso_ip_addresses_in_gw": "Allowlisting Moxso IP Addresses in Google Workspace"
    },
    "import_employees": "Import employees",
    "integration_error": "An error occurred when setting up the integration to {provider}.",
    "integration_error_title": "An error occurred",
    "invite": {
      "button": "Invite user",
      "text": "We'll send them an email to get started.",
      "title": "Invite team members to your dashboard"
    },
    "microsoft_bypass_junk_by_header": {
      "bypass_junk_by_header": "Bypass Junk By Header",
      "finish": "finish",
      "step_1_heading": "Exchange admin center",
      "step_1_text": "Navigate to Mail flow rules in the Exchange admin center by visiting the following URL: {url}",
      "step_2_heading": "Create a new rule",
      "step_2_text": "Create a new rule and give it a name. For example: {copyField}",
      "step_2b_heading": "Configure rule",
      "step_2b_list_1": "Select \"The message headers...\"",
      "step_2b_list_2": "Then choose \"matches these text patterns\".",
      "step_2b_p1": "Click the first \"Enter text\" link and enter the header key: {copyField}",
      "step_2b_p2": "Click the next \"Enter text\" link and enter the following header value: {copyField}",
      "step_2b_text": "In the \"Apply this rule if\" drop-down menu:",
      "step_3_heading": "Configure Message Header",
      "step_3_list_1": "Select \"Modify the message properties\"",
      "step_3_list_2": "Then choose \"Set a message header\".",
      "step_3_list_3": "Click the first \"Enter text\" link and set the header to: {copyField}",
      "step_3_list_4": "Click the second \"Enter text\" link and set the value to: {copyField}",
      "step_3_text": "In the \"Do the following\" drop-down menu:",
      "step_4_heading": "Rule settings",
      "step_4_list_1": "Click \"next\" and continue to rule settings.",
      "step_4_list_2": "Under \"Rule mode\" select \"Enforce\".",
      "step_4_list_3": "Click \"next\" and review the rule configuration.",
      "step_5_heading": "Save the Rule",
      "step_5_text": "Click {finish} to save and apply the rule."
    },
    "microsoft_bypass_junk_by_ip": {
      "bypass_junk_by_ip": "Bypass Junk By IP",
      "configure_message_header_heading": "Configure Message Header",
      "configure_message_header_text_bullet_1": "Select {modify_message_props}",
      "configure_message_header_text_bullet_2": "Then choose {set_msg_header}",
      "configure_message_header_text_bullet_3": "Click the first \"Enter text\" link and set the header to: {header}",
      "configure_message_header_text_bullet_4": "Click the second \"Enter text\" link and set the value to: {value}",
      "configure_message_header_text_intro": "In the \"Do the following\" drop-down menu:",
      "configure_rule_heading": "Configure rule",
      "configure_rule_text_bullet_1": "Select {the_sender}",
      "configure_rule_text_bullet_2": "Then choose {ip_range}",
      "configure_rule_text_bullet_3": "Enter the following IP addresses one by one in the popup and click \"Add\". When you are done click \"Save\".",
      "configure_rule_text_intro": "In the \"Apply this rule if\" drop-down menu:",
      "create_new_rule_heading": "Create a new rule",
      "create_new_rule_text": "Create a new rule and give it a name. For example: {example}",
      "exchange_admin_center_heading": "Exchange admin center",
      "exchange_admin_center_text": "Navigate to Mail flow rules in the Exchange admin center by visiting the following URL: {url}",
      "rule_settings_bullet_1": "Click \"next\" and continue to rule settings.",
      "rule_settings_bullet_2": "Under \"Rule mode\" select \"Enforce\".",
      "rule_settings_bullet_3": "Click \"next\" and review the rule configuration.",
      "rule_settings_heading": "Rule settings",
      "save_the_rule_heading": "Save the Rule",
      "save_the_rule_text": "Click {finish} to save and apply the rule."
    },
    "microsoft_bypass_safe_links_by_header": {
      "bypass_safe_links_by_header": "Bypass Safe Links By Header",
      "configure_message_header_heading": "Configure Message Header",
      "configure_message_header_text_bullet_1": "Select {modify_message_properties}",
      "configure_message_header_text_bullet_2": "Then choose {set_a_message_header}",
      "configure_message_header_text_bullet_3": "Click the first \"Enter text\" link and set the header to: {header}",
      "configure_message_header_text_bullet_4": "Click the second \"Enter text\" link and set the value to: {value}",
      "configure_message_header_text_intro": "In the \"Do the following\" drop-down menu:",
      "configure_rule_heading": "Configure rule",
      "configure_rule_text_bullet_1": "Select {the_message_headers}",
      "configure_rule_text_bullet_2": "Then choose {matches_text_patterns}",
      "configure_rule_text_intro": "In the \"Apply this rule if\" drop-down menu:",
      "configure_rule_text_paragraph_1": "Click the first \"Enter text\" link and enter the header key: {header_key}",
      "configure_rule_text_paragraph_2": "Click the next \"Enter text\" link and enter the following header value: {header_value}",
      "create_new_rule_heading": "Create a new rule",
      "create_new_rule_text": "Create a new rule and give it a name. For example: {example}",
      "exchange_admin_center_heading": "Exchange admin center",
      "exchange_admin_center_text": "Navigate to Mail flow rules in the Exchange admin center by visiting the following URL: {url}",
      "rule_settings_bullet_1": "Click \"next\" and continue to rule settings.",
      "rule_settings_bullet_2": "Under \"Rule mode\" select \"Enforce\".",
      "rule_settings_bullet_3": "Click \"next\" and review the rule configuration.",
      "rule_settings_heading": "Rule settings",
      "save_the_rule_heading": "Save the Rule",
      "save_the_rule_text": "Click {finish} to save and apply the rule."
    },
    "microsoft_bypass_safe_links_by_ip": {
      "bypass_safe_links_by_ip": "Bypass Safe Links By IP",
      "configure_message_header_heading": "Configure Message Header",
      "configure_message_header_text_bullet_1": "Select {modify_message_props}",
      "configure_message_header_text_bullet_2": "Then choose {set_msg_header}",
      "configure_message_header_text_bullet_3": "Click the first \"Enter text\" link and set the header to: {header}",
      "configure_message_header_text_bullet_4": "Click the second \"Enter text\" link and set the value to: {value}",
      "configure_message_header_text_intro": "In the \"Do the following\" drop-down menu:",
      "configure_rule_heading": "Configure rule",
      "configure_rule_text_bullet_1": "Select {the_sender}",
      "configure_rule_text_bullet_2": "Then choose {ip_range}",
      "configure_rule_text_bullet_3": "Enter the following IP addresses one by one in the popup and click \"Add\". When you are done click \"Save\".",
      "configure_rule_text_intro": "In the \"Apply this rule if\" drop-down menu:",
      "create_new_rule_heading": "Create a new rule",
      "create_new_rule_text": "Create a new rule and give it a name. For example: {example}",
      "exchange_admin_center_heading": "Exchange admin center",
      "exchange_admin_center_text": "Navigate to Mail flow rules in the Exchange admin center by visiting the following URL: {url}",
      "rule_settings_bullet_1": "Click \"next\" and continue to rule settings.",
      "rule_settings_bullet_2": "Under \"Rule mode\" select \"Enforce\".",
      "rule_settings_bullet_3": "Click \"next\" and review the rule configuration.",
      "rule_settings_heading": "Rule settings",
      "save_the_rule_heading": "Save the Rule",
      "save_the_rule_text": "Click {finish} to save and apply the rule."
    },
    "microsoft_integration": "Microsoft allowlisting",
    "microsoft_tenant_allow_block": {
      "add_moxso_ips_to_tabl": "Add Moxso IPs to Tenant Allow/Block Lists",
      "add_new_entry_bullet_1": "Click the {add_button} button.",
      "add_new_entry_bullet_2": "In the domain pairs section, enter the following: {domain_pair_1} {domain_pair_2}",
      "add_new_entry_bullet_3": "Set Spoof type to {spoof_internal}.",
      "add_new_entry_bullet_4": "Set Action to {allow_action}.",
      "add_new_entry_heading": "Add a New Entry",
      "microsoft_defender_heading": "Microsoft Defender",
      "microsoft_defender_text": "Navigate to the Tenant Allow/Block Lists in Microsoft Defender by visiting the following URL: {url}",
      "save_the_domain_pair_heading": "Save the domain pair",
      "save_the_domain_pair_text": "Click {add} to save the new domain pair."
    },
    "microsoft_third_party": {
      "add_moxso_ips_domains_title": "Add Moxso's IPs and domains to the Third-Party Phishing Simulation in Microsoft Defender",
      "download_simulation_heading": "Download simulation domains/IP's",
      "download_simulation_text": "Download the simulation domains/IP's by clicking the button below: {csv_export_button}",
      "edit_entries_bullet_1": "Click the {edit_button} button.",
      "edit_entries_bullet_2": "In the {domain_section} section, input each domain listed as {domain_text} in the downloaded CSV file.",
      "edit_entries_bullet_3": "In the {sending_ip_section} section, enter the following: {ip_1} {ip_2}",
      "edit_entries_heading": "Edit entries",
      "microsoft_defender_heading": "Microsoft Defender",
      "microsoft_defender_text": "Navigate to the Third-Party Phishing Simulation settings in Microsoft Defender by visiting the following URL: {url}",
      "save_the_domain_pair_heading": "Save the domain pair",
      "save_the_domain_pair_text": "Click {save_button} to save the Third-party phishing simulation settings."
    },
    "redirecting": "Redirecting",
    "results": {
      "button": "Go to dashboard",
      "text": "Welcome aboard! Based on your responses, we have assigned training levels that best suit you. You can adjust these at any time in the settings.",
      "title": "Your summary"
    },
    "risk": {
      "approx_training_time_per_month": "Approximate training time per month",
      "more_training_more_time": "Higher resilience targets exponentially increase training time",
      "targeted_resilience_score": "Targeted resilience score",
      "text": "Use the slider to indicate your company’s overall risk exposure and tolerance. Consider your industry, the nature of your operations, and the sensitivity of the information you handle when selecting a risk level.",
      "title": "Set organisation risk level"
    },
    "select_your_email_provider": "Select your email provider for step-by-step allowlisting instructions.",
    "setting_up_workspace": "Setting up workspace",
    "skip_button": "Skip allowlisting",
    "skip_this_step": "Skip this step",
    "sync_started": "Sync started",
    "toggle_gmail_api_integration": "Use Gmail API Integration",
    "try_integration_again": "Try again",
    "use_powershell": "Use PowerShell",
    "verifying_integration": "Verifying integration",
    "we_are_now_importing_employees": "We're syncing employees from {provider}.",
    "welcome": {
      "graphic": {
        "text": "You can also skip this step for now.",
        "title": "Choose your identity provider to get started"
      },
      "text": "To get the most out of Moxso, we recommend going through this onboarding.",
      "title": "Welcome to Moxso"
    }
  },
  "pagination": "Page {page} of {lastPage}",
  "policies": {
    "approve_button": "Approve policy",
    "approve_warning": "Finalizing this policy will disable any future editing. Do you wish to proceed?",
    "approve_warning_title": "Approve policy",
    "audit": {
      "cancel": {
        "audit_canceled": "Audit canceled",
        "button": "Cancel Audit",
        "title": "Cancel Audit",
        "warning": "All pending notifications will be stopped immediately and assigned users will lose access to this policy. Do you wish to proceed?"
      },
      "details": {
        "all_completed_tooltip": "All {count} employees have acknowledged the audit",
        "completed_tooltip": "No employees have acknowledged the audit | {count} out of {total} employees have acknowledged the audit | {count} out of {total} employees have acknowledged the audit",
        "created_at": "Created at",
        "end_date": "End date",
        "enrolling_participants_heading": "Enrolling participants",
        "enrolling_participants_text": "Participants are being enrolled. Please wait.",
        "group": "Group",
        "groups_heading": "Audience",
        "groups_text": "Audience details",
        "heading": "Audit",
        "included_members_count_new_members_tooltip": "New members added to the group after this audit was started are not included.",
        "included_members_count_tooltip": "Employees who have already acknowledged this policy and new members added to the group after this audit was started are excluded.",
        "members": "Members",
        "no_participants_text": "No participants for this audit",
        "no_participants_title": "No participants",
        "not_active_yet_text": "Start audit to enroll participants.",
        "not_active_yet_title": "Audit not active",
        "start_date": "Start date",
        "status": "Status",
        "text": "Audit details"
      },
      "filters": {
        "acknowledged": "Acknowledged",
        "acknowledged_at": "Acknowledged at",
        "acknowledged_default": "All",
        "acknowledged_label": "Acknowledgement",
        "not_acknowledged": "Pending"
      },
      "launch": {
        "audit_started": "Audit started",
        "button": "Start audit",
        "input_label": "Recipient count",
        "title": "Start audit",
        "warning": "You're about to start an audit that will distribute the policy to members of the following groups. Do you wish to proceed?"
      },
      "single": {
        "settings": "Settings",
        "title": "Audit"
      }
    },
    "audit_draft": "Inactive",
    "audit_running": "Auditing",
    "audits": {
      "create": {
        "buttons": {
          "back": "Go back",
          "continue": "Continue",
          "submit": "Create audit"
        },
        "date_range": "Audit period",
        "date_range_placeholder": "Select audit start and end date",
        "error": "An error occurred while creating the audit",
        "select_groups": "Select groups",
        "title": "Create audit"
      },
      "create_new_button": "Add audit",
      "created": "Audit created successfully",
      "edit_button": "Edit",
      "empty": "No audits available for this policy",
      "help": {
        "include_previously_signed": "Employees who have already acknowledged this policy will be included in the audit.",
        "notification_flow_enabled": "Enable automatic notifications for employees who have not yet acknowledged the policy",
        "notification_prelude_enabled": "Send a notification to employees when a new policy is assigned to them."
      },
      "labels": {
        "include_previously_signed": "Include already acknowledged employees",
        "notification_flow_enabled": "Enable notification flow",
        "notification_frequency": "Notification frequency",
        "notification_prelude_enabled": "Enable prelude notification"
      },
      "policy_not_approved_yet": "Approve policy to initiate an audit.",
      "save_settings": "Save settings",
      "title": "Audit history",
      "updated": "Audit was updated"
    },
    "create": {
      "create_button": "Create policy",
      "duplicate": "Duplicate",
      "duplicated": "Policy duplicated!",
      "from_template": {
        "text": "Choose from a library of common policies.",
        "title": "Create policy from template"
      },
      "labels": {
        "locale": "Language",
        "title": "Title"
      },
      "manual": {
        "text": "Create policy with nothing filled in.",
        "title": "Create policy from scratch"
      },
      "placeholders": {
        "locale": "Choose primary language of the policy",
        "title": "Policy title"
      },
      "success": "Policy created!",
      "title": "Create Policy"
    },
    "delete": {
      "are_you_sure": "Are you sure you want to delete this policy? This action cannot be undone.",
      "button": "Delete",
      "policy_deleted": "Policy deleted."
    },
    "edit": {
      "subtitle": "Edit policy content and details",
      "title": "Edit Policy",
      "title_updated": "Title changed successfully"
    },
    "editor": {
      "add_column_after": "Add column after",
      "add_column_before": "Add column before",
      "add_row_after": "Add row below",
      "add_row_before": "Add row above",
      "delete_column": "Delete column",
      "delete_image": "Delete image",
      "delete_row": "Delete row",
      "delete_table": "Delete table",
      "insert_image": "Insert image",
      "insert_table": "Insert table",
      "merge_cells": "Merge cells",
      "split_cell": "Split cell",
      "table": "Table",
      "toggle_header_row": "Toggle header row"
    },
    "list": {
      "create_new": "Create policy",
      "subtitle": "Overview of all policies",
      "title": "Policies"
    },
    "policy_approved": "Policy approved.",
    "quiz": {
      "create_button": "Create quiz",
      "done_translate_button": "Done",
      "edit_button": "Edit quiz",
      "empty": "No quizzes",
      "other_translations_have_quizzes": "Other translations have quizzes",
      "other_translations_have_quizzes_want_to_translate": "Other translations already have quizzes. Do you want to automatically translate this quiz into those languages?",
      "processing_n_languages": "Processing one language | Processing {count} languages",
      "quiz": "Quiz",
      "quiz_now_available_in": "Your quiz is now available in one additional language | Your quiz is now available in {count} additional languages",
      "quiz_translate_success": "Success!",
      "quizzes_translated": "Quizzes translated.",
      "select_the_languages_you_want_to_translate_your_quiz_into": "Select the languages you want to translate your quiz into",
      "some_translations_have_no_quizzes": "Some translations currently have no quizzes. Translate now?",
      "subtitle": "Available quizzes",
      "this_translation_has_quizzes_in_other_languages_translate_automatically": "This translation has quizzes in other languages. Translate automatically?",
      "title": "Quizzes",
      "translate_button": "Translate",
      "translate_from": "Translate from",
      "translate_multiple_choice_quiz": "Translate multiple choice quiz",
      "translate_quiz": "Translate",
      "translating_your_quiz": "Translating your quiz",
      "update_this_quiz_and_translate_others": "Update this quiz and translate other quizzes",
      "update_this_quiz_only": "Update this quiz only",
      "view_button": "View quiz"
    },
    "single": {
      "audits": "Audits",
      "audits_subtitle": "Audit history",
      "details": {
        "heading": "Details",
        "text": "Policy details"
      },
      "labels": {
        "acknowledgement_rate": "Acknowledgement rate",
        "approval": "Approval status",
        "approved_at": "Approved on {approved_at}",
        "approved_by": "Approved by {user}",
        "created_at": "Created at",
        "edit": "Edit",
        "id": "ID",
        "latest_audit_status": "Latest audit status",
        "not_approved": "Not approved",
        "updated_at": "Updated at"
      },
      "subtitle": "Available translations",
      "title": "Policy"
    },
    "tables": {
      "approved_at": "Approved at",
      "created_at": "Created at",
      "has_active_audit": "Audit status",
      "status_approved": "Approved",
      "status_draft": "Draft",
      "title": "Title"
    },
    "translations": {
      "ai": {
        "done_translate_button": "Done",
        "policy_now_available_in": "Your policy is now available in one additional language | Your policy is now available in {count} additional languages",
        "policy_translate_success": "Success!",
        "processing_n_languages": "Processing one language | Processing {count} languages",
        "text": "Use DeepL to automatically translate the policy into a selected language.",
        "title": "Translate policy with AI",
        "translate_button": "Translate",
        "translate_from": "Translate from",
        "translating_your_policy": "Translating your policy"
      },
      "create": "Translate",
      "create_deepl_new_button": "Translate with AI",
      "create_new_button": "Add translation",
      "create_success": "Translation created successfully",
      "create_title": "Add translation",
      "created_at": "Created",
      "default_badge": "Default",
      "delete_are_you_sure": "Are you sure you want to delete this translation? This action cannot be undone.",
      "delete_button": "Delete",
      "edit_button": "Edit",
      "edit_views": {
        "edit": "Edit",
        "preview": "Preview"
      },
      "empty": "No translations for this policy",
      "empty_sections_overview": {
        "subtitle": "Add a Heading 1 to create a new section",
        "title": "No sections added"
      },
      "language": "Language",
      "last_updated": "Last Updated",
      "locked": "Editing locked as policy is approved.",
      "make_default": "Set as default",
      "manual": {
        "first_translation_text": "Get started by creating a translation from scratch",
        "first_translation_title": "Create policy translation",
        "text": "Rewrite the translation from scratch in a new language.",
        "title": "Manually translate policy"
      },
      "save": "Save changes",
      "save_success": "Translation saved successfully",
      "save_success_title": "Title changed successfully",
      "select_locale": "Target Language",
      "select_locale_placeholder": "Choose the language for your translation",
      "subtitle": "Manage translations for this policy",
      "title": "Translations",
      "title_label": "Translation Title",
      "title_placeholder": "Enter translation title",
      "translation_deleted": "Translation deleted.",
      "view_button": "View"
    }
  },
  "quiz_builder": {
    "buttons": {
      "add_ai_question": "Add AI question",
      "add_option": "Add option",
      "add_question": "Add question",
      "close": "Close",
      "edit": "Edit",
      "save_quiz": "Save quiz"
    },
    "delete_question_confirmation": {
      "are_you_sure": "Are you sure you want to delete this question?",
      "button": "Delete question"
    },
    "empty": {
      "ai_create_button": "Use Moxso Intelligence",
      "ai_description": "Get started by either adding the first question or using Moxso AI to generate a quiz.",
      "create_button": "Create quiz",
      "description": "Get started by adding the first question.",
      "manually_create_button": "Manually create quiz",
      "title": "No questions yet"
    },
    "labels": {
      "answer_options": "Answer options",
      "question": "Question"
    },
    "placeholders": {
      "answer_option": "Enter option",
      "question": "Enter question"
    },
    "quiz_saved": "Quiz saved",
    "quizzes_translated": "Quizzes translated.",
    "titles": {
      "question": "Question {number}"
    }
  },
  "report": {
    "click_rate": "Click rate",
    "from_value": "from {value}",
    "last_12_months": "Last 12 months",
    "last_six_months": "Last 6 months",
    "no_data": "No data",
    "polarity": "Polarity",
    "report_rate": "Report rate",
    "resilience": "Resilience",
    "simulations": "Simulations",
    "training": "Training",
    "vs_previous_period": "vs prev. period"
  },
  "reset_password": {
    "heading": "Reset password",
    "success_message": "Password saved successfully",
    "text": "Please choose a new password"
  },
  "seo_titles": {
    "automation": {
      "action": "Automation participants",
      "edit": "Edit automation",
      "index": "Automations",
      "single": "Sequence"
    },
    "breach": {
      "index": "Breaches",
      "single": "Breach"
    },
    "campaign": {
      "index": "Simulations",
      "single": "Simulation",
      "templates": "Custom templates"
    },
    "dashboard": {
      "breaches": "Dashboard – Breaches",
      "human_risk_intelligence": "Dashboard - Human risk intelligence",
      "overview": "Dashboard",
      "resilience": "Dashboard – Resilience",
      "simulations": "Dashboard – Simulations",
      "threats": "Dashboard – Threats",
      "training": "Dashboard – Training"
    },
    "employee": {
      "index": "Employees",
      "single": "Employee"
    },
    "forgot_password": "Reset password",
    "group": {
      "index": "Groups",
      "single": "Group"
    },
    "impersonate": "Impersonate",
    "integration": "Integration",
    "invite": {
      "id": "Accept invite",
      "index": "Accept invite"
    },
    "login": "Sign in",
    "policies": {
      "audit": "Audit",
      "index": "Policies",
      "single": "Edit Policy Translation",
      "translations": "Policy Translations"
    },
    "reset_password": "Reset password",
    "settings": {
      "breaches": "Settings – Breaches",
      "domains": "Settings – Domains",
      "e_learning": "Settings – Training",
      "export": "Settings – Export data to CSV",
      "import": "Settings – Import from CSV",
      "index": "Settings – Workspace",
      "integrations": {
        "index": "Settings – Integrations",
        "single": "Settings – Edit integration"
      },
      "risk": "Settings – Risk",
      "simulations": "Settings – Simulations",
      "threats": "Settings – Threats"
    },
    "threat": {
      "index": "Threats",
      "single": "Threat"
    },
    "training": {
      "deadlines": "Deadlines",
      "index": "Training",
      "participation": "Participation"
    },
    "two_factor": "Two-factor authentication",
    "user_settings": "User settings",
    "validate_domain": "Validate domain"
  },
  "settings": {
    "breaches": {
      "enable_breaches": {
        "help": "Enable breaches for this workspace.",
        "title": "Enable breaches"
      },
      "enable_notifications": {
        "help": "Notify employees directly when they are involved in new breaches.",
        "title": "Enable notifications"
      },
      "subtitle": "Configure your breach settings.",
      "title": "Breaches"
    },
    "buttons": {
      "add_domain": "Add domain",
      "add_report": "Add report",
      "add_user": "Add user",
      "resend_invitation": "Resend email",
      "revoke_access": "Revoke access",
      "save_settings": "Save settings",
      "verify_domain": "Verify"
    },
    "data": {
      "subtitle": "When enabled, records will be anonymized 90 days after their last relevant action.",
      "title": "Data anonymization"
    },
    "domains": {
      "domain_added": "Domain created",
      "domain_required": "Please input a domain",
      "subtitle": "Manage domain names owned by your workspace.",
      "title": "Verified domains",
      "verification_email_sent": "Verification email sent",
      "verification_required": "Verification pending",
      "verified": "Verified",
      "verified_on": "Verified on:",
      "verify_new_domain": "Verify new domain"
    },
    "e_learning": {
      "alert": {
        "not_allowed": "Not allowed",
        "optional_courses": "Optional courses",
        "optional_courses_description": "Courses outside of mandatory training",
        "optional_quiz_questions": "Quiz questions",
        "optional_quiz_questions_description": "Optional phishing quiz questions",
        "optional_videos": "Optional videos",
        "optional_videos_description": "Videos outside of mandatory training",
        "quiz_limit_value": "15 per week",
        "title": "Restrictions applied when enabled",
        "video_limit_value": "2 per week"
      },
      "modes": {
        "automatic": {
          "description": "Moxso runs your training program for you, end to end.",
          "recommended": "Recommended",
          "title": "Automatic training"
        },
        "confirmation": {
          "automatic": {
            "description": "Moxso starts assigning training automatically.",
            "title": "Switch to automatic training?"
          },
          "manual": {
            "description": "Moxso stops assigning training. Existing assignments are kept.",
            "title": "Switch to scheduled training?"
          },
          "switch": "Switch"
        },
        "help": "Choose how training is assigned across your organization.",
        "label": "Training mode",
        "manual": {
          "description": "Admins schedule and assign training themselves.",
          "title": "Scheduled training"
        },
        "will_be_hidden": "Will be hidden after switching"
      },
      "subtitle": "Configure your training settings.",
      "title": "Training"
    },
    "exports": {
      "custom": "Custom",
      "default": "Default",
      "download_export": "Download export",
      "export_type": {
        "automation": "Automation report",
        "employee": "Employee report",
        "text": "Select the type of export you want to generate.",
        "title": "Export type",
        "training": "Training report"
      },
      "form": {
        "deselect_all": "Deselect all fields",
        "select_all": "Select all fields"
      },
      "reports": {
        "delete_button": "Delete",
        "deleted_success": "Report deleted",
        "download_button": "Download",
        "edit_button": "Edit",
        "search": "Search",
        "subtitle": "Configure scheduled reports for your workspace.",
        "title": "Scheduled reports"
      },
      "selected_columns": "Fields({count}): {columns}",
      "subtitle": "Select the data you want to export.",
      "title": "Download export"
    },
    "forms": {
      "company": {
        "label": "Company",
        "placeholder": "Company"
      },
      "custom_deeplink_url": {
        "description": "Use ::content_id:: as a required placeholder for the content id.",
        "label": "Custom content URL",
        "placeholder": "https://example.com/launch/something-::content_id::"
      },
      "custom_lms_url": {
        "label": "Custom LMS URL",
        "placeholder": "https://example.com/launch/"
      },
      "data_enrichment": {
        "subtitle": "Assign roles to employees based on their data.",
        "title": "Employee data enrichment",
        "tooltip": "Employee data enrichment uses AI to assign roles to employees based on their department and groups."
      },
      "enhanced_scoring": {
        "subtitle": "Weight resilience scores based on employee roles.",
        "title": "Enhanced scoring",
        "tooltip": "Enhanced scoring applies different weights depending on how security-critical a role is, so individuals with greater access or responsibility must do more to reach the same resilience score."
      },
      "gdpr": {
        "employees": {
          "help": "Automatically anonymize inactive employees.",
          "title": "Anonymize inactive employees"
        },
        "threats": {
          "help": "Automatically anonymize threat data.",
          "title": "Anonymize handled threats"
        }
      },
      "hotline": {
        "description": "This will be the primary contact for your team in case of a potential threat or employee requests.",
        "label": "Hotline",
        "placeholder": "it{'@'}company.com"
      },
      "industry": {
        "label": "Industry"
      },
      "labels": {
        "active_status": "Status",
        "automation": "Automation",
        "custom_fields": "Fields",
        "date_range": "Select dates",
        "domain": "Domain",
        "email": "Email",
        "first_name": "First name",
        "group": "Group",
        "last_name": "Last name",
        "report_frequency": "Frequency",
        "report_period": "Period",
        "report_recipient": "Recipient",
        "report_status": "Status",
        "report_type": "Report Type",
        "role": "Role",
        "training_type": "Type"
      },
      "leaderboard": {
        "enabled": {
          "subtitle": "Enable to show a leaderboard in the hub and choose how employees are ranked.",
          "title": "Leaderboard"
        },
        "options": {
          "point_leaderboard": "Points leaderboard",
          "score_leaderboard": "Resilience score leaderboard"
        },
        "setting": {
          "label": "Type"
        }
      },
      "placeholders": {
        "date_range": "Select dates",
        "domain": "company.com",
        "email": "name{'@'}company.com",
        "first_name": "First name",
        "last_name": "Last name",
        "report_recipient": "Search for employee",
        "search_employee": "Search employee"
      },
      "reports": {
        "add_scheduled_report": "Add scheduled report",
        "choose_report_type": "Choose a different report type",
        "description": "Set up scheduled reports to be sent automatically.",
        "edit_scheduled_report": "Edit scheduled report",
        "hierarchy_level": {
          "description": "When enabled, the report includes employees further down the hierarchy, not just direct reports.",
          "label": "Enable roll up reporting"
        },
        "manager_report": {
          "text": "A report for managers about their employees.",
          "title": "Manager report"
        },
        "workspace_report": {
          "text": "A report for the entire workspace.",
          "title": "Workspace report"
        }
      },
      "scim": {
        "add_title": "Create SCIM token",
        "connection_add_title": "Create SCIM connection",
        "connection_created": "SCIM connection created.",
        "connection_deleted": "SCIM connection deleted.",
        "connection_name_label": "Connection name",
        "connection_name_placeholder": "Microsoft Entra ID",
        "connection_saved": "SCIM connection saved.",
        "connection_token_name_placeholder": "{name} provisioning",
        "create_connection_button": "Create connection",
        "create_token_button": "Create token",
        "create_token_header": "Create token",
        "created_title": "SCIM token created",
        "default_mapping_marker": "Default",
        "delete_connection_body": "This will remove the connection and revoke all SCIM tokens linked to it. Provisioning from this provider will stop immediately.",
        "delete_connection_button": "Delete connection",
        "delete_connection_title": "Delete SCIM connection?",
        "done": "Done",
        "edit_connection_button": "Edit connection",
        "enabled_label": "Enabled",
        "name_help": "Give your token a descriptive name to help you identify it later.",
        "name_label": "Token name",
        "name_placeholder": "Microsoft Entra provisioning",
        "note_cannot_view": "This token is only shown once. Store it in your identity provider before closing this dialog.",
        "provider_label": "Provider",
        "reset_mapping_button": "Reset to defaults",
        "revoke_body": "Provisioning requests using this token will stop immediately. Existing employees and groups are not deleted.",
        "revoke_button": "Revoke token",
        "revoke_title": "Revoke SCIM token",
        "save_connection_button": "Save connection",
        "save_mapping_button": "Save mapping",
        "secret_token_label": "Secret token",
        "show_mapping_details": "Mapping details",
        "success_token_added": "SCIM token added.",
        "success_token_revoked": "SCIM token revoked.",
        "sync_type_employee": "Employee",
        "sync_type_employee_description": "Provision employees and employee groups from this identity provider.",
        "sync_type_label": "Provisioning type",
        "sync_type_user": "Admin user",
        "sync_type_user_description": "Provision admin users who can access the administration dashboard."
      },
      "select_automation": "Select automation",
      "select_group": "Select group",
      "settings_saved": "Settings saved",
      "success": {
        "invitation_resent": "Email confirmation has been resent",
        "report_added": "Report added successfully",
        "report_edited": "Report saved",
        "user_added": "User added"
      },
      "timezone": {
        "label": "Timezone",
        "placeholder": "Select timezone"
      },
      "tokens": {
        "add_title": "Create token",
        "are_you_sure_you_want_to_delete": "Are you sure you want to delete this token? This action cannot be undone.",
        "close": "Close",
        "create_token_button": "Create token",
        "documentation": "Documentation",
        "name_help": "Give your token a descriptive name to help you identify it later.",
        "name_label": "Name",
        "name_placeholder": "Name of token",
        "note_cannot_view": "This token will only be displayed once. Save it somewhere secure.",
        "success_token_added": "Token added.",
        "success_token_deleted": "Token deleted.",
        "token_created": "Token created"
      },
      "training_restrictions": {
        "enabled": {
          "subtitle": "Limit how much unassigned training employees can complete.",
          "title": "Training restrictions",
          "tooltip": "Enable the default restrictions for optional training in the hub."
        },
        "unassigned_quiz_limit": {
          "help": "Maximum number of unassigned quizzes an employee can complete.",
          "label": "Quiz limit"
        },
        "unassigned_video_limit": {
          "help": "Maximum number of unassigned videos an employee can complete.",
          "label": "Video limit"
        }
      },
      "training_type": {
        "course": "Course",
        "video": "Video"
      },
      "users": {
        "add_employee": "Add user"
      }
    },
    "imports": {
      "back": "Back",
      "button": "{click} or drag and drop",
      "click_to_upload": "Click to upload",
      "completed": "Completed",
      "done": "Done",
      "failed": "Failed",
      "file_requirements": "The file must contain the following columns: <b>first_name</b>, <b>last_name</b>, <b>email</b>, and <b>locale</b> (e.g., da_DK, en_US, de_DE).<br/>Optionally the file can contain <b>timezone</b> (e.g. Europe/Copenhagen), <b>phone_number</b>, and <b>phone_country_code</b>.<br/><b>CSV files must use commas as separators.</b><br/>Accepted formats: .csv or .txt (The file should be saved in UTF-8 format to ensure correct character encoding)",
      "formats": "CSV or TXT up to 10MB",
      "import_type": {
        "employees": "{count} employee | {count} employees",
        "groups": "{count} group | {count} groups"
      },
      "pending": "Syncing",
      "upload_another": "Upload another file"
    },
    "integrations": {
      "account": {
        "subtitle": "Synchronize user accounts with Moxso.",
        "title": "Users and communication"
      },
      "add_our_domains_and_setup_guides": "Add our domains and follow Gmail/Outlook guides.",
      "addin_setup_guide": "Setup guide",
      "coming_soon": "Coming soon",
      "compliance": {
        "subtitle": "Synchronize with compliance tools.",
        "title": "Compliance tools"
      },
      "connected": {
        "subtitle": "Currently connected integrations.",
        "title": "Active integrations"
      },
      "delete": {
        "button": "Delete integration",
        "confirmation": "Are you sure you want to delete this integration? This action cannot be undone.",
        "description": "Deleting this integration stops future synchronization. This action cannot be undone.",
        "subtitle": "Remove this integration from your workspace.",
        "success": "Integration deleted",
        "title": "Delete integration"
      },
      "edit": {
        "auth_settings": {
          "subtitle": "Update authentication settings",
          "title": "Authentication settings"
        },
        "filtering": {
          "text": "Email filtering automatically removes shared email addresses from your integration. These could be email accounts like admin{'@'}domain.com, contact{'@'}domain.com, etc.",
          "title": "Generic and role-based email filtering"
        },
        "groups": {
          "text": "Select whether to sync groups every time your integration is updated.",
          "title": "Groups"
        },
        "managers": {
          "text": "Select whether to sync managers every time your integration is updated.",
          "title": "Managers"
        },
        "offboarding": {
          "text": "Select whether to automatically disable employees that are removed from your integration.",
          "title": "Offboarding"
        },
        "settings": {
          "enable_notifications": {
            "title": "Enable training notifications"
          },
          "enable_sync": "Enable synchronization",
          "select_sync_frequency": "Choose how often you want your integration to be synchronized.",
          "subtitle": "Update integration configuration",
          "sync_frequency": "Synchronization frequency",
          "title": "Edit integration"
        },
        "sync_phone_numbers": {
          "text": "Select whether phone numbers should be imported when syncing with this integration.",
          "title": "Import phone numbers"
        },
        "title": "Latest syncs"
      },
      "enabled": "Enabled",
      "first_sync": "First sync",
      "form": {
        "access_token": {
          "help": "The API key is used to authenticate the integration.",
          "label": "API key"
        },
        "api_route": {
          "label": "API route",
          "placeholder": "Enter API route"
        },
        "password": {
          "help": "The password is used to authenticate the integration.",
          "label": "Password",
          "placeholder": "Enter password"
        },
        "region": {
          "help": "Select which data region you are using for this provider.",
          "label": "Data region",
          "options": {
            "eu": "EU",
            "global": "Global"
          }
        },
        "username": {
          "help": "The username is used to authenticate the integration.",
          "label": "Username",
          "placeholder": "Enter username"
        }
      },
      "frequency": {
        "daily": {
          "description": "Your data will be synced every day.",
          "title": "Daily"
        },
        "monthly": {
          "description": "Your data will be synced every month on the first day.",
          "title": "Monthly"
        },
        "realtime": {
          "description": "Your data will be synced every minute.",
          "title": "Real-time"
        },
        "weekly": {
          "description": "Your data will be synced every week on Monday.",
          "title": "Weekly"
        }
      },
      "gmail_addin": {
        "apps_marketplace_apps": "Apps → Google Workspace Marketplace apps",
        "click_install_review_deploy": "Click {install}, review the requested permissions, and choose {deploy_to_organisation} (or a test group) to make the add-in available to users.",
        "deploy_to_organisation": "Deploy to your organisation",
        "find_moxso_add_in": "Find the “Moxso Report” add-in",
        "in_admin_console_navigate_to": "In the Google Workspace Admin console, navigate to {marketplace_apps}.",
        "install": "Install",
        "install_and_deploy": "Install and deploy the add-in",
        "moxso_report": "Moxso Report",
        "open_workspace_marketplace": "Open Google Workspace Marketplace",
        "report_threats_directly_from_gmail": "Report threats to Moxso directly from Gmail.",
        "search_to_locate": "Use the search bar to locate {moxso_report} and open its details page.",
        "title": "Setup Gmail Add-in"
      },
      "gmail_whitelisting_guide": "Gmail allowlisting guide",
      "hri": {
        "connected": "Connected",
        "directory_description": "Connect Microsoft Entra or Google Workspace to match employee IDs and unlock other HRI integrations. This HRI connection is separate from your regular integration.",
        "directory_title": "Connect your employee directory first",
        "enable": "Enable",
        "explore_description": "You can explore the integrations below. Setup requires an active Microsoft Entra or Google Workspace HRI connection.",
        "explore_title": "Explore integrations",
        "recommended": "Recommended",
        "recommended_tooltip": "You already use this directory",
        "setup_locked": "Setup locked",
        "setup_prerequisite": "Set up Microsoft Entra or Google Workspace HRI first."
      },
      "integration_stored": "Integration saved",
      "last_sync": "Last sync",
      "last_update": "Last update: {time}",
      "lms": {
        "subtitle": "Synchronize with learning management systems.",
        "title": "Learning management systems"
      },
      "never": "Never",
      "not_connected": "Not connected",
      "notifications": {
        "subtitle": "Send notifications through collaboration tools.",
        "title": "Notifications"
      },
      "open_guide": "Open guide",
      "outlook_addin": {
        "accept_permissions": "Accept permissions",
        "add_ins": "Add-ins",
        "app_type": "App type",
        "assign_access": "Assign Access",
        "assign_users": "Assign users",
        "choose_who_get_add_in": "Under {assign_users}, choose who should receive the add-in. We recommend selecting {specific_users} and picking the relevant groups.",
        "chose_manifest_url": "Choose {provide_link} and paste the manifest URL:",
        "click": "Click {next}.",
        "click_next_then_finish": "Click {next}, then {finish}.",
        "click_you_should_see_message": "Click {validate}. You should see the message \"{file_validated}\".",
        "complete": "Complete",
        "confirm_slot_is_selected": "In the {app_type} list, confirm that {add_in} is selected.",
        "done": "Done",
        "examine_permissions": "Examine the requested permissions. If everything looks correct, choose {accept_permissions} and confirm the prompts.",
        "finalize_deployment": "Finalize Deployment",
        "finish_deployment": "Finish deployment",
        "integrated_apps": "Integrated Apps",
        "manifest_file_validated": "Manifest file validated",
        "navigate_to_admin_center": "Navigate to Microsoft 365 admin center > Settings > {link}",
        "next": "Next",
        "office_add-in": "Office Add-in",
        "open_integrated_apps": "Open Integrated Apps",
        "proceed_to_assignment": "Proceed to Assignment",
        "process_indicator_then_complete": "You’ll see a progress indicator; this step rarely exceeds one minute. Afterward, press {done} to complete the setup.",
        "provide_link_to_manifest_file": "Provide link to manifest file",
        "provide_manifest": "Provide the Manifest",
        "report_threats_directly_from_outlook": "Report threats to Moxso directly from Outlook.",
        "restart_outlook": "Restart Outlook to ensure the add-in initializes, then submit a test email report. Note that the add-in may take up to 24 hours to appear after deployment.",
        "review_permissions": "Review Permissions",
        "select_upload_custom_apps": "Select {bold}.",
        "specific_users_groups": "Specific users/groups",
        "specify_app_type": "Specify the App Type",
        "start_the_upload": "Start the Upload Process",
        "title": "Setup Outlook Add-in",
        "upload_custom_apps": "Upload custom apps",
        "use_powershell": "Use powershell",
        "validate": "Validate",
        "validate_manifest": "Validate the Manifest",
        "verify_add_in": "Verify the Add-in in Outlook"
      },
      "outlook_whitelisting_guide": "Outlook allowlisting guide",
      "overview": {
        "active": "Active",
        "active_subtitle": "Currently connected integrations.",
        "active_title": "Active integrations",
        "all": "All",
        "all_subtitle": "Connect services to bring employee security activity into Human Risk Intelligence.",
        "all_title": "All integrations",
        "attention": "Needs attention",
        "attention_subtitle": "Integrations that need attention before they can sync.",
        "attention_title": "Needs attention",
        "empty": "No integrations found.",
        "hri": "Human risk intelligence",
        "search": "Search integrations...",
        "sections": {
          "compliance": "Compliance",
          "lms": "LMS",
          "notifications": "Notifications",
          "signals": "Signals",
          "user_sync": "User sync"
        }
      },
      "refresh": "Refresh data",
      "refresh_data": "Refresh data",
      "report_threats_directly_from_inbox": "Report threats directly from the inbox.",
      "settings_saved": "Settings saved",
      "setup": "Connect",
      "setup_integration": "Setup integration",
      "setup_text": "We use single sign-on (SSO) to securely connect with {provider}. You will be redirected to your provider's login page for authentication. Please note that an admin account is required to configure the integration.",
      "simulation_deliverability": "Simulation deliverability",
      "single": {
        "provider_title": "Edit {provider}",
        "subtitle": "Update integration configuration",
        "title": "Edit integration"
      },
      "status": "Integration status",
      "step_by_step": "Step-by-step guide to let emails through.",
      "sync_already_enabled_tooltip": "Employee synchronization is already enabled on another integration. Please disable it to use this option.",
      "sync_started": "Sync added to queue",
      "tags": {
        "all": "All tags",
        "compliance": {
          "description": "Share security awareness data with your compliance platform.",
          "headline": "Compliance"
        },
        "filter": "Filter by tag",
        "learning_management": {
          "description": "Connect security awareness training with your learning management system.",
          "headline": "Learning Management"
        },
        "notifications": {
          "description": "Send Moxso notifications through your communication platform.",
          "headline": "Notifications"
        },
        "user_sync": {
          "description": "Synchronize users from your directory or workspace into Moxso.",
          "headline": "User Sync"
        }
      },
      "teams_guide": {
        "description": "Follow the setup guide in our {help_center} for instructions on adding Moxso to Microsoft Teams.",
        "download_zip": "Download ZIP file",
        "help_center": "help center"
      },
      "title": "Integrations",
      "token_error": "We couldn't establish a connection with {provider} for you. Our most recent attempt was on: {date}. Please reconfirm your account credentials.",
      "whitelisting_guide": "Allowlisting guide"
    },
    "magic_links": {
      "description": "Allow employees to sign in automatically through Hub links in notifications. When disabled, links open the Hub login page and keep the original destination.",
      "label": "Enable magic links",
      "title": "Hub magic links"
    },
    "risk": {
      "organisation_risk_subtitle": "Overall risk level for {organisation}",
      "organisation_risk_text": "The higher the risk level, the more training employees will receive. Consider balancing training needs with employee workload.",
      "organisation_risk_title": "Organisation risk",
      "subtitle": "Adjust training level for each category.",
      "title": "Training levels"
    },
    "saml": {
      "acs_url": "ACS URL",
      "add_provider": "Add provider",
      "attribute_mapping": {
        "description": "Map SAML assertion attributes to the admin user profile fields Moxso expects.",
        "title": "Assertion attribute mapping"
      },
      "cancel_edit": "Cancel edit",
      "create": {
        "manual": {
          "description": "Configure the provider manually",
          "title": "Create manually"
        },
        "metadata": {
          "description": "Import IdP settings from provider",
          "fetch": "Fetch metadata",
          "setup_description": "Paste the metadata URL from your identity provider. Moxso will use it to import the IdP entity ID, login URL, and certificate.",
          "setup_manually": "Setup manually",
          "title": "Create from metadata URL"
        }
      },
      "delete": {
        "cancel": "Cancel",
        "confirm": "Delete connection",
        "description": "Users will no longer be able to sign in through this identity provider. Existing linked SAML identities for this provider will also be removed.",
        "title": "Delete SAML connection"
      },
      "deleted": "SAML connection deleted",
      "disabled": "Disabled",
      "edit_provider": "Edit provider",
      "empty": {
        "description": "Add a SAML provider to let invited admin users start SSO from the login page.",
        "title": "No SAML providers"
      },
      "enabled": "Enabled",
      "entity_id": "Entity ID",
      "entity_id_instruction": "Use the entityID value from the metadata URL.",
      "existing_users_only": "SAML sign-in only works for existing invited admin users in this workspace.",
      "form": {
        "app_federation_metadata_url": "App federation metadata URL",
        "app_federation_metadata_url_placeholder": "https://example.com/federationmetadata.xml",
        "email_attribute": "Email attribute",
        "email_attribute_placeholder": "email",
        "enabled": "Enable provider",
        "enabled_help": "Enabled providers can be used from the login page.",
        "first_name_attribute": "First name attribute",
        "first_name_attribute_placeholder": "firstName",
        "idp_entity_id": "IdP entity ID",
        "idp_entity_id_placeholder": "https://idp.example.com/entity",
        "idp_login_url": "IdP login URL",
        "idp_logout_url": "IdP logout URL",
        "idp_x509_certificate": "IdP X.509 certificate",
        "idp_x509_certificate_help": "The current certificate cannot be viewed again. Leave this field empty to keep it, or paste a new certificate to update it.",
        "idp_x509_certificate_placeholder": "Paste the certificate from your identity provider",
        "idp_x509_certificate_update": "Update certificate",
        "last_name_attribute": "Last name attribute",
        "last_name_attribute_placeholder": "lastName",
        "login_type": "Require SAML for",
        "login_type_employee": "Hub users",
        "login_type_employee_description": "Use SAML for employee sign-in to the learning hub.",
        "login_type_user": "Admin users",
        "login_type_user_description": "Use SAML for admin sign-in to the admin area.",
        "name": "Name",
        "name_id_format": "Name ID format",
        "name_placeholder": "Microsoft Entra ID",
        "provider": "Provider",
        "url_placeholder": "https://idp.example.com/sso"
      },
      "idp_entity_id": "IdP entity ID",
      "login_url": "Login URL",
      "metadata_url": "Metadata URL",
      "providers": {
        "microsoft_scim": "Microsoft Entra ID",
        "okta_scim": "Okta"
      },
      "read": {
        "description": "Copy these values into the your identity provider setup.",
        "title": "SAML configuration"
      },
      "save_provider": "Save provider",
      "saved": "SAML provider saved",
      "subtitle": "Configure identity providers for SSO.",
      "table": {
        "delete": "Delete",
        "edit": "Edit",
        "name": "Name",
        "provider": "Provider",
        "provider_id": "Provider ID",
        "status": "Status"
      },
      "title": "SAML single sign-on"
    },
    "simulation": {
      "ceo_fraud": {
        "ceo": {
          "text": "Enter the contact details of your CEO (or equivalent)",
          "title": "Chief executive officer (CEO)"
        },
        "cfo": {
          "text": "Enter the contact details of your CFO (or equivalent)",
          "title": "Chief financial officer (CFO)"
        },
        "cto": {
          "text": "Enter the contact details of your CTO (or equivalent)",
          "title": "Chief technology officer (CTO)"
        },
        "info": "We use the information below to customize our CEO fraud simulations for your organization. If you don't have the information available, we will use default values.",
        "subtitle": "Settings for CEO fraud in simulations.",
        "title": "CEO fraud"
      },
      "dmi": {
        "google": {
          "alert_text": "Make sure to configure DMI in Google Workspace before enabling it here.",
          "subtitle": "Set up DMI in Google Workspace to inject simulation emails directly to Gmail inboxes.",
          "title": "DMI for Google Workspace",
          "toggle": {
            "help": "Configure DMI in Google Workspace, then enable it here once setup is complete.",
            "label": "Activate DMI"
          }
        }
      },
      "search": {
        "placeholder": "Search for services",
        "results": "Search results for: {query}"
      },
      "services": {
        "credential_harvest": "Credential page",
        "selector": {
          "dialog_title": "Edit services",
          "edit_button": "Edit available services",
          "title": "No services activated | One service activated | {count} services activated",
          "update_services": "Update services"
        },
        "subtitle": "Settings for targeting based on software.",
        "title": "Software targeting"
      },
      "training": {
        "download": {
          "subtitle": "Download domains used in our phishing simulations.",
          "title": "Download simulation domains"
        },
        "local_ratio": {
          "help": "At 70%, a German-speaking employee gets 70% German templates and 30% English.",
          "subtitle": "Control how templates are split between each employee’s language and English. When off, there’s no set ratio.",
          "title": "Templates in employees' languages"
        },
        "subtitle": "Tweak sensibility and tracking settings for your simulations.",
        "title": "General",
        "toggle": {
          "subtitle": "Send remedial training once an employee is found to be vulnerable.",
          "title": "Training"
        }
      }
    },
    "simulations": {
      "ceo_fraud": {
        "ceo_email": {
          "label": "Email"
        },
        "ceo_name": {
          "label": "Name"
        },
        "cfo_email": {
          "label": "Email"
        },
        "cfo_name": {
          "label": "Name"
        },
        "cto_email": {
          "label": "Email"
        },
        "cto_name": {
          "label": "Name"
        }
      },
      "enable_ceo_fraud": "Enable CEO fraud",
      "enable_module_help": "Enable this module for the workspace.",
      "enable_software_targeting": "Enable Software targeting"
    },
    "tables": {
      "reports": {
        "frequency": "Frequency",
        "period": "Period",
        "recipient": "Recipient",
        "status": "Status",
        "type": "Type"
      },
      "scim": {
        "actions": "Actions",
        "created": "Created",
        "default_mapping": "Default mapping",
        "effective_mapping": "Effective mapping",
        "last_used": "Last used",
        "name": "Name",
        "provider": "Provider",
        "status": "Status",
        "sync_type": "Type"
      },
      "tokens": {
        "created": "Created",
        "last_used": "Last used",
        "name": "Name"
      },
      "users": {
        "created": "Created",
        "role": "Role",
        "status": "Status",
        "two_factor": "2FA",
        "user": "User"
      }
    },
    "threats": {
      "advanced_settings": {
        "hide": "Hide advanced settings",
        "show": "Show advanced settings"
      },
      "alias_email": {
        "help": "We suggest to create a more user-friendly alias version of the inbound email address. For example security{'@'}example.com",
        "label": "Alias email",
        "placeholder": "security{'@'}example.com"
      },
      "clustering": {
        "title": "Threat clustering"
      },
      "enable_defender_integration": {
        "help": "Forward reported phishing emails to Microsoft Defender.",
        "label": "Enable Microsoft Defender integration",
        "title": "Microsoft Defender"
      },
      "enable_forwarding": {
        "help": "Enable threat forwarding to a specific email address.",
        "title": "Enable threat forwarding"
      },
      "enable_grouped_threat_status_transitions": {
        "help": "When enabled, newly created threats will be set to the same status as their related threat",
        "title": "Enable automatic transition of clustered threats"
      },
      "enable_notifications": {
        "help": "Receive a notification each time a potential threat is reported",
        "title": "Enable notifications"
      },
      "enable_third_party_submission": {
        "help": "Enable third party submission of phishing attacks to Microsoft and Google.",
        "title": "Enable third party submission"
      },
      "enable_threat_management": {
        "help": "Enable threat management for this workspace.",
        "title": "Enable threat management"
      },
      "forward_reported_emails_to": {
        "label": "Forward reported emails to:",
        "placeholder": "reported{'@'}company.com"
      },
      "forward_to": {
        "label": "Forward to:",
        "placeholder": "phishing{'@'}company.com"
      },
      "forwarding": {
        "defender": {
          "description": "Forward reported phishing emails to Microsoft Defender.",
          "title": "Forward to Defender"
        },
        "disabled": {
          "description": "Do not forward reported threats.",
          "title": "Disable forwarding"
        },
        "email": {
          "description": "Send reported threats to a specific email address.",
          "title": "Forward to email"
        },
        "title": "Threat forwarding"
      },
      "forwarding_warning": "When threat forwarding is enabled, reported threats will be read-only in the admin panel. No analysis will be conducted by Moxso.",
      "inbound_email": {
        "help": "This email address is your personal reporting email. Any emails sent to this address will be analyzed by Moxso.",
        "label": "Inbound email"
      },
      "save_forwarded_emails": {
        "help": "When enabled forwarded emails will be stored.",
        "label": "Save forwarded threats"
      },
      "subtitle": "Configure your threat management settings.",
      "threat_grouping_confidence": {
        "help": "Controls how closely threats must match before they are clustered together.",
        "label": "Threat clustering confidence",
        "options": {
          "high": "High",
          "low": "Low",
          "medium": "Medium"
        }
      },
      "title": "Threat management"
    },
    "two_factor": {
      "actions": {
        "disable": "Disable two-factor authentication",
        "enable": "Enable two-factor authentication",
        "regenerate_recovery_codes": "Regenerate recovery codes",
        "view_recovery_codes": "View recovery codes"
      },
      "disabled": {
        "badge": "Off",
        "text": "Protect this admin account with a code from an authenticator app or password manager.",
        "title": "Two-factor authentication is off"
      },
      "enabled": {
        "badge": "On",
        "text": "This admin account requires a second factor when signing in.",
        "title": "Two-factor authentication is enabled"
      },
      "password_dialog": {
        "cancel": "Cancel",
        "cancel-setup": {
          "button": "Cancel setup",
          "description": "Confirm your current password to cancel the pending two-factor setup.",
          "title": "Cancel two-factor setup"
        },
        "current_password": "Current password",
        "disable": {
          "button": "Disable",
          "description": "Confirm your current password to disable two-factor authentication for this account.",
          "title": "Disable two-factor authentication"
        },
        "enable": {
          "button": "Continue",
          "description": "Confirm your current password before setting up two-factor authentication.",
          "title": "Enable two-factor authentication"
        },
        "regenerate-recovery-codes": {
          "button": "Regenerate codes",
          "description": "Confirm your current password to replace your existing recovery codes.",
          "title": "Regenerate recovery codes"
        },
        "show-recovery-codes": {
          "button": "View codes",
          "description": "Confirm your current password to view your recovery codes.",
          "title": "View recovery codes"
        }
      },
      "recovery_codes": {
        "copied": "Copied",
        "copy": "Copy codes",
        "text": "Save these one-time codes in your password manager. They will not be shown here after you close them.",
        "title": "Recovery codes"
      },
      "setup": {
        "cancel": "Cancel setup",
        "code_label": "Authentication code",
        "code_placeholder": "123456",
        "confirm": "Confirm",
        "manual_key": "Manual setup key",
        "qr_alt": "Two-factor setup QR code",
        "text": "Scan the QR code with your authenticator app or password manager, then enter the 6-digit code it generates.",
        "title": "Set up your authenticator"
      },
      "subtitle": "Require a second factor when signing in to your admin account.",
      "title": "Two-factor authentication"
    },
    "workspace": {
      "lms": {
        "subtitle": "Configure a custom content URL to redirect users to an external learning platform.",
        "title": "External LMS"
      },
      "logging": {
        "activity": "Activity",
        "columns": {
          "action_time": "Action Time",
          "action_type": "Action Type",
          "actor": "Actor",
          "zone": "Zone"
        },
        "moxso_support": "Moxso support",
        "partner": "Partner",
        "slideover": {
          "actor": "Actor",
          "app": "App",
          "audit_log": "Audit log",
          "created": "Created",
          "email": "Email",
          "event": "Event",
          "impersonated_by_support": "Impersonated by support",
          "ip_address": "IP address",
          "name": "Name",
          "no": "No",
          "path": "Path",
          "request": "Request",
          "summary": "Summary",
          "tabs": {
            "request": "Request",
            "summary": "Summary & Actor"
          },
          "title": "Event",
          "type": "Type",
          "user_agent": "User agent",
          "yes": "Yes"
        },
        "subtitle": "See the history of changes made within this account.",
        "title": "Audit logs"
      },
      "scim": {
        "attribute_mapping": {
          "subtitle": "Override supported SCIM attribute targets for this connection. Empty rows use the backend default mapping.",
          "title": "Attribute mapping"
        },
        "connection_settings": {
          "subtitle": "Manage the provider, name, and enabled state for the selected SCIM connection.",
          "title": "Connection settings"
        },
        "connections": {
          "disabled": "Disabled",
          "enabled": "Enabled",
          "subtitle": "Configure identity provider connections for automated SCIM user and group provisioning.",
          "title": "SCIM connections"
        },
        "endpoint": {
          "label": "Tenant URL",
          "subtitle": "Use this base URL in your identity provider. Do not add Users, Groups, or ServiceProviderConfig to the URL.",
          "title": "Provisioning endpoint"
        },
        "tokens": {
          "subtitle": "Create bearer tokens for Microsoft Entra ID, Okta, or another SCIM v2 identity provider.",
          "title": "SCIM provisioning tokens"
        }
      },
      "subtitle": "Configure your workspace settings.",
      "title": "Workspace settings",
      "tokens": {
        "subtitle": "Securely access the Moxso data warehouse from your apps and services.",
        "title": "Data warehouse"
      },
      "user": {
        "two_factor_disabled": "Disabled",
        "two_factor_enabled": "Enabled",
        "verification_required": "Verification pending",
        "verified": "Verified"
      },
      "users": {
        "subtitle": "Manage users in your workspace",
        "title": "Users"
      }
    }
  },
  "simulations": {
    "audience_missing_phone_numbers_all": "None of the employees in the selected audience have phone numbers. Please change the audience or add phone numbers, then try again.",
    "audience_missing_phone_numbers_some": "One employee out of {total} in the selected audience is missing a phone number. | {count} employees out of {total} in the selected audience are missing phone numbers.",
    "click_rate": {
      "title": "Click rate"
    },
    "clicked": "Clicked",
    "count": {
      "title": "Simulations processed",
      "unit": "Simulations"
    },
    "create": {
      "button": "Create simulation",
      "configuration": {
        "choose_type": "Back",
        "text": "Define the audience and settings for this simulation.",
        "title": "Configure your simulation",
        "token": "Set a custom email header for allowlisting purposes. Your token will be passed as an {token} header on every email sent from this simulation."
      },
      "credential_harvest": {
        "description": "When enabled, employees will exclusively receive simulations that include login pages. Moxso monitors form submissions but never stores any entered credentials.",
        "enable_label": "Enable credential harvest",
        "title": "Credential harvest"
      },
      "delivery_rate": {
        "high": {
          "email_description": "1-2 weeks between emails",
          "sms_description": "1-2 weeks between text messages",
          "title": "High"
        },
        "low": {
          "email_description": "1-6 weeks between emails",
          "sms_description": "1-6 weeks between text messages",
          "title": "Low"
        },
        "medium": {
          "email_description": "1-4 weeks between emails",
          "sms_description": "1-4 weeks between text messages",
          "title": "Medium"
        }
      },
      "help": {
        "audience": "Decide which audience is to receive this simulation.",
        "email_delivery_rate": "Defines the time between simulation emails. Frequency adapts within the delivery rate range based on employee performance.",
        "sms_delivery_rate": "Defines the time between simulation text messages. Frequency adapts within the delivery rate range based on employee performance.",
        "staggered_delivery": "Simulations are delivered at random across weekdays within the selected number of days.",
        "test": "Test simulations don't affect user training records or reporting metrics."
      },
      "labels": {
        "audience": "Audience",
        "delivery_rate": "Delivery rate",
        "name": "Name",
        "preview": "Preview",
        "schedule_type": "Schedule type",
        "staggered_delivery": "Staggered delivery",
        "template": "Template",
        "test": "Mark as test simulation",
        "token": "Token",
        "token_header": "Set a custom simulation token header",
        "use_template": "Use custom template"
      },
      "placeholders": {
        "audience": "Please select audience",
        "name": "Simulation name",
        "token": "ABC-123"
      },
      "random_template": "Random template",
      "remove_template": "Remove template",
      "step_current_of_last": "Step {current_step} of {last_step}",
      "type": {
        "button": "Next",
        "email": {
          "text_plural": "Send simulations as email",
          "text_singular": "Send simulation as email",
          "title": "Email"
        },
        "help": {
          "delivery_method": "Choose how the simulation will be delivered",
          "schedule_type": "Select how often this simulation should run"
        },
        "labels": {
          "delivery_method": "Delivery method",
          "schedule_type": "Schedule type"
        },
        "one_off": {
          "text": "All the attacks will be sent when the simulation is launched",
          "title": "One-off simulation"
        },
        "recurring": {
          "text": "Attacks will be sent every month until the simulation is deactivated",
          "title": "Automated simulation"
        },
        "sms": {
          "text_plural": "Send simulations as text messages",
          "text_singular": "Send simulation as a text message",
          "title": "Text message"
        },
        "text": "Select the schedule and delivery method for this simulation.",
        "title": "Set up simulation delivery"
      }
    },
    "delete": {
      "are_you_sure": "Are you sure you want to delete this simulation? This action cannot be undone.",
      "button": "Delete simulation",
      "simulation_deleted": "Simulation deleted"
    },
    "details": {
      "heading": "Summary",
      "text": "Simulation summary"
    },
    "edit": {
      "button": "Edit settings",
      "button_save": "Save settings",
      "campaign_updated": "Simulation updated",
      "title": "Edit simulation"
    },
    "filter": {
      "status": {
        "all": "Status: All",
        "click": "Status: Clicked",
        "report": "Status: Reported",
        "submission": "Status: Login"
      }
    },
    "launch": {
      "button": "Launch simulation",
      "input_label": "Type the total number of recipients",
      "launched": "Simulation launched",
      "no_recipients": "The selected audience has no members. Please adjust the audience and try again.",
      "no_recipients_title": "No members",
      "title": "Launch simulation",
      "warning": "You are about to launch a simulation that will be sent to {count} recipients. Are you sure you want to continue?"
    },
    "opened": "Open",
    "pause": "Pause simulation",
    "pause_confirmation": {
      "results": "Results from simulations already sent are kept.",
      "title": "Pause simulation?",
      "warning": "Pausing cancels {count} scheduled send. When you resume, a new schedule replaces the original send dates. Employees may wait longer for their next simulation. | Pausing cancels {count} scheduled sends. When you resume, a new schedule replaces the original send dates. Employees may wait longer for their next simulation."
    },
    "play": "Resume simulation",
    "received": "Received",
    "report_rate": {
      "title": "Report rate"
    },
    "reported": "Reported",
    "scheduled": "Scheduled",
    "send_test": "Send test",
    "send_test_tooltip": "This will send a test email to {userEmail}",
    "staggered_delivery": {
      "days": "{count} day | {count} days",
      "off": "Off"
    },
    "stop": {
      "button": "Stop simulation",
      "simulation_stopped": "Simulation stopped",
      "title": "Stop simulation?",
      "warning": "Stopping the simulation cancels all remaining scheduled deliveries. Results from simulations already sent will be kept. Are you sure you want to continue?"
    },
    "submission_disabled": "Disabled",
    "submission_enabled": "Enabled",
    "submission_rate": {
      "title": "Login rate"
    },
    "submitted": "Login",
    "summary": {
      "credential_harvest": "Credential harvest",
      "delivery_method": "Delivery method",
      "delivery_rate": "Delivery rate",
      "group": "Audience",
      "schedule_type": "Schedule type",
      "staggered_delivery": "Staggered delivery",
      "test": "Test simulation",
      "type": "Type"
    },
    "templates": {
      "create": {
        "button": "Create template",
        "success_text": "Template created",
        "title": "Create simulation template"
      },
      "duplicate": {
        "button": "Duplicate",
        "subject": "Copy",
        "success_text": "Template duplicated",
        "title": "Duplicate simulation template"
      },
      "edit": {
        "button": "Save template",
        "success_text": "Template saved",
        "title": "Edit simulation template"
      },
      "editor": {
        "ai_modal": {
          "button": "Generate",
          "placeholder": "Describe the simulation template you want to build...",
          "title": "Generate template using AI"
        },
        "attack_link": "Attack link",
        "attack_link_already_applied": "Attack links are applied automatically to buttons.",
        "buttons": {
          "generate": "Generate",
          "send_preview": "Send me a preview"
        },
        "change_image": "Change image",
        "default_block_content": {
          "button": "Review now",
          "container_text": "Insert content here",
          "footer_text": "You are receiving this email because you are an employee of ::workspace.name::.",
          "heading_1": "Heading 1",
          "heading_2": "Heading 2",
          "heading_3": "Heading 3",
          "image_alt": "Image",
          "text": "Write your message here.",
          "unsubscribe": "Unsubscribe"
        },
        "generating_template": "Generating template",
        "google_dmi_enabled": "Direct message injection enabled",
        "insert_image": "Insert image",
        "labels": {
          "custom_domain": "Custom domain",
          "email": "Email",
          "select_domain": "Select a domain",
          "sender": "Sender",
          "string_templates": {
            "date_last_month": "Same day last month",
            "date_last_week": "Same day last week",
            "date_last_year": "Same day last year",
            "date_next_month": "Same day next month",
            "date_next_week": "Same day next week",
            "date_next_year": "Same day next year",
            "date_today": "Today",
            "date_tomorrow": "Tomorrow",
            "date_yesterday": "Yesterday",
            "department": "Department",
            "email": "Email",
            "first_name": "First name",
            "last_name": "Last name",
            "manager_email": "Manager email",
            "manager_first_name": "Manager first name",
            "manager_last_name": "Manager last name",
            "workspace_address": "Company address",
            "workspace_city": "Company city",
            "workspace_name": "Company name",
            "workspace_postal_code": "Company postal code"
          },
          "subject": "Subject"
        },
        "no_image_selected": "No image selected",
        "placeholders": {
          "custom_domain": "example.com",
          "email": "Sender name",
          "sender_name": "Alice Smith",
          "subject": "Enter subject here"
        },
        "preview_sent_success": "Preview email sent successfully.",
        "qr_code": "QR code",
        "sidebar": {
          "blocks": "Blocks",
          "no_tags_found": "No tags found",
          "settings": "Settings",
          "settings_title": "Selected block settings",
          "style": "Design",
          "style_title": "Template design",
          "tags": "Tags",
          "variables_title": "Merge tags"
        },
        "sidebar_field_options": {
          "center": "Center",
          "fixed": "Fixed width",
          "full_width": "Full width",
          "left": "Left",
          "right": "Right"
        },
        "sidebar_fields": {
          "alt_text": "Alt text",
          "auto": "Auto",
          "background_color": "Background color",
          "border_radius": "Corner radius",
          "button_dimensions_hint": "Dimensions are in pixels. Set width or height to 0 to fit the text.",
          "button_min_height": "Minimum height",
          "color": "Color",
          "column_width": "Column {column} width (%)",
          "columns": "Columns",
          "content_alignment": "Alignment",
          "content_width_mode": "Width",
          "font_size": "Font size",
          "gap": "Gap",
          "height": "Height",
          "image_url": "Image",
          "padding": "Padding",
          "text_color": "Text color",
          "thickness": "Thickness",
          "width": "Width"
        },
        "sidebar_placeholders": {
          "alt_text": "Describe the image",
          "button_label": "Review now",
          "legal_copy": "You are receiving this email because you are an employee of ::workspace.name::."
        },
        "tooltip_fill_out_all_fields": "Fill out all fields to send a preview",
        "tooltip_this_will_save_the_template": "This will save the template",
        "unsaved_changes": {
          "confirm_exit": "You have unsaved changes. Are you sure you want to exit?",
          "description": "You have unsaved changes. If you exit without saving, your changes will be lost.",
          "discard": "Discard changes",
          "save_and_exit": "Save and exit",
          "subtile": "Save before exiting?",
          "title": "Unsaved changes"
        },
        "unsaved_changes_badge": "Unsaved changes"
      }
    },
    "test_sent": "Test email sent to {userEmail}",
    "tooltip": {
      "click": "A link was clicked",
      "open": "This simulation was opened",
      "report": "The simulation was reported",
      "submit": "A login attempt was made"
    },
    "updated": "Simulation updated"
  },
  "statistics": {
    "activities_by_type": {
      "completed_courses": "Completed courses",
      "phishing_quiz_correct_answers": "Correct phishing quiz answers",
      "phishing_quiz_incorrect_answers": "Incorrect phishing quiz answers",
      "quiz_answers": "Quiz answers",
      "quiz_correct_answers": "Correct quiz answers",
      "quiz_incorrect_answers": "Incorrect quiz answers",
      "simulations_delivered": "Simulations delivered",
      "simulations_failed": "Failed simulations",
      "simulations_passed": "Passed simulations",
      "simulations_reported": "Simulations reported",
      "text": "How your employees are training",
      "threats_reported": "Threats reported",
      "title": "Completed activities",
      "videos_watched": "Videos watched"
    },
    "benchmarks": {
      "above_benchmark_tooltip": "Value is above the benchmark.",
      "average": "Network average",
      "below_benchmark_tooltip": "Value is below the benchmark.",
      "benchmark_tooltip": "Benchmark",
      "peer_avg": "Peer avg.",
      "score": "Current score",
      "text_higher": "% better than comparable companies",
      "text_lower": "% lower than comparable companies",
      "title": "Benchmarks"
    },
    "breaches": {
      "title": "Breaches"
    },
    "competence": {
      "text": "How well your employees are performing in their training",
      "title": "Competence"
    },
    "culture": {
      "text": "How engaged your employees are in their security training",
      "title": "Culture"
    },
    "employee_activity": {
      "title": "Employee activity"
    },
    "employees": {
      "title": "Active employees"
    },
    "onboarding": {
      "title": "Onboarding"
    },
    "overdue": {
      "change": "{points} pts vs. {date}",
      "security_program_text": "Percentage of employees not following their security program (training, policies)",
      "security_program_title": "Employees falling behind security program",
      "text": "Percentage of active employees with missed training deadlines",
      "title": "Missed deadlines",
      "unit": "Missed deadlines"
    },
    "recent_activity": "Recent activity",
    "resilience_score": {
      "change_last_90_days": "{value}% in the last 90 days",
      "text": "Calculated score based on how all active employees are training and performing in simulations.",
      "title": "Current resilience score"
    },
    "resilience_score_progression": {
      "title": "Resilience score over time"
    },
    "risk_level": {
      "country": "Country",
      "text": "Risk level is determined by country, organization, and a synthesized risk level, providing insight into the current threat landscape.",
      "title": "Risk level",
      "workspace": "Workspace"
    },
    "show_more": "Show more",
    "simulation_coverage": {
      "title": "Simulation coverage"
    },
    "simulations": {
      "campaign_overview": "Campaign overview",
      "click_count": {
        "text": "Number of times a simulation has been clicked.",
        "title": "Total clicks",
        "unit": "Clicks"
      },
      "click_rate": {
        "text": "Calculated score based on the percentage of employees that have clicked on a link in a simulation.",
        "title": "Click rate",
        "unit": "%"
      },
      "count": {
        "text": "Total number of simulations sent.",
        "title": "Simulations sent",
        "unit": "Simulations"
      },
      "performance_metrics": "Performance metrics",
      "reporting_count": {
        "text": "Total number of simulations reported",
        "title": "Total reports",
        "unit": "Reports"
      },
      "reporting_rate": {
        "text": "Calculated score based on the percentage of employees that have reported a simulation.",
        "title": "Reporting rate",
        "unit": "%"
      },
      "submission_count": {
        "text": "Total number of simulations submitted.",
        "title": "Total submissions",
        "unit": "Submissions"
      },
      "submission_rate": {
        "text": "Calculated score based on the percentage of employees that have logged in on a simulation.",
        "title": "Login rate",
        "unit": "%"
      },
      "submission_sent_count": "Total submissions sent"
    },
    "simulations_sent": {
      "title": "Simulations sent"
    },
    "threats": {
      "count": {
        "text": "Number of threats reported by employees.",
        "title": "Threats reported"
      },
      "fraud_count": {
        "text": "Number of fraudulent threats reported by employees.",
        "title": "Fraudulent threats"
      },
      "handle_rate": {
        "text": "Calculated score based on the percentage of threats that have been handled by an admin.",
        "title": "Threat handle rate"
      },
      "reporting_rate": {
        "title": "Threats reported"
      },
      "status_partition": {
        "title": "Threat status"
      },
      "text": "How well your employees are taking action on threats",
      "time_to_handle": {
        "text": "The average time it takes for your employees to handle a threat.",
        "title": "Handling time"
      },
      "title": "Threat detection"
    },
    "timeframe_nienty_days": "In the last 90 days",
    "training": {
      "courses": {
        "title": "Courses",
        "unit": "Courses completed"
      },
      "phishing_quizzes": {
        "title": "Phishing quizzes"
      },
      "quizzes": {
        "title": "Quizzes"
      },
      "video_quizzes": {
        "title": "Video quizzes"
      },
      "videos": {
        "title": "Videos",
        "unit": "Videos completed"
      }
    },
    "training_coverage": {
      "text": "Calculated score based on the percentage of employees that have completed security training.",
      "title": "Training coverage"
    }
  },
  "tables": {
    "anonymized_at": "Anonymized at",
    "audience": "Audience",
    "audit_completed_status": "Acknowledged at",
    "available_at": "Available at",
    "breached_at": "Breached date",
    "completed_at": "Completed at",
    "created": "Created",
    "created_at": "Created at",
    "deadlines": {
      "deadline": "Deadline",
      "employee": "Employee",
      "last_learning_interaction": "Last activity",
      "lesson": "Lesson",
      "reminder_sent": "Latest reminder"
    },
    "delivery_method": "Delivery method",
    "deselect_all": "Deselect all",
    "domain": "Domain",
    "employee": "Employee",
    "employees": "Employees",
    "enrolled_at": "Enrolled at",
    "error_count": "Skipped",
    "filters": {
      "back": "Back",
      "boolean": "{column} is {toggle}",
      "data": "Filter data",
      "false": "False",
      "filter_by": "Filter by",
      "group": "Filter by group",
      "numberRange": "{column} from {minValue} to {maxValue}",
      "search": "Search",
      "select_date": "Select date",
      "status": "Status",
      "training_type": "Type",
      "true": "True"
    },
    "group": "Group",
    "groups": "Groups",
    "invited": "Invited",
    "languages": "Languages",
    "last_sent_at": "Last sent",
    "lesson_status": "Lesson status",
    "locale": "Language",
    "name": "Name",
    "overdue": "Overdue",
    "published_at": "Published at",
    "report_count": "Report count",
    "reports": "Reports",
    "scheduled_at": "Scheduled for",
    "score": "Score",
    "sensitivity": "Sensitivity level",
    "sent_to_count": "Attacks",
    "status": "Status",
    "synced_count": "Synced",
    "title": "Title",
    "translations": "Translations",
    "unique_click_count": "Clicks",
    "unique_submission_count": "Logins",
    "updated_at": "Updated at"
  },
  "threats": {
    "analysis": {
      "attachments": {
        "files": "Files",
        "subtitle": "Email attachments",
        "title": "Attachments"
      },
      "indicators": {
        "common": {
          "heading": "Common threats",
          "help": "The email content mentions company names commonly used in phishing."
        },
        "credentials": {
          "heading": "Credentials",
          "help": "The email content mentions credentials or passwords."
        },
        "detected": "Detected",
        "homoglyphs": {
          "heading": "Homoglyphs",
          "help": "The sender name or email contains homoglyphs."
        },
        "inconsistency": {
          "heading": "Inconsistency",
          "help": "Inconsistencies in links and/or sender information."
        },
        "no_data": "No data",
        "not_detected": "Not detected",
        "subtitle": "Threat indicators",
        "title": "Indicators",
        "urgency": {
          "heading": "Urgency",
          "help": "Urgency is used to pressure the recipient into taking action."
        }
      },
      "links": {
        "button": "Browser isolation",
        "empty": "No links found",
        "showing_links": "Showing {shown} of {total} links",
        "subtitle": "Links found in email",
        "title": "Links"
      },
      "preview": {
        "not_available": {
          "description": "We were unable to generate a preview for this email.",
          "title": "No image preview available"
        },
        "subtitle": "Email preview",
        "title": "Preview"
      },
      "sender": {
        "domain": "Domain",
        "email": "Email",
        "empty": "No sender analysis found",
        "ip": "IP-address",
        "mx": "DNS MX-records",
        "subtitle": "Sender analysis",
        "title": "Sender",
        "type": "Type",
        "type_text": {
          "free": "Free service",
          "paid": "Paid service"
        }
      }
    },
    "anonymized": {
      "title": "Anonymized threat"
    },
    "browser_isolation": {
      "button": "Open link in browser isolation",
      "copied": "Copied to clipboard",
      "heading": "Browser isolation",
      "host": "Host",
      "notice": "BrowserLing is a third-party service that provides a secure environment for opening links. By clicking the button below, you will be redirected to the BrowserLing website. Moxso is not affiliated with BrowserLing and cannot be held responsible for any content or activity that occurs on the BrowserLing website.",
      "path": "Path",
      "scheme": "Scheme",
      "secured_by": "Secured by BrowserLing"
    },
    "buttons": {
      "delete": "Delete threat",
      "download_html": "Download HTML",
      "fraudulent": "Fraudulent",
      "legitimate": "Legitimate",
      "mark_as_fraudulent": "Mark as fraudulent",
      "mark_as_legitimate": "Mark as legitimate",
      "mark_as_spam": "Mark as spam",
      "notify_reporters": "Notify reporters",
      "notify_reporters_description": "Notify reporters about the status change of their reports.",
      "show_headers": "Show email headers",
      "show_less": "Show less",
      "show_more": "Show more",
      "spam": "Spam"
    },
    "comment_added": "Comment added",
    "created_at": "Created at",
    "current": "Current",
    "disabled": {
      "button": "Go to settings",
      "heading": "Threat management is disabled",
      "text": "Provide your employees with a secure means to notify you and take action against potential threats lurking in their email inboxes, thereby safeguarding the integrity of your organization on a daily basis. Stay one step ahead of any potential harm."
    },
    "export_csv": {
      "description": "Download only includes threats with the selected status in the CSV export.",
      "subtitle": "Select threat status",
      "title": "Download CSV"
    },
    "filter": {
      "status": {
        "all": "Status: All",
        "forwarded": "Status: Forwarded",
        "fraudulent": "Status: Fraudulent",
        "legitimate": "Status: Legitimate",
        "spam": "Status: Spam",
        "unhandled": "Status: Unhandled"
      }
    },
    "forwarding_enabled": "Forwarding enabled",
    "forwarding_warning": "Reported threats are read-only and must be handled in an external system.",
    "from": "From",
    "headers": "Headers",
    "mark_as": "Mark as:",
    "no_more_unhandled_threats_button": "Close",
    "no_more_unhandled_threats_text": "You've reviewed all reported threats. Your inbox is now secure.",
    "no_more_unhandled_threats_title": "All clear!",
    "note_placeholder": "Add a note to the reporters...",
    "related_threats": "Related threats",
    "relative_time": {
      "days_ago": "{count} day ago | {count} days ago",
      "hours_ago": "{count} hour ago | {count} hours ago",
      "minutes_ago": "{count} minute ago | {count} minutes ago"
    },
    "report_information": "Report information",
    "reported_by": "Reported by: {name}",
    "reports": {
      "clicked_link_warning": "Clicked a link",
      "phishing": "Phishing",
      "reported_as_phishing": "Reported as phishing",
      "reported_as_spam": "Reported as spam",
      "reporter_note": "Reporter's note",
      "spam": "Spam"
    },
    "review_next_threat_button": "Review next threat",
    "review_next_threat_text": "Would you like to review the next unhandled threat?",
    "status_updated": "Status updated",
    "subject": "Subject",
    "this_threat_has_been_forwarded": "This threat has been forwarded to an external system. No analysis has been conducted.",
    "timeline": {
      "analysis_completed": "Analysis completed",
      "button": "Save",
      "status_transition": "Status transitioned from {from} to {to}",
      "textarea_placeholder": "Add a comment...",
      "title": "Activity"
    },
    "transition_description": "Confirm which reports receive this status.",
    "x_of_n_selected": "{x} of {n} selected"
  },
  "titles": {
    "automations": {
      "subtitle": "Automated training sequences",
      "title": "Automation"
    },
    "breaches": {
      "subtitle": "Discover the data breaches in your workspace.",
      "title": "Breaches"
    },
    "dashboard": {
      "subtitle": "Overview of your workspace.",
      "title": "Overview"
    },
    "group": {
      "subtitle": "One active group member. | {count} active group members."
    },
    "groups": {
      "subtitle": "Arrange your employees together into groups.",
      "title": "Groups"
    },
    "integrations": {
      "subtitle": "Overview of integrations",
      "title": "Integrations"
    },
    "resilience": {
      "subtitle": "Overview of your organisation's resilience.",
      "title": "Resilience"
    },
    "simulations": {
      "custom_templates": {
        "subtitle": "Overview of all your custom templates",
        "title": "Custom templates"
      },
      "subtitle": "Simulate phishing attacks on your team.",
      "title": "Simulations"
    },
    "team": {
      "subtitle": "All employees currently in your workspace.",
      "title": "Employees"
    },
    "threat": {
      "title": "Threat report"
    },
    "threats": {
      "subtitle": "Overview of all threats and their status",
      "title": "Threats"
    },
    "training": {
      "course": {
        "subtitle": "Overview of all courses",
        "title": "Courses"
      },
      "course_overview": {
        "title": "Course overview"
      },
      "deadlines": {
        "subtitle": "Overview of deadlines",
        "title": "Deadlines"
      },
      "participation": {
        "subtitle": "Overview of training participation",
        "title": "Participation overview"
      },
      "subtitle": "Overview of your organisation's training",
      "title": "Training",
      "video": {
        "subtitle": "Overview of all videos",
        "title": "Videos"
      },
      "video_overview": {
        "title": "Video overview"
      }
    }
  },
  "training": {
    "actions": {
      "edit": "Edit",
      "edit_categories": "Edit categories",
      "save": "Save"
    },
    "completed_status": {
      "completed": "Completed",
      "not_completed": "Not completed"
    },
    "courses": {
      "actions": {
        "collapse_all": "Collapse all",
        "delete_course": "Delete course",
        "edit": "Edit",
        "edit_categories": "Edit categories",
        "edit_course": "Edit course",
        "expand_all": "Expand all",
        "preview_course": "Preview course",
        "save": "Save"
      },
      "add_step": {
        "quiz": "Quiz content",
        "text": "Text content",
        "video": "Video content"
      },
      "create": {
        "button": "Create course"
      },
      "create_button": "Create course",
      "create_success": "Course created successfully",
      "create_title": "Create new course",
      "default_language_badge": "Default",
      "default_language_label": "Default language",
      "default_language_placeholder": "Select default language",
      "delete": {
        "are_you_sure": "Are you sure you want to delete this step? This action cannot be undone.",
        "course_are_you_sure": "Are you sure you want to delete this course? All mandatory training and points related to the course will also be deleted. This action cannot be undone.",
        "translation_are_you_sure": "Are you sure you want to delete this translation? This action cannot be undone."
      },
      "details": {
        "heading": "Details"
      },
      "edit_name_dialog": {
        "save": "Save title",
        "title": "Edit course title"
      },
      "errors": {
        "select_category": "Please select at least one category",
        "select_locale": "Please select at least one language"
      },
      "form": {
        "labels": {
          "categories": "Categories",
          "risk_categories": "Categories",
          "title": "Title"
        },
        "placeholders": {
          "categories": "Select categories",
          "title": "Enter title"
        }
      },
      "labels": {
        "categories": "Category | Categories",
        "no_categories": "No categories"
      },
      "language_card": {
        "add_language": "Add a language",
        "editing": "Editing",
        "select_language": "Select a language",
        "switch": "Switch",
        "translate_with_ai": "Translate with AI"
      },
      "navigation": {
        "course": "Course",
        "participants": "Participants"
      },
      "notifications": {
        "course_deleted": "Course deleted",
        "name_updated": "Course title updated",
        "saved": "Saved",
        "settings_saved": "Changes saved",
        "step_deleted": "Step deleted"
      },
      "preview": "Preview",
      "publish": "Publish course",
      "publish_confirm": "Yes, publish course",
      "publish_confirm_description": "Are you sure you want to publish this course? It will appear in the hub immediately.",
      "publish_success": "Course published",
      "quiz_editor": {
        "actions": {
          "cancel": "Cancel",
          "save": "Save"
        },
        "ai_prompt": {
          "button": "AI prompt",
          "generate": "Generate",
          "no_previous_steps": "Add a video or text step earlier in the course to use it as context.",
          "placeholder": "Custom instructions",
          "select_helper": "Select steps",
          "select_label": "Use existing content, a written prompt, or both to generate new questions.",
          "step_number": "Step {order}",
          "step_type": {
            "quiz": "Quiz",
            "text": "Text",
            "video": "Video"
          },
          "title": "Add questions using AI",
          "untitled": "Untitled"
        },
        "heading": {
          "description": "Quiz",
          "title": "Step {step}"
        },
        "select_action": {
          "ai": {
            "description": "Let AI automatically generate quiz questions from your existing content in this course.",
            "title": "AI generate from content"
          },
          "manual": {
            "description": "Build your own quiz from scratch by adding questions and answers manually.",
            "title": "Manually create quiz"
          }
        }
      },
      "select_languages_description": "Choose the languages you want to include in your course content.",
      "set_current_language_as_default": "Set as default",
      "settings": {
        "edit_description": "Edit course description",
        "save": "Save"
      },
      "status": {
        "draft": "Draft",
        "missing_content_warning": "Course is missing content in one or more languages",
        "published": "Published"
      },
      "steps": {
        "empty": {
          "description": "Click the edit button above to add content",
          "title": "Empty step"
        },
        "intro": "Introduction",
        "knowledge_check": "Knowledge check",
        "missing_translation": "Translation missing for this locale",
        "quiz": "Quiz",
        "text": "Text",
        "video": "Video"
      },
      "tabs": {
        "course": "Course",
        "participants": "Participants"
      },
      "text_editor": {
        "actions": {
          "cancel": "Cancel",
          "edit": "Edit",
          "save": "Save"
        },
        "ai_prompt": {
          "button": "Text editor AI button",
          "generate": "Generate",
          "label": "Describe what you would like the AI to do",
          "placeholder": "\"Help me make the text more formal\"",
          "title": "Generate text card with AI"
        },
        "ai_viewer": {
          "accept": "Accept",
          "back": "Cancel",
          "caption": "Review the AI-generated content and decide whether to accept or regenerate it",
          "generating": "Generating course content",
          "heading": "Review generated content"
        },
        "apply_image": {
          "button": "Apply to other languages",
          "has_image": "Has image",
          "subtitle": "Select languages to apply this image to",
          "title": "Apply image to other languages"
        },
        "course_title_badge": "Course title",
        "heading": {
          "description": "Text-editor",
          "title": "Step {step}"
        },
        "labels": {
          "after": "After",
          "before": "Before",
          "excerpt": "Excerpt",
          "image_upload": "Image",
          "remove_image": "Remove image",
          "title": "Title",
          "uploaded_image_alt": "Uploaded image"
        },
        "placeholders": {
          "content": "Enter your content",
          "excerpt": "Enter an excerpt",
          "title": "Enter a title"
        },
        "title_linked_tooltip": "Used as the title in the {language} version of the course."
      },
      "title_summary": {
        "course_title": "Course title",
        "description": "Used as the title in the {language} version of the course."
      },
      "translate": {
        "open": "Translate course",
        "submit": "Translate",
        "title": "Translate course"
      },
      "translate_success": "Course translated.",
      "translation_list_label": "Translation | Translations",
      "unpublish": "Unpublish course",
      "unpublish_confirm": "Yes, unpublish course",
      "unpublish_confirm_description": "Are you sure you want to unpublish this course? It will disappear from the hub immediately.",
      "unpublish_success": "Course unpublished",
      "untitled": "Untitled",
      "validation": {
        "content_missing_in_languages": "Content missing in one language | Content missing in {count} languages",
        "missing_content": "Missing content",
        "missing_excerpt": "Missing excerpt",
        "missing_image": "Missing image",
        "missing_questions": "Missing questions",
        "missing_title": "Missing title",
        "options_missing_text": "Some options are missing text",
        "questions_missing_correct_options": "Some questions are missing correct options",
        "questions_missing_text": "Some questions are missing text",
        "step_issues": "Step issues"
      },
      "video_editor": {
        "empty_search": {
          "description": "Try refining your keywords or clear the search to view all videos.",
          "title": "No videos match your search"
        },
        "empty_state": {
          "description": "This step is empty. Click the edit button above to add content."
        },
        "fallback_translation_tooltip": "This video uses a fallback translation",
        "search_placeholder": "Search videos",
        "selected": {
          "button": "Change video",
          "title": "VIDEO"
        },
        "subtitle": "Choose a video to add to this step.",
        "title": "Select video"
      }
    },
    "custom_uploads": {
      "subtitle": "Videos created by your organization",
      "title": "Custom uploads",
      "video": {
        "badges": {
          "quiz": "Quiz",
          "video": "Video"
        },
        "create": {
          "create_video": "Create video",
          "next_steps_text": "Fill out the information below to set up your video. After creating the video, you’ll be taken to the video page, where you can select this translation and upload a video file.",
          "video_created": "Video created"
        },
        "delete": {
          "are_you_sure": "Are you sure you want to delete this video? This action cannot be undone.",
          "button": "Delete",
          "video_deleted": "Video deleted"
        },
        "form": {
          "labels": {
            "categories": "Categories",
            "description": "Description",
            "language": "Language",
            "title": "Title"
          },
          "placeholders": {
            "categories": "Select categories",
            "description": "Enter a description",
            "language": "Select language",
            "title": "Enter a title"
          }
        },
        "publish": "Publish",
        "publish_confirm": "Publish",
        "publish_confirm_description": "Publishing makes this video available in the hub and usable across the platform.",
        "publish_success": "Video published",
        "publish_unavailable": "Upload videos for all translations before publishing.",
        "quiz": {
          "available_quizzes": "Available quizzes",
          "create": "Create",
          "edit": "Edit",
          "quiz_deleted": "Quiz deleted",
          "quiz_saved": "Quiz saved",
          "quizzes": "Quizzes",
          "quizzes_translated": "Quizzes translated."
        },
        "single": {
          "details": {
            "heading": "Details",
            "text": "Video details"
          },
          "labels": {
            "categories": "Category | Categories",
            "created_at": "Created at",
            "published_at": "Published at",
            "updated_at": "Updated at"
          },
          "title": "Custom video"
        },
        "status": {
          "draft": "Draft",
          "published": "Published"
        },
        "translations": {
          "add_translation": "Add translation",
          "ai": {
            "done_translate_button": "Done",
            "processing_n_languages": "Processing one language | Processing {count} languages",
            "text": "Use DeepL to automatically translate the video’s title and description into a selected language.",
            "title": "Translate video details with AI",
            "translate_button": "Translate",
            "translating_your_video": "Translating video details",
            "video_now_available_in": "Translations have been created in one additional language | Translations have been created in {count} additional languages",
            "video_translate_success": "Success!"
          },
          "available_translations": "Available translations",
          "create_title": "Add translation",
          "default_badge": "Default",
          "delete": "Delete",
          "delete_are_you_sure": "Are you sure you want to delete this translation? This action cannot be undone.",
          "edit": "Edit",
          "edit_translation": "Edit translation",
          "empty": "No translations for this video",
          "make_default": "Set as default",
          "manual": {
            "text": "Rewrite the translation from scratch in a new language.",
            "title": "Manually translate video"
          },
          "quiz": {
            "create": "Create quiz",
            "edit": "Edit quiz",
            "other_translations_have_quizzes": "Other translations have quizzes",
            "other_translations_have_quizzes_want_to_translate": "Other translations already have quizzes. Do you want to automatically translate this quiz into those languages?",
            "some_translations_have_no_quizzes": "Some translations currently have no quizzes. Translate now?",
            "this_translation_has_quizzes_in_other_languages_translate_automatically": "This translation has quizzes in other languages. Translate automatically?",
            "translate_quiz": "Translate",
            "update_this_quiz_and_translate_others": "Update this quiz and translate other quizzes",
            "update_this_quiz_only": "Update this quiz only"
          },
          "save_changes": "Save changes",
          "single": {
            "edit": {
              "subtitle": "Update the video details",
              "title": "Video details"
            },
            "upload": {
              "subtitle": "Upload video file for this translation.",
              "title": "Upload video",
              "video_deleted": "Video deleted",
              "video_uploaded": "Video uploaded"
            }
          },
          "translation_added": "Translation added",
          "translation_deleted": "Translation deleted",
          "translation_updated": "Translation updated",
          "translations": "Translations",
          "video": "Video"
        },
        "unpublish": "Unpublish",
        "unpublish_confirm": "Unpublish",
        "unpublish_confirm_description": "Unpublishing will hide this video from the hub. It will still be available in any automations where it’s already used.",
        "unpublish_success": "Video unpublished"
      }
    },
    "deadlines": {
      "bulk_reminder_dialog_confirm": "Send {count} reminder | Send {count} reminders",
      "bulk_reminder_dialog_text": "This will notify {count} employees. Each employee will receive one notification, even if they have multiple assignments.",
      "bulk_reminder_dialog_title": "Send reminders to everyone matching your selected filters",
      "bulk_reminders_sent": "Reminders sent",
      "delete_reminder": "Delete reminder",
      "participation_title": "Participation",
      "reminder_deleted": "Reminder deleted",
      "reminder_sent": "Reminder sent",
      "send_bulk_reminder": "Send reminders to all",
      "send_reminder": "Send reminder"
    },
    "default_language_updated": "Default language updated",
    "default_translation_tooltip": "This is currently the default language. Please choose a different language before deleting it.",
    "errors": {
      "select_category": "Please select at least one category"
    },
    "filter": {
      "course": "Only show courses",
      "video": "Only show videos"
    },
    "form": {
      "labels": {
        "categories": "Categories",
        "no_categories": "No categories"
      },
      "placeholders": {
        "categories": "Select categories"
      }
    },
    "invited_status": {
      "invited": "Invited",
      "not_invited": "Not invited"
    },
    "moxso_courses": {
      "description": "Courses provided by Moxso",
      "title": "Moxso courses"
    },
    "moxso_uploads": {
      "subtitle": "Videos provided by Moxso",
      "title": "Moxso videos"
    },
    "quiz": "Quiz",
    "search_courses": {
      "description": "Search results matching your query",
      "title": "Search results"
    },
    "type": {
      "course": "Course",
      "user_course": "User course",
      "video": "Video"
    },
    "user_defined_courses": {
      "description": "Courses created by your organization",
      "title": "User-defined courses"
    }
  },
  "translations": {
    "ai": {
      "overwrite_existing_translations_text": "This will delete the existing translations and translate them from scratch",
      "overwrite_existing_translations_title": "Overwrite existing translations",
      "select_languages_to_translate_item_into": "Select the languages you want to generate translations for",
      "translate_from": "Translate from"
    },
    "deepl_privacy": "DeepL's privacy policy",
    "deepl_text": "This will send a copy of your translation to DeepL, an external AI-powered translation service. Your content will be processed externally, and {link} will apply.",
    "quizzes": {
      "done_translate_button": "Done",
      "processing_n_languages": "Processing one language | Processing {count} languages",
      "quiz_now_available_in": "Your quiz is now available in one additional language | Your quiz is now available in {count} additional languages",
      "quiz_translate_success": "Success!",
      "select_the_languages_you_want_to_translate_your_quiz_into": "Select the languages you want to translate your quiz into",
      "translate_button": "Translate",
      "translate_from": "Translate from",
      "translate_multiple_choice_quiz": "Translate multiple choice quiz",
      "translating_your_quiz": "Translating your quiz"
    }
  },
  "two_factor_challenge": {
    "back_to_login": "Back to login",
    "code": {
      "label": "Authentication code",
      "placeholder": "123456"
    },
    "heading": "Two-factor authentication",
    "recovery_code": {
      "label": "Recovery code",
      "placeholder": "aaaaaaaaaa-bbbbbbbbbb"
    },
    "submit": "Verify",
    "text": "Enter a code from your authenticator app or use a recovery code to continue.",
    "use_authenticator_code": "Use an authenticator code",
    "use_recovery_code": "Use a recovery code"
  },
  "uploads": {
    "file_upload": {
      "click_to_upload": "Click to upload",
      "delete": {
        "are_you_sure": "Are you sure you want to delete this file? This action cannot be undone.",
        "button": "Delete"
      },
      "file_upload_limit": "{fileType} · Up to {fileSize} · {imageRatio} recommended",
      "or_drag_and_drop": "{click} or drag and drop",
      "placeholder": "file",
      "title": "Upload file",
      "up_to": "Up to",
      "upload_failed": {
        "button": "Upload new",
        "subtitle": "The file provided failed to upload.",
        "title": "Upload failed"
      },
      "upload_in_progress": {
        "processing_subtitle": "Upload complete. You can safely leave this page while we process it.",
        "processing_title": "Processing your file...",
        "uploading_subtitle": "Your file is being uploaded.",
        "uploading_title": "Uploading file..."
      }
    },
    "image_upload": {
      "click_to_upload": "Click to upload",
      "delete": {
        "are_you_sure": "Are you sure you want to delete this image? This action cannot be undone.",
        "button": "Delete"
      },
      "or_drag_and_drop": "or drag and drop",
      "upload_failed": {
        "button": "Upload new",
        "subtitle": "The file provided failed to upload.",
        "title": "Upload failed"
      },
      "upload_in_progress": {
        "processing_subtitle": "Upload complete. You can safely leave this page while we process it.",
        "processing_title": "Processing your file...",
        "uploading_subtitle": "Your file is being uploaded.",
        "uploading_title": "Uploading file..."
      }
    },
    "video_upload": {
      "click_to_upload": "Click to upload",
      "delete": {
        "are_you_sure": "Are you sure you want to delete this video? This action cannot be undone.",
        "button": "Delete"
      },
      "format": "MP4",
      "max": "Max",
      "or_drag_and_drop": "or drag and drop",
      "up_to": "Up to",
      "upload_failed": {
        "button": "Upload new",
        "subtitle": "The file provided failed to upload.",
        "title": "Upload failed"
      },
      "upload_in_progress": {
        "processing_subtitle": "Upload complete. You can safely leave this page while we process it.",
        "processing_title": "Processing your file...",
        "uploading_title": "Uploading file..."
      }
    }
  },
  "upsell": {
    "click_to_open": "Click to learn more",
    "contact": "Notify Customer Success",
    "knowledge_base": "Knowledge base",
    "learn_more": "Learn more",
    "locked_feature": "Locked feature",
    "notify_success": "Notification sent to customer success",
    "upgrade_required": "This feature requires an upgrade"
  },
  "user_settings": {
    "subtitle": "Manage security settings for your admin account.",
    "title": "Security and access"
  },
  "validate_domain": {
    "login": "Sign in",
    "success": "The domain has successfully been verified."
  },
  "videos": {
    "error": "Streaming is currently unavailable"
  },
  "workspace_onboarding": {
    "invite_admins": {
      "form": {
        "button": "Invite admin",
        "description": "Add additional admins if someone else should help own the setup or manage Moxso",
        "title": "Invite another admin"
      },
      "header": {
        "description": "Decide who should have admin access from the start. If more than one person will manage cybersecurity or Moxso, invite them now so setup and ownership are shared from day one.",
        "title": "Invite admins"
      },
      "intro": {
        "admin_added": "You already have more than one admin in this workspace.",
        "description": "A single admin can work well for smaller teams, while multiple admins can make handover and collaboration easier.",
        "eyebrow": "Recommended before launch",
        "recommendation": "Choose the setup that fits your team and invite additional admins if ownership is shared.",
        "title": "Share admin access"
      },
      "list": {
        "added_on": "Added on",
        "description": "Review the admins who currently have access to this workspace.",
        "title": "Workspace admins",
        "you": "You"
      }
    },
    "kick_off": {
      "complete": "Schedule kickoff",
      "dates": {
        "description": "Plan your kickoff dates",
        "locked": "Locked",
        "locked_description": "Complete the requirements above to unlock scheduling.",
        "simulation": {
          "custom_date": "Custom date",
          "custom_date_description": "Choose a specific day",
          "label": "Simulation kickoff date",
          "one_week_before": "1 week before training",
          "recommended": "Recommended"
        },
        "title": "Kickoff dates",
        "training": {
          "description": "Employees receive their first training module on this day.",
          "label": "Training kickoff date",
          "placeholder": "Pick a date"
        }
      },
      "header": {
        "description": "Pick the day your employees start their awareness training. A baseline phishing simulation runs beforehand to measure where you’re starting from.",
        "title": "Schedule kickoff"
      },
      "validation": {
        "description": "Complete these before you can schedule training.",
        "requirements_count": "{count} of {total} completed",
        "set_up": "Set up",
        "title": "Kickoff validation"
      }
    },
    "microsoft_manual_setup": {
      "junk": {
        "button": "How to bypass junk filters",
        "heading": "Bypass Junk Filter",
        "text": "This guide provides step-by-step instructions for allowing Moxso emails to bypass junk filters."
      },
      "safe_links": {
        "button": "How to bypass Safe Links",
        "heading": "Bypass Safe Links",
        "text": "This guide provides step-by-step instructions for allowing Moxso emails to bypass Safe Links."
      },
      "spam": {
        "button": "How to bypass spam filters",
        "heading": "Bypass spam Filter",
        "text": "This guide provides step-by-step instructions for allowing Moxso emails to bypass spam filters."
      },
      "tenant_allow_block": {
        "button": "How to allowlist Moxso by IP in Outlook",
        "heading": "Add Moxso IPs to Tenant Allow/Block Lists",
        "text": "This guide provides step-by-step instructions for adding Moxso IP addresses to the Tenant Allow/Block Lists in Microsoft Defender to ensure proper email delivery."
      },
      "third_party": {
        "button": "How to Add Moxso IPs & Domains to Microsoft Defender",
        "heading": "Add Moxso's IPs and domains to Microsoft Defender",
        "text": "This guide provides step-by-step instructions for adding Moxso's IPs and domains to the Third-Party Phishing Simulation settings in Microsoft Defender to ensure proper email testing and delivery."
      }
    },
    "onboarding_actions": {
      "back": "Back",
      "continue": "Continue",
      "knowledge_base": "Knowledge base",
      "mark_as_completed": "Mark as completed",
      "skip": "Set up later"
    },
    "progress_badge": {
      "kick_off_planned": "Kick off planned",
      "simulation_date": "Simulation start date",
      "training_start": "Training start date",
      "workspace_setup": "Workspace Setup:"
    },
    "reporting_add_in": {
      "confirm_setup": {
        "description": "If the Moxso plugin is available in your company’s mailboxes, employees can start using it to report suspicious emails directly from their inbox.",
        "manage_later": "See how reporting works in {link}.",
        "subtitle": "Complete the guide for your email provider, then continue when the add-in has been deployed.",
        "this_guide": "this guide",
        "title": "Is the Moxso plugin visible in your mailbox?"
      },
      "continue_disabled_tooltip_text": "Select an email provider to continue.",
      "follow_guide": {
        "gmail": "Gmail",
        "outlook": "Outlook",
        "title": "Follow the guide below"
      },
      "guide_picker": {
        "gmail": {
          "description": "Step-by-step guide to set up the reporting add-in in Gmail.",
          "title": "Gmail"
        },
        "outlook": {
          "description": "Step-by-step guide to set up the reporting add-in in Outlook.",
          "title": "Outlook"
        },
        "title": "Select your email provider"
      },
      "header": {
        "description": "Set up the Moxso reporting add-in so employees can quickly report suspicious emails directly from their inbox as part of their normal email workflow.",
        "title": "Set up reporting add-in"
      }
    },
    "setup_provider": {
      "add_simulation": {
        "button": "Create simulation draft",
        "continue_disabled_tooltip_text": "Setup a phishing simulation campaign to continue",
        "description": "We have set up a phishing simulation campaign based on your company profile. This campaign will act as a baseline to help you identify areas of improvement.",
        "description_cta": "Click the button below to create a the simulation",
        "header": {
          "description": "Setup a phishing simulation campaign to sends ongoing, realistic emails to help employees practice spotting threats. You can adjust the campaign settings and audience after the campaign has started running.",
          "title": "Setup your first phishing simulation"
        },
        "settings_card": {
          "Audience": "Audience",
          "Credential harvest": "Credential harvest",
          "Delivery rate": "Delivery rate",
          "Name": "Name",
          "all_employees": "All employees",
          "baseline_campaign": "Baseline campaign",
          "credential_harvest": "Enabled",
          "delivery_rate": "Medium"
        },
        "simulation_created": "Simulation draft created",
        "subtitle": "Ready to launch",
        "title": "Recommended settings"
      },
      "buttons": {
        "back": "Back",
        "continue": "Continue"
      },
      "header": {
        "description": "Set up an integration to automatically sync your employee data with the system. This keeps employee details updated and removes the need for manual updates.",
        "title": "Configure integrations"
      },
      "integration": {
        "header": {
          "description": "Select if you’d like to integrate with your HR database (identity provider) or instead to import your employees manually through a CSV file. We do not recommend the manual option as that will not allow the system to automatically sync and update over time (keeping track of new or inactive users).",
          "title": "Sync employees"
        },
        "warning": "An admin account with global permissions is required to set up Microsoft Entra ID or Google Workspace sync."
      },
      "provider": {
        "csv_import": "CSV Import",
        "description": "Select the platform you use to manage identities and employees.",
        "employees": "Employees",
        "google": "Google",
        "google_sync": "Google Sync",
        "microsoft": "Microsoft",
        "microsoft_sync": "Microsoft Entra ID",
        "okta": "Okta",
        "title": "Choose your provider"
      },
      "recommendations": {
        "create_target_group": {
          "description": "Create a group with the employees you want to target to easily assign simulations and training by selecting the group directly.",
          "title": "Create target group"
        },
        "heading": {
          "description": "Follow these steps before importing employees to ensure the correct data is synced. While not mandatory, this will save you time later on.",
          "title": "Prepare for integration"
        },
        "verify_language_settings": {
          "description": "Make sure employees’ language settings are correct so the right language is synced to Moxso.",
          "title": "Verify language settings"
        },
        "warning": "Make sure new employees are always added to the groups synced with Moxso."
      },
      "saml_scim": {
        "header": {
          "description": "Configure single sign-on and automatic user provisioning. Complete both sections below, then continue when your identity provider is connected.",
          "title": "Set up SAML & SCIM"
        }
      },
      "setup_method": {
        "header": {
          "description": "Use SAML and SCIM for secure sign-in and automatic provisioning, or connect a provider using the standard integration.",
          "title": "Choose your setup"
        },
        "provider_integration": {
          "description": "Sync employees directly from Microsoft Entra ID, Google Workspace, Slack, or a CSV file.",
          "title": "Standard integration"
        },
        "recommended": "Recommended",
        "saml_scim": {
          "description": "Enable single sign-on and automate user provisioning.",
          "title": "SAML & SCIM"
        }
      },
      "whitelisting": {
        "buttons": {
          "change_guides": "Change guide",
          "confirm_whitelist": "Confirm allowlist",
          "manual": "Manual",
          "test_whitelist": "Test allowlist"
        },
        "continue_disabled_tooltip_text": "Please confirm that the allowlisting worked before continuing.",
        "follow_guide": {
          "gmail": "Gmail",
          "outlook": "Outlook",
          "title": "Follow the guide below"
        },
        "guide_picker": {
          "gmail": {
            "description": "Step-by-step guide to let emails through in Gmail.",
            "title": "Gmail"
          },
          "outlook": {
            "description": "Step-by-step guide to let emails through in Outlook.",
            "title": "Outlook"
          },
          "title": "Select your email provider"
        },
        "header": {
          "description": "Set up allowlisting of our IP addresses and domains to ensure that phishing simulations are delivered to employee inboxes and aren’t blocked by spam filters.",
          "title": "Ensure messages are not flagged as spam"
        },
        "send_test": {
          "buttons": {
            "no": "No, help me",
            "send_test": "Send test email",
            "yes": "Yes, recieved it"
          },
          "confirm": {
            "text": "Check your inbox (and spam folder).",
            "title": "Did you receive the email | Did you receive the emails"
          },
          "description": "Send a test email to confirm that it is delivered to your inbox at {email} (not the spam folder). {try_a_few_times}, each email uses different content and domains.",
          "subtitle": "Send test email",
          "success": {
            "text": "Your configuration is correct. You can now continue on to the next step.",
            "title": "Allowlisting is working"
          },
          "title": "Confirm that allowlisting works",
          "try_a_few_times": "Try a few times"
        }
      }
    },
    "simulation": {
      "targeting": {
        "add_services": "Add services",
        "ceo": "CEO contact details",
        "cfo": "CFO contact details",
        "content_description": "Add executive contacts and your services for more realistic simulations.",
        "content_title": "Personalize your simulations",
        "cto": "CTO contact details",
        "description": "Configure realistic targeting for your organization.",
        "edit_services": "Edit services",
        "no_services": "No services selected",
        "services": "Services",
        "services_title": "Select services",
        "title": "Set up simulations"
      }
    },
    "steps": {
      "add_simulation": "Simulations",
      "invite_admins": "Admins",
      "kick_off": "Kick off",
      "reporting_add_in": "Reporting add-in",
      "setup_provider": "Integrations",
      "training": "Training",
      "verify_domains": "Domains",
      "welcome": "Welcome",
      "whitelisting": "Allowlisting"
    },
    "training": {
      "header": {
        "description": "Choose whether Moxso assigns training automatically or you schedule it yourself, then tailor the setup to your organization.",
        "title": "Set up training"
      },
      "mode": {
        "continue_disabled": "Choose a training approach to continue.",
        "description": "Select one approach to finish this step.",
        "title": "Choose how training runs"
      }
    },
    "verify_domains": {
      "buttons": {
        "add": "Add",
        "resend": "Resend",
        "verify": "Verify"
      },
      "continue_disabled_tooltip_text": "Please verify at least one domain before continuing",
      "domain_placeholder": "company.com",
      "empty": {
        "subtitle": "Add your company domains above to continue",
        "title": "No domains added yet"
      },
      "heading": {
        "description": "Please add all company domains used in employee email addresses to import your employees. A verification email will be sent to {email} to confirm each domain.",
        "title": "Confirm your domains"
      },
      "labels": {
        "add_domain": "Add domain",
        "not_verified": "Not verified",
        "verification_pending": "Verification pending",
        "verified": "Verified",
        "verified_on": "Verified on: {date}"
      },
      "verification_email_sent": "Verification email sent",
      "your_domains": "Your domains"
    },
    "welcome": {
      "connect_provider": {
        "description": "Prepare for Integration & Sync employees",
        "title": "Configure integrations"
      },
      "description": "You may already be familiar with the steps below, but we’ll now make sure all of them are completed so that you can go live. Any test data you may have previously created has now been removed.",
      "get_started": "Get started",
      "invite_admins": {
        "description": "Decide whether others should help manage setup and ongoing admin work.",
        "title": "Invite admins"
      },
      "launch_phishing_simulation": {
        "description": "Create a baseline simulation and configure CEO fraud and software targeting.",
        "title": "Simulations"
      },
      "reporting_add_in": {
        "description": "Add the Moxso report button to employee inboxes.",
        "title": "Set up reporting add-in"
      },
      "subtitle": "Welcome to Moxso",
      "title": "Let’s get you ready to launch.",
      "training": {
        "description": "Choose a training mode and the frameworks that matter to your organization.",
        "title": "Training"
      },
      "verify_domains": {
        "description": "Verify the domains you want to use with Moxso.",
        "title": "Verify domains"
      },
      "whitelist_email": {
        "description": "Ensure messages are not flagged as spam.",
        "title": "Set up Allowlisting"
      }
    }
  },
  "workspace_report": {
    "assignments": "Assignments",
    "avg_score": "Avg score",
    "compared_against": "Compared against {period}",
    "department": "Department",
    "employee": "Employee",
    "employees_at_risk": "Employees at risk",
    "generated": "Generated {date}",
    "group": "Group",
    "group_breakdown": "Group breakdown",
    "group_breakdown_description": "Aggregated signals, assignments, and interventions by group",
    "group_breakdown_description_without_hri": "Aggregated assignments by group",
    "group_breakdown_note": "Avg score is employee-weighted across each group. The signals bar splits activity into negative, neutral, and positive sentiment.",
    "group_breakdown_note_without_hri": "Avg score is employee-weighted across each group.",
    "hri_summary": "Workspace HRI summary",
    "human_risk_intelligence": "Human Risk Intelligence",
    "interventions": "Interventions",
    "interventions_by_type": "Interventions by type",
    "last_six_months": "Last 6 months",
    "loading": "Loading workspace report…",
    "missed": "Missed",
    "no_employees_at_risk": "No employees at risk",
    "no_groups": "No group data available",
    "no_risk_indicators": "No risk indicators",
    "operational_metrics": "Operational metrics",
    "performance_by_team": "Performance by team",
    "resilience_score": "Resilience score",
    "risk_index": "Risk index {value}/10 · lower is better",
    "risk_indicator": "Risk indicator",
    "risk_level": "Risk level",
    "risk_levels": {
      "high": "High",
      "low": "Low",
      "moderate": "Moderate"
    },
    "security_behaviour_overview": "Security behaviour overview",
    "signals": "Signals",
    "signals_by_sentiment": "Signals by sentiment",
    "signals_by_severity": "Signals by severity",
    "threshold": "Threshold {value}% · sorted low to high",
    "title": "Workspace report",
    "top_five_period": "Top 5 this period",
    "total": "{count} total",
    "total_employees": "{count} total employees",
    "total_groups": "{count} groups",
    "total_signals": "{count} signals",
    "training": "Training metrics",
    "training_simulations_risk": "Training, simulations & risk",
    "trend": "Trend",
    "trend_title": "Resilience, click & report rate",
    "trending_risk_indicators": "Trending risk indicators",
    "unavailable": "Report unavailable",
    "unavailable_description": "The report could not be loaded. Check that the report URL is valid and has not expired.",
    "workspace_summary": "Workspace summary"
  }
}
